import { SlideObject, SlideTypes } from "../../SlideObjects/SlideStructures";

export const LowerCase = ({ ...props }) => {
  return (
    <svg
      className={props.className ? props.className : ""}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2 5L14 5" stroke="#585858" strokeLinecap="round" />
      <path d="M7.98242 21.0117V5.01172" stroke="#585858" strokeLinecap="round" />
      <path
        d="M16.6464 19.3536C16.8417 19.5488 17.1583 19.5488 17.3536 19.3536L20.5355 16.1716C20.7308 15.9763 20.7308 15.6597 20.5355 15.4645C20.3403 15.2692 20.0237 15.2692 19.8284 15.4645L17 18.2929L14.1716 15.4645C13.9763 15.2692 13.6597 15.2692 13.4645 15.4645C13.2692 15.6597 13.2692 15.9763 13.4645 16.1716L16.6464 19.3536ZM17.5 10C17.5 9.72386 17.2761 9.5 17 9.5C16.7239 9.5 16.5 9.72386 16.5 10L17.5 10ZM17.5 19L17.5 10L16.5 10L16.5 19L17.5 19Z"
        fill="#585858"
      />
    </svg>
  );
};

export const UpperCase = ({ ...props }) => {
  return (
    <>
      <svg
        className={props.className ? props.className : ""}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M2 5L14 5" stroke="#585858" strokeLinecap="round" />
        <path d="M7.98242 21.0117V5.01172" stroke="#585858" strokeLinecap="round" />
        <path
          d="M16.5 19C16.5 19.2761 16.7239 19.5 17 19.5C17.2761 19.5 17.5 19.2761 17.5 19L16.5 19ZM17.3536 9.64645C17.1583 9.45118 16.8417 9.45118 16.6464 9.64645L13.4645 12.8284C13.2692 13.0237 13.2692 13.3403 13.4645 13.5355C13.6597 13.7308 13.9763 13.7308 14.1716 13.5355L17 10.7071L19.8284 13.5355C20.0237 13.7308 20.3403 13.7308 20.5355 13.5355C20.7308 13.3403 20.7308 13.0237 20.5355 12.8284L17.3536 9.64645ZM17.5 19L17.5 10L16.5 10L16.5 19L17.5 19Z"
          fill="#585858"
        />
      </svg>
    </>
  );
};

export const TitleCase = ({ ...props }) => {
  return (
    <>
      <svg
        className={props.className ? props.className : ""}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M2 5L14 5" stroke="#585858" strokeLinecap="round" />
        <path d="M13 10L21 10" stroke="#585858" strokeLinecap="round" />
        <path d="M7.98242 21.0117V5.01172" stroke="#585858" strokeLinecap="round" />
        <path d="M17 19L17 10" stroke="#585858" strokeLinecap="round" />
      </svg>
    </>
  );
};

export const SuperScript = ({ ...props }) => {
  return (
    <>
      <svg
        className={props.className ? props.className : ""}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M2.5 20.3525L15.2279 7.62462" stroke="#585858" strokeLinecap="round" />
        <path d="M15.2285 20.3525L2.50059 7.62462" stroke="#585858" strokeLinecap="round" />
        <path
          d="M17.502 4.12498C18.0515 3.57545 19.2051 3.47891 20.1329 3.50344C20.9265 3.52442 21.502 4.2069 21.502 5.00085C21.502 5.89783 20.7748 6.62498 19.8778 6.62498H19.502C18.3974 6.62498 17.502 7.52041 17.502 8.62498V9.12498C17.502 9.40112 17.7258 9.62498 18.002 9.62498H21.502"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const SubScript = ({ ...props }) => {
  return (
    <>
      <svg
        className={props.className ? props.className : ""}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M2.5 20.3525L15.2279 7.62462" stroke="#585858" strokeLinecap="round" />
        <path d="M15.2285 20.3525L2.50059 7.62462" stroke="#585858" strokeLinecap="round" />
        <path
          d="M17.502 17.625C18.0515 17.0754 19.2051 16.9789 20.1329 17.0034C20.9265 17.0244 21.502 17.7069 21.502 18.5008C21.502 19.3978 20.7748 20.125 19.8778 20.125H19.502C18.3974 20.125 17.502 21.0204 17.502 22.125V22.625C17.502 22.9011 17.7258 23.125 18.002 23.125H21.502"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const OnUploladDragCursor = ({ ...props }) => {
  return (
    <svg
      width="71"
      height="103"
      viewBox="0 0 71 103"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_280_91793)">
        <path
          d="M27.729 38.3125C28.7509 38.3125 29.7627 38.1112 30.7068 37.7202C31.6508 37.3291 32.5086 36.756 33.2312 36.0334C33.9537 35.3109 34.5269 34.4531 34.9179 33.509C35.309 32.5649 35.5103 31.5531 35.5103 30.5312C35.5103 29.5094 35.309 28.4976 34.9179 27.5535C34.5269 26.6094 33.9537 25.7516 33.2312 25.0291C32.5086 24.3065 31.6508 23.7334 30.7068 23.3423C29.7627 22.9513 28.7509 22.75 27.729 22.75C25.6653 22.75 23.6861 23.5698 22.2268 25.0291C20.7676 26.4883 19.9478 28.4675 19.9478 30.5312C19.9478 32.595 20.7676 34.5742 22.2268 36.0334C23.6861 37.4927 25.6653 38.3125 27.729 38.3125Z"
          fill="#80D7FE"
        />
        <path
          d="M66.625 74.625C66.625 77.3766 65.5319 80.0155 63.5862 81.9612C61.6405 83.9069 59.0016 85 56.25 85H14.75C11.9984 85 9.35946 83.9069 7.41377 81.9612C5.46808 80.0155 4.375 77.3766 4.375 74.625V12.375C4.375 9.62338 5.46808 6.98446 7.41377 5.03877C9.35946 3.09308 11.9984 2 14.75 2L43.2812 2L66.625 25.3438V74.625ZM14.75 7.1875C13.3742 7.1875 12.0547 7.73404 11.0819 8.70688C10.109 9.67973 9.5625 10.9992 9.5625 12.375V64.25L21.0995 52.713C21.5084 52.3051 22.0416 52.0454 22.6149 51.9749C23.1881 51.9044 23.7684 52.0272 24.2639 52.3239L35.5 59.0625L46.6894 43.3963C46.9084 43.0901 47.1913 42.8352 47.5187 42.6493C47.846 42.4635 48.2099 42.3511 48.585 42.32C48.9601 42.2889 49.3376 42.3399 49.691 42.4693C50.0445 42.5987 50.3656 42.8035 50.6319 43.0694L61.4375 53.875V25.3438H51.0625C48.9988 25.3438 47.0196 24.5239 45.5603 23.0647C44.1011 21.6054 43.2812 19.6262 43.2812 17.5625V7.1875H14.75Z"
          fill="#80D7FE"
        />
      </g>
      <path
        d="M31 82L31.1438 102L36.9983 95.2503L46 94.5435L31 82Z"
        fill="white"
        stroke="#01AFFD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_d_280_91793"
          x="0.375"
          y="0"
          width="70.25"
          height="91"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_280_91793" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_280_91793"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
export const IconX = ({ ...props }) => {
  return (
    <svg
      style={{ cursor: "pointer" }}
      onClick={props.onClick}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6L6 18M6 6L18 18"
        stroke="#979797"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const UploadCloud = ({ ...props }) => {
  return (
    <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M32.5 32L24.5 24L16.5 32"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.5 24V42"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.28 36.78C43.2307 35.7165 44.7717 34.0338 45.6598 31.9973C46.5479 29.9607 46.7325 27.6865 46.1845 25.5334C45.6364 23.3803 44.387 21.471 42.6334 20.1069C40.8797 18.7428 38.7218 18.0015 36.5 18H33.98C33.3747 15.6585 32.2464 13.4847 30.6799 11.642C29.1135 9.7993 27.1497 8.3357 24.9362 7.36121C22.7227 6.38673 20.3171 5.92672 17.9003 6.01576C15.4834 6.10481 13.1182 6.7406 10.9824 7.87533C8.84662 9.01006 6.99586 10.6142 5.56929 12.5672C4.14271 14.5201 3.17742 16.7711 2.746 19.1508C2.31458 21.5305 2.42825 23.9771 3.07847 26.3065C3.72869 28.636 4.89853 30.7877 6.50004 32.6"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.5 32L24.5 24L16.5 32"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Edit3 = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 3.99998H4C3.46957 3.99998 2.96086 4.2107 2.58579 4.58577C2.21071 4.96084 2 5.46955 2 5.99998V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13M18.5 2.49998C18.8978 2.10216 19.4374 1.87866 20 1.87866C20.5626 1.87866 21.1022 2.10216 21.5 2.49998C21.8978 2.89781 22.1213 3.43737 22.1213 3.99998C22.1213 4.56259 21.8978 5.10216 21.5 5.49998L12 15L8 16L9 12L18.5 2.49998Z"
        stroke={"currentColor"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PageCounterIcon = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 15H4C3.46957 15 2.96086 14.7893 2.58579 14.4142C2.21071 14.0391 2 13.5304 2 13V4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H13C13.5304 2 14.0391 2.21071 14.4142 2.58579C14.7893 2.96086 15 3.46957 15 4V5M11 9H20C21.1046 9 22 9.89543 22 11V20C22 21.1046 21.1046 22 20 22H11C9.89543 22 9 21.1046 9 20V11C9 9.89543 9.89543 9 11 9Z"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FooterIcon = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V19C1 19.5304 1.21071 20.0391 1.58579 20.4142C1.96086 20.7893 2.46957 21 3 21H15C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V7M11 1L17 7M11 1V7H17M6 14H12"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RotateWithArrow = ({ ...props }) => {
  return (
    <div>
      <svg
        width="24"
        height="24"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_270_91812)">
          <circle
            cx="17.3559"
            cy="17.4541"
            r="12"
            transform="rotate(-20 17.3559 17.4541)"
            fill="white"
          />
          <circle
            cx="17.3559"
            cy="17.4541"
            r="11.5"
            transform="rotate(-20 17.3559 17.4541)"
            stroke="white"
          />
        </g>
        <g clipPath="url(#clip0_270_91812)">
          <path
            d="M9.73009 15.2635L10.9272 18.5524M10.9272 18.5524L14.2161 17.3554M10.9272 18.5524L12.6007 15.2367C13.0826 14.2056 13.8866 13.3589 14.8915 12.8244C15.8965 12.2899 17.0479 12.0964 18.1723 12.2732C19.2967 12.45 20.3332 12.9874 21.1257 13.8045C21.9181 14.6215 22.4235 15.674 22.5658 16.8033C22.7081 17.9326 22.4794 19.0776 21.9144 20.0657C21.3494 21.0538 20.4785 21.8315 19.4331 22.2816C18.3876 22.7317 17.2242 22.8298 16.1181 22.5612C15.012 22.2927 14.0232 21.6719 13.3006 20.7924"
            stroke="#D4D5DE"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_270_91812"
            x="0.3526"
            y="0.450806"
            width="34.0065"
            height="34.0065"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="2.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_270_91812" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_270_91812"
              result="shape"
            />
          </filter>
          <clipPath id="clip0_270_91812">
            <rect
              width="14"
              height="14"
              fill="white"
              transform="translate(8.38388 13.2704) rotate(0)"
            />
          </clipPath>
        </defs>
      </svg>
      <svg
        style={{ position: "absolute", top: "0", left: "0", transform: "rotate(20deg)" }}
        width="24"
        height="24"
        viewBox="0 0 32 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.3833 17.469L7.38736 22.9751L12.8119 21.0007"
          stroke="#01AFFD"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.0565 9.94458L28.0606 15.4507L22.636 17.4251"
          stroke="#01AFFD"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.41576 22.7385C6.28505 23.2751 6.61409 23.816 7.15068 23.9467C7.68727 24.0774 8.22823 23.7484 8.35894 23.2118L6.41576 22.7385ZM27.5405 16.3048C28.0122 16.592 28.6274 16.4425 28.9147 15.9708C29.2019 15.4991 29.0524 14.8839 28.5807 14.5966L27.5405 16.3048ZM8.35894 23.2118C9.0356 20.4339 10.8201 16.829 13.8755 14.8677C16.8242 12.9748 21.2155 12.4531 27.5405 16.3048L28.5807 14.5966C21.7803 10.4554 16.5462 10.7766 12.7951 13.1846C9.15074 15.524 7.1613 19.6778 6.41576 22.7385L8.35894 23.2118Z"
          fill="#01AFFD"
        />
      </svg>
    </div>
  );
};
export const Move = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_270_92855)">
        <circle cx="17" cy="17" r="12" fill="white" />
        <circle cx="17" cy="17" r="11.5" stroke="white" />
      </g>
      <path
        d="M12.9167 15.2498L11.1667 16.9998M11.1667 16.9998L12.9167 18.7498M11.1667 16.9998H22.8333M15.25 12.9165L17 11.1665M17 11.1665L18.75 12.9165M17 11.1665V22.8332M18.75 21.0832L17 22.8332M17 22.8332L15.25 21.0832M21.0833 15.2498L22.8333 16.9998M22.8333 16.9998L21.0833 18.7498"
        stroke="#585858"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_d_270_92855"
          x="0"
          y="0"
          width="34"
          height="34"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_270_92855" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_270_92855"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const Rotate = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_270_92858)">
        <circle cx="17" cy="17" r="12" fill="white" />
        <circle cx="17" cy="17" r="11.5" stroke="white" />
      </g>
      <path
        d="M10.5833 12.3333V15.8333M10.5833 15.8333H14.0833M10.5833 15.8333L13.29 13.2899C14.0955 12.4858 15.1406 11.9652 16.2677 11.8066C17.3949 11.648 18.543 11.86 19.5392 12.4107C20.5353 12.9614 21.3255 13.8209 21.7907 14.8597C22.2559 15.8986 22.3709 17.0604 22.1183 18.1703C21.8657 19.2802 21.2593 20.2779 20.3904 21.0131C19.5215 21.7484 18.4372 22.1813 17.3008 22.2467C16.1645 22.3121 15.0377 22.0064 14.0901 21.3757C13.1426 20.745 12.4257 19.8235 12.0475 18.7499"
        stroke="#585858"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_d_270_92858"
          x="0"
          y="0"
          width="34"
          height="34"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_270_92858" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_270_92858"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const FormatColor = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.46154 15.8462C9.46154 16.3984 9.90925 16.8462 10.4615 16.8462C11.0138 16.8462 11.4615 16.3984 11.4615 15.8462H9.46154ZM10.4615 14.3077H9.46154H10.4615ZM13.5385 11.2308V10.2308V11.2308ZM18.9231 11.2308V12.2308V11.2308ZM20.4615 5.07692V4.07692V5.07692ZM18.9231 4.07692C18.3708 4.07692 17.9231 4.52464 17.9231 5.07692C17.9231 5.62921 18.3708 6.07692 18.9231 6.07692V4.07692ZM12.7692 22V23C13.3215 23 13.7692 22.5523 13.7692 22H12.7692ZM8.15385 22H7.15385C7.15385 22.5523 7.60156 23 8.15385 23V22ZM17.3846 1H3.53846V3H17.3846V1ZM3.53846 1C2.13651 1 1 2.13651 1 3.53846H3C3 3.24108 3.24108 3 3.53846 3V1ZM1 3.53846V6.61538H3V3.53846H1ZM1 6.61538C1 8.01734 2.13651 9.15385 3.53846 9.15385V7.15385C3.24108 7.15385 3 6.91277 3 6.61538H1ZM3.53846 9.15385H17.3846V7.15385H3.53846V9.15385ZM17.3846 9.15385C18.7866 9.15385 19.9231 8.01734 19.9231 6.61538H17.9231C17.9231 6.91277 17.682 7.15385 17.3846 7.15385V9.15385ZM19.9231 6.61538V3.53846H17.9231V6.61538H19.9231ZM19.9231 3.53846C19.9231 2.13651 18.7866 1 17.3846 1V3C17.682 3 17.9231 3.24108 17.9231 3.53846H19.9231ZM11.4615 15.8462V14.3077H9.46154V15.8462H11.4615ZM11.4615 14.3077C11.4615 13.7569 11.6804 13.2286 12.0699 12.8391L10.6556 11.4249C9.89107 12.1894 9.46154 13.2264 9.46154 14.3077H11.4615ZM12.0699 12.8391C12.4594 12.4496 12.9876 12.2308 13.5385 12.2308V10.2308C12.4572 10.2308 11.4202 10.6603 10.6556 11.4249L12.0699 12.8391ZM13.5385 12.2308H18.9231V10.2308H13.5385V12.2308ZM18.9231 12.2308C20.0043 12.2308 21.0413 11.8012 21.8059 11.0367L20.3917 9.62245C20.0022 10.012 19.4739 10.2308 18.9231 10.2308V12.2308ZM21.8059 11.0367C22.5705 10.2721 23 9.23511 23 8.15385H21C21 8.70468 20.7812 9.23295 20.3917 9.62245L21.8059 11.0367ZM23 8.15385V6.61538H21V8.15385H23ZM23 6.61538C23 5.94214 22.7325 5.29647 22.2565 4.82042L20.8423 6.23463C20.9433 6.33562 21 6.47258 21 6.61538H23ZM22.2565 4.82042C21.7804 4.34437 21.1348 4.07692 20.4615 4.07692V6.07692C20.6043 6.07692 20.7413 6.13365 20.8423 6.23463L22.2565 4.82042ZM20.4615 4.07692H18.9231V6.07692H20.4615V4.07692ZM13.7692 22V17.3846H11.7692V22H13.7692ZM13.7692 17.3846C13.7692 16.7114 13.5018 16.0657 13.0257 15.5897L11.6115 17.0039C11.7125 17.1048 11.7692 17.2418 11.7692 17.3846H13.7692ZM13.0257 15.5897C12.5497 15.1136 11.904 14.8462 11.2308 14.8462V16.8462C11.3736 16.8462 11.5105 16.9029 11.6115 17.0039L13.0257 15.5897ZM11.2308 14.8462H9.69231V16.8462H11.2308V14.8462ZM9.69231 14.8462C9.01906 14.8462 8.3734 15.1136 7.89734 15.5897L9.31156 17.0039C9.41254 16.9029 9.5495 16.8462 9.69231 16.8462V14.8462ZM7.89734 15.5897C7.42129 16.0657 7.15385 16.7114 7.15385 17.3846H9.15385C9.15385 17.2418 9.21058 17.1048 9.31156 17.0039L7.89734 15.5897ZM7.15385 17.3846V22H9.15385V17.3846H7.15385ZM12.7692 21H8.15385V23H12.7692V21Z"
        className="undoIconFill"
        fill={props.active ? "#01AFFD" : "#585858"}
      />
    </svg>
  );
};

export const FormatColorDisabled = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.46154 15.8462C9.46154 16.3984 9.90925 16.8462 10.4615 16.8462C11.0138 16.8462 11.4615 16.3984 11.4615 15.8462H9.46154ZM10.4615 14.3077H9.46154H10.4615ZM13.5385 11.2308V10.2308V11.2308ZM18.9231 11.2308V12.2308V11.2308ZM20.4615 5.07692V4.07692V5.07692ZM18.9231 4.07692C18.3708 4.07692 17.9231 4.52464 17.9231 5.07692C17.9231 5.62921 18.3708 6.07692 18.9231 6.07692V4.07692ZM12.7692 22V23C13.3215 23 13.7692 22.5523 13.7692 22H12.7692ZM8.15385 22H7.15385C7.15385 22.5523 7.60156 23 8.15385 23V22ZM17.3846 1H3.53846V3H17.3846V1ZM3.53846 1C2.13651 1 1 2.13651 1 3.53846H3C3 3.24108 3.24108 3 3.53846 3V1ZM1 3.53846V6.61538H3V3.53846H1ZM1 6.61538C1 8.01734 2.13651 9.15385 3.53846 9.15385V7.15385C3.24108 7.15385 3 6.91277 3 6.61538H1ZM3.53846 9.15385H17.3846V7.15385H3.53846V9.15385ZM17.3846 9.15385C18.7866 9.15385 19.9231 8.01734 19.9231 6.61538H17.9231C17.9231 6.91277 17.682 7.15385 17.3846 7.15385V9.15385ZM19.9231 6.61538V3.53846H17.9231V6.61538H19.9231ZM19.9231 3.53846C19.9231 2.13651 18.7866 1 17.3846 1V3C17.682 3 17.9231 3.24108 17.9231 3.53846H19.9231ZM11.4615 15.8462V14.3077H9.46154V15.8462H11.4615ZM11.4615 14.3077C11.4615 13.7569 11.6804 13.2286 12.0699 12.8391L10.6556 11.4249C9.89107 12.1894 9.46154 13.2264 9.46154 14.3077H11.4615ZM12.0699 12.8391C12.4594 12.4496 12.9876 12.2308 13.5385 12.2308V10.2308C12.4572 10.2308 11.4202 10.6603 10.6556 11.4249L12.0699 12.8391ZM13.5385 12.2308H18.9231V10.2308H13.5385V12.2308ZM18.9231 12.2308C20.0043 12.2308 21.0413 11.8012 21.8059 11.0367L20.3917 9.62245C20.0022 10.012 19.4739 10.2308 18.9231 10.2308V12.2308ZM21.8059 11.0367C22.5705 10.2721 23 9.23511 23 8.15385H21C21 8.70468 20.7812 9.23295 20.3917 9.62245L21.8059 11.0367ZM23 8.15385V6.61538H21V8.15385H23ZM23 6.61538C23 5.94214 22.7325 5.29647 22.2565 4.82042L20.8423 6.23463C20.9433 6.33562 21 6.47258 21 6.61538H23ZM22.2565 4.82042C21.7804 4.34437 21.1348 4.07692 20.4615 4.07692V6.07692C20.6043 6.07692 20.7413 6.13365 20.8423 6.23463L22.2565 4.82042ZM20.4615 4.07692H18.9231V6.07692H20.4615V4.07692ZM13.7692 22V17.3846H11.7692V22H13.7692ZM13.7692 17.3846C13.7692 16.7114 13.5018 16.0657 13.0257 15.5897L11.6115 17.0039C11.7125 17.1048 11.7692 17.2418 11.7692 17.3846H13.7692ZM13.0257 15.5897C12.5497 15.1136 11.904 14.8462 11.2308 14.8462V16.8462C11.3736 16.8462 11.5105 16.9029 11.6115 17.0039L13.0257 15.5897ZM11.2308 14.8462H9.69231V16.8462H11.2308V14.8462ZM9.69231 14.8462C9.01906 14.8462 8.3734 15.1136 7.89734 15.5897L9.31156 17.0039C9.41254 16.9029 9.5495 16.8462 9.69231 16.8462V14.8462ZM7.89734 15.5897C7.42129 16.0657 7.15385 16.7114 7.15385 17.3846H9.15385C9.15385 17.2418 9.21058 17.1048 9.31156 17.0039L7.89734 15.5897ZM7.15385 17.3846V22H9.15385V17.3846H7.15385ZM12.7692 21H8.15385V23H12.7692V21Z"
        fill="#D4D5DE"
      />
    </svg>
  );
};

export const Undo = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 9.14054V16M1 16H7.7727M1 16L6.23756 11.0155C7.45072 9.78614 8.95158 8.88812 10.6001 8.40517C12.2486 7.92223 13.9911 7.87011 15.6648 8.25368C17.3386 8.63724 18.8892 9.44399 20.1719 10.5987C21.4545 11.7533 22.4275 13.2182 23 14.8568"
        stroke={"currentColor"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Redo = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23 9.14054V16M23 16H16.2273M23 16L17.7624 11.0155C16.5493 9.78614 15.0484 8.88812 13.3999 8.40517C11.7514 7.92223 10.0089 7.87011 8.33516 8.25368C6.66138 8.63724 5.11081 9.44399 3.82813 10.5987C2.54546 11.7533 1.57248 13.2182 1 14.8568"
        stroke={"currentColor"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Select = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 3L6.14378 23L11.9983 16.2503L21 15.5435L6 3Z"
        className={"undoIconFill"}
        fill="white"
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TextBox = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 8.875V7H17V8.875M10.125 17H13.875M12 7V17"
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="2"
        y="2"
        width="20"
        height="20"
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Images = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.11549 4C2.95638 4 2.80118 4.0639 2.68475 4.18182C2.56789 4.30017 2.5 4.46336 2.5 4.63614V16.9072C2.5 17.4595 2.05228 17.9072 1.5 17.9072C0.947715 17.9072 0.5 17.4595 0.5 16.9072V4.63614C0.5 3.94106 0.772515 3.27193 1.26158 2.77661C1.75108 2.28086 2.41769 2 3.11549 2H17.6549C18.2072 2 18.6549 2.44772 18.6549 3C18.6549 3.55228 18.2072 4 17.6549 4H3.11549ZM22.2178 21.631C22.9889 21.1698 23.5009 20.3212 23.5009 19.3615V8.72661C23.5009 7.28272 22.3419 6.09047 20.8854 6.09047H7.15376C5.69732 6.09047 4.53827 7.28272 4.53827 8.72661V19.3615C4.53827 20.3963 5.13349 21.3018 6.00684 21.7319C6.07171 21.7696 6.13982 21.7993 6.2098 21.8212C6.50193 21.9351 6.82004 21.9977 7.15376 21.9977H20.8854C21.2467 21.9977 21.5896 21.9243 21.9011 21.792C22.0131 21.7585 22.1206 21.7049 22.2178 21.631ZM19.4519 19.9977L14.5046 14.7461L14.4977 14.7388L14.4977 14.7387C14.439 14.6751 14.3686 14.6252 14.2914 14.5916C14.2142 14.558 14.1315 14.5412 14.0484 14.5418C13.9653 14.5423 13.8828 14.5603 13.8061 14.595C13.7293 14.6297 13.6595 14.6805 13.6015 14.7451L13.5881 14.7597L8.69041 19.9977H19.4519ZM21.5009 19.256L15.9633 13.3779C15.7181 13.1134 15.4209 12.9021 15.0898 12.7579C14.757 12.613 14.3977 12.5393 14.0346 12.5418C13.6716 12.5443 13.3133 12.623 12.9825 12.7724C12.6552 12.9203 12.3622 13.1342 12.1213 13.4001L6.53833 19.3709C6.53829 19.3678 6.53827 19.3647 6.53827 19.3615V8.72661C6.53827 8.36326 6.82577 8.09047 7.15376 8.09047H20.8854C21.2134 8.09047 21.5009 8.36326 21.5009 8.72661V19.256Z"
        fill={props.active ? "#01AFFD" : "currentColor"}
      />
      {/*<path d="M29.5 10.25L33 13.75L36.5 10.25" className={'undoIcon'} stroke={props.active ? '#01AFFD' : "#585858"}*/}
      {/*strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>*/}
    </svg>
  );
};

export const Shapes = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="40"
      height="24"
      viewBox="0 0 40 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 9C3 5.68629 5.68629 3 9 3C12.3137 3 15 5.68629 15 9C15 12.3137 12.3137 15 9 15C5.68629 15 3 12.3137 3 9ZM9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1ZM19 5C18.8925 5 18.7857 5.01733 18.6838 5.05132L17.1838 5.55132L17.8162 7.44868L19.1623 7H21V21H10V18H8V22C8 22.5523 8.44772 23 9 23H22C22.5523 23 23 22.5523 23 22V6C23 5.44772 22.5523 5 22 5H19Z"
        fill={props.active ? "#01AFFD" : "#585858"}
      />
      {/*<path d="M29.5 10.25L33 13.75L36.5 10.25" className={'undoIcon'} stroke={props.active ? '#01AFFD' : "#585858"}*/}
      {/*strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>*/}
    </svg>
  );
};

export const Lines = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="40"
      height="24"
      viewBox="0 0 40 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 4C5 4.13826 4.98597 4.27325 4.95926 4.40361L20.3693 18.1015C20.5676 18.0356 20.7796 18 21 18C22.1046 18 23 18.8954 23 20C23 21.1046 22.1046 22 21 22C19.8954 22 19 21.1046 19 20C19 19.8617 19.014 19.7268 19.0407 19.5964L3.63066 5.89854C3.43239 5.96436 3.22036 6 3 6C1.89543 6 1 5.10457 1 4C1 2.89543 1.89543 2 3 2C4.10457 2 5 2.89543 5 4Z"
        fill={props.active ? "#01AFFD" : "#585858"}
      />
      {/*<path d="M29.5 10.25L33 13.75L36.5 10.25" className={'undoIcon'} stroke={props.active ? '#01AFFD' : "#585858"}*/}
      {/*strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>*/}
    </svg>
  );
};

export const Separator = ({ ...props }) => {
  return (
    <svg
      className={"separator " + props.className ? props.className : ""}
      width="2"
      height="26"
      viewBox="0 0 2 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1V25"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeLinecap="round"
      />
    </svg>
  );
};

export const Charts = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="40"
      height="24"
      viewBox="0 0 40 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 20V10M18 20V4M6 20V16"
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/*<path d="M29.5 10.25L33 13.75L36.5 10.25" className={'undoIcon'} stroke={props.active ? '#01AFFD' : "#585858"}*/}
      {/*strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>*/}
    </svg>
  );
};

export const FinancialCharts = ({ ...props }) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 82 81"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M81.2998 41.8999C77.5998 43.8999 71.9998 45.0999 66.2998 45.6999V56.6999C76.7998 55.6999 81.2998 52.7999 81.2998 51.7999V41.8999Z"
      fill={props.active ? "#01AFFD" : "#585858"}
    />
    <path
      d="M58.7998 10C71.2262 10 81.2998 7.76142 81.2998 5C81.2998 2.23858 71.2262 0 58.7998 0C46.3734 0 36.2998 2.23858 36.2998 5C36.2998 7.76142 46.3734 10 58.7998 10Z"
      fill={props.active ? "#01AFFD" : "#585858"}
    />
    <path
      d="M81.3 26C77.6 28 71.7 29.2 65.5 29.7C66 30.7 66.3 31.8 66.3 33V41.6C76.8 40.6 81.3 37.7 81.3 36.6V26Z"
      fill={props.active ? "#01AFFD" : "#585858"}
    />
    <path
      d="M81.2998 20.8001V10.1001C76.2998 12.7001 67.2998 14.0001 58.7998 14.0001C50.2998 14.0001 41.2998 12.7001 36.2998 10.1001V20.9001C36.2998 22.4001 44.1998 26.0001 58.7998 26.0001C73.3998 26.0001 81.2998 22.4001 81.2998 20.9001V20.8001Z"
      fill={props.active ? "#01AFFD" : "#585858"}
    />
    <path
      d="M58.3 30H3.9C1.7 30 0 31.8 0 33.9V76.5C0 78.7 1.8 80.4 3.9 80.4H58.3C60.5 80.4 62.2 78.6 62.2 76.5V34C62.2 31.8 60.5 30 58.3 30ZM15.1 77.9H7V70.3H15.1V77.9ZM15.1 68H7V60.4H15.1V68ZM27.9 77.9H19.8V66.9H27.9V77.9ZM27.9 64.5H19.8V53.5H27.9V64.5ZM40.6 77.9H32.5V63.4H40.6V77.9ZM40.6 61.1H32.5V46.5H40.6V61.1ZM53.4 77.9H45.3V55.8H53.4V77.9ZM53.4 39.5V53.5H45.3V39.5H41.8L49.3 31.4L56.9 39.5H53.4Z"
      fill={props.active ? "#01AFFD" : "#585858"}
    />
  </svg>
);

export const FinancialTables = ({ ...props }) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M22 74H13V80H22V74Z" fill={props.active ? "#01AFFD" : "#585858"} />
    <path d="M22 64H13V70H22V64Z" fill={props.active ? "#01AFFD" : "#585858"} />
    <path d="M22 54H13V60H22V54Z" fill={props.active ? "#01AFFD" : "#585858"} />
    <path d="M22 44H13V50H22V44Z" fill={props.active ? "#01AFFD" : "#585858"} />
    <path d="M9 54H0V60H9V54Z" fill={props.active ? "#01AFFD" : "#585858"} />
    <path d="M9 44H0V50H9V44Z" fill={props.active ? "#01AFFD" : "#585858"} />
    <path d="M9 64H0V70H9V64Z" fill={props.active ? "#01AFFD" : "#585858"} />
    <path d="M35 44H26V50H35V44Z" fill={props.active ? "#01AFFD" : "#585858"} />
    <path d="M48 74H39V80H48V74Z" fill={props.active ? "#01AFFD" : "#585858"} />
    <path d="M35 74H26V80H35V74Z" fill={props.active ? "#01AFFD" : "#585858"} />
    <path d="M48 64H39V70H48V64Z" fill={props.active ? "#01AFFD" : "#585858"} />
    <path d="M48 54H39V60H48V54Z" fill={props.active ? "#01AFFD" : "#585858"} />
    <path d="M35 64H26V70H35V64Z" fill={props.active ? "#01AFFD" : "#585858"} />
    <path d="M35 54H26V60H35V54Z" fill={props.active ? "#01AFFD" : "#585858"} />
    <path d="M0 77C0 78.7 1.3 80 3 80H9V74H0V77Z" fill={props.active ? "#01AFFD" : "#585858"} />
    <path d="M61 54H52V60H61V54Z" fill={props.active ? "#01AFFD" : "#585858"} />
    <path d="M48 44H39V50H48V44Z" fill={props.active ? "#01AFFD" : "#585858"} />
    <path d="M61 44H52V50H61V44Z" fill={props.active ? "#01AFFD" : "#585858"} />
    <path
      d="M0 40H61V33C61 31.3 59.7 30 58 30H3C1.3 30 0 31.3 0 33V40Z"
      fill={props.active ? "#01AFFD" : "#585858"}
    />
    <path
      d="M52 80H58C59.7 80 61 78.7 61 77V74H52V80Z"
      fill={props.active ? "#01AFFD" : "#585858"}
    />
    <path
      d="M80 41.8999C76.3 43.8999 70.7 45.0999 65 45.6999V56.6999C75.5 55.6999 80 52.7999 80 51.7999V41.8999Z"
      fill={props.active ? "#01AFFD" : "#585858"}
    />
    <path d="M61 64H52V70H61V64Z" fill={props.active ? "#01AFFD" : "#585858"} />
    <path
      d="M57.5 10C69.9264 10 80 7.76142 80 5C80 2.23858 69.9264 0 57.5 0C45.0736 0 35 2.23858 35 5C35 7.76142 45.0736 10 57.5 10Z"
      fill={props.active ? "#01AFFD" : "#585858"}
    />
    <path
      d="M80.0002 26C76.3002 28 70.4002 29.2 64.2002 29.7C64.7002 30.7 65.0002 31.8 65.0002 33V41.6C75.5002 40.6 80.0002 37.7 80.0002 36.6V26Z"
      fill={props.active ? "#01AFFD" : "#585858"}
    />
    <path
      d="M80 20.8001V10.1001C75 12.7001 66 14.0001 57.5 14.0001C49 14.0001 40 12.7001 35 10.1001V20.9001C35 22.4001 42.9 26.0001 57.5 26.0001C72.1 26.0001 80 22.4001 80 20.9001V20.8001Z"
      fill={props.active ? "#01AFFD" : "#585858"}
    />
  </svg>
);

export const Tables = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 3V21M9 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V12M9 3H15M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V12M9 21H15M15 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V12M15 3V21M15 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V12M3 12H21"
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/*<path d="M29.5 10.25L33 13.75L36.5 10.25" className={'undoIcon'} stroke={props.active ? '#01AFFD' : "#585858"}*/}
      {/*strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>*/}
    </svg>
  );
};

export const BG = ({ ...props }) => {
  return (
    <svg
      width="107"
      height="26"
      viewBox="0 0 107 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.76847 19V7.36364H5.83665C6.64725 7.36364 7.31581 7.50379 7.84233 7.78409C8.36885 8.06061 8.76089 8.43371 9.01847 8.90341C9.27604 9.36932 9.40483 9.88636 9.40483 10.4545C9.40483 10.9545 9.31581 11.3674 9.13778 11.6932C8.96354 12.0189 8.73248 12.2765 8.4446 12.4659C8.16051 12.6553 7.8518 12.7955 7.51847 12.8864V13C7.87453 13.0227 8.23248 13.1477 8.59233 13.375C8.95218 13.6023 9.25331 13.928 9.49574 14.3523C9.73816 14.7765 9.85938 15.2955 9.85938 15.9091C9.85938 16.4924 9.7268 17.017 9.46165 17.483C9.1965 17.9489 8.77794 18.3182 8.20597 18.5909C7.634 18.8636 6.88968 19 5.97301 19H1.76847ZM3.17756 17.75H5.97301C6.89347 17.75 7.54688 17.572 7.93324 17.2159C8.32339 16.8561 8.51847 16.4205 8.51847 15.9091C8.51847 15.5152 8.41809 15.1515 8.21733 14.8182C8.01657 14.4811 7.73059 14.2121 7.35938 14.0114C6.98816 13.8068 6.54877 13.7045 6.04119 13.7045H3.17756V17.75ZM3.17756 12.4773H5.79119C6.21544 12.4773 6.59801 12.3939 6.93892 12.2273C7.28362 12.0606 7.55634 11.8258 7.7571 11.5227C7.96165 11.2197 8.06392 10.8636 8.06392 10.4545C8.06392 9.94318 7.88589 9.50947 7.52983 9.15341C7.17377 8.79356 6.60938 8.61364 5.83665 8.61364H3.17756V12.4773ZM14.5611 19.2045C14.008 19.2045 13.5062 19.1004 13.0554 18.892C12.6046 18.6799 12.2467 18.375 11.9815 17.9773C11.7164 17.5758 11.5838 17.0909 11.5838 16.5227C11.5838 16.0227 11.6823 15.6174 11.8793 15.3068C12.0762 14.9924 12.3395 14.7462 12.669 14.5682C12.9986 14.3902 13.3622 14.2576 13.7599 14.1705C14.1615 14.0795 14.5649 14.0076 14.9702 13.9545C15.5005 13.8864 15.9304 13.8352 16.2599 13.8011C16.5933 13.7633 16.8357 13.7008 16.9872 13.6136C17.1425 13.5265 17.2202 13.375 17.2202 13.1591V13.1136C17.2202 12.553 17.0668 12.1174 16.7599 11.8068C16.4569 11.4962 15.9967 11.3409 15.3793 11.3409C14.7391 11.3409 14.2372 11.4811 13.8736 11.7614C13.5099 12.0417 13.2543 12.3409 13.1065 12.6591L11.8338 12.2045C12.0611 11.6742 12.3641 11.2614 12.7429 10.9659C13.1255 10.6667 13.5421 10.4583 13.9929 10.3409C14.4474 10.2197 14.8944 10.1591 15.3338 10.1591C15.6141 10.1591 15.9361 10.1932 16.2997 10.2614C16.6671 10.3258 17.0213 10.4602 17.3622 10.6648C17.7069 10.8693 17.9929 11.178 18.2202 11.5909C18.4474 12.0038 18.5611 12.5568 18.5611 13.25V19H17.2202V17.8182H17.152C17.0611 18.0076 16.9096 18.2102 16.6974 18.4261C16.4853 18.642 16.2031 18.8258 15.8509 18.9773C15.4986 19.1288 15.0687 19.2045 14.5611 19.2045ZM14.7656 18C15.2959 18 15.7429 17.8958 16.1065 17.6875C16.474 17.4792 16.7505 17.2102 16.9361 16.8807C17.1255 16.5511 17.2202 16.2045 17.2202 15.8409V14.6136C17.1634 14.6818 17.0384 14.7443 16.8452 14.8011C16.6558 14.8542 16.4361 14.9015 16.1861 14.9432C15.9399 14.9811 15.6993 15.0152 15.4645 15.0455C15.2334 15.072 15.0459 15.0947 14.902 15.1136C14.5535 15.1591 14.2277 15.233 13.9247 15.3352C13.6255 15.4337 13.383 15.5833 13.1974 15.7841C13.0156 15.9811 12.9247 16.25 12.9247 16.5909C12.9247 17.0568 13.0971 17.4091 13.4418 17.6477C13.7902 17.8826 14.2315 18 14.7656 18ZM24.554 19.1818C23.7358 19.1818 23.0313 18.9886 22.4403 18.6023C21.8494 18.2159 21.3949 17.6837 21.0767 17.0057C20.7585 16.3277 20.5994 15.553 20.5994 14.6818C20.5994 13.7955 20.7623 13.0133 21.0881 12.3352C21.4176 11.6534 21.8759 11.1212 22.4631 10.7386C23.054 10.3523 23.7434 10.1591 24.5312 10.1591C25.1449 10.1591 25.6979 10.2727 26.1903 10.5C26.6828 10.7273 27.0862 11.0455 27.4006 11.4545C27.715 11.8636 27.91 12.3409 27.9858 12.8864H26.6449C26.5426 12.4886 26.3153 12.1364 25.9631 11.8295C25.6146 11.5189 25.1449 11.3636 24.554 11.3636C24.0313 11.3636 23.5729 11.5 23.179 11.7727C22.7888 12.0417 22.4839 12.4223 22.2642 12.9148C22.0483 13.4034 21.9403 13.9773 21.9403 14.6364C21.9403 15.3106 22.0464 15.8977 22.2585 16.3977C22.4744 16.8977 22.7775 17.286 23.1676 17.5625C23.5616 17.839 24.0237 17.9773 24.554 17.9773C24.9025 17.9773 25.2188 17.9167 25.5028 17.7955C25.7869 17.6742 26.0275 17.5 26.2244 17.2727C26.4214 17.0455 26.5616 16.7727 26.6449 16.4545H27.9858C27.91 16.9697 27.7225 17.4337 27.4233 17.8466C27.1278 18.2557 26.7358 18.5814 26.2472 18.8239C25.7623 19.0625 25.1979 19.1818 24.554 19.1818ZM31.196 15.8182L31.1733 14.1591H31.446L35.2642 10.2727H36.9233L32.8551 14.3864H32.7415L31.196 15.8182ZM29.946 19V7.36364H31.2869V19H29.946ZM35.4915 19L32.0824 14.6818L33.0369 13.75L37.196 19H35.4915ZM41.8125 22.4545C41.1648 22.4545 40.608 22.3712 40.142 22.2045C39.6761 22.0417 39.2879 21.8258 38.9773 21.5568C38.6705 21.2917 38.4261 21.0076 38.2443 20.7045L39.3125 19.9545C39.4337 20.1136 39.5871 20.2955 39.7727 20.5C39.9583 20.7083 40.2121 20.8883 40.5341 21.0398C40.8598 21.1951 41.286 21.2727 41.8125 21.2727C42.517 21.2727 43.0985 21.1023 43.5568 20.7614C44.0152 20.4205 44.2443 19.8864 44.2443 19.1591V17.3864H44.1307C44.0322 17.5455 43.892 17.7424 43.7102 17.9773C43.5322 18.2083 43.2746 18.4148 42.9375 18.5966C42.6042 18.7746 42.1534 18.8636 41.5852 18.8636C40.8807 18.8636 40.2481 18.697 39.6875 18.3636C39.1307 18.0303 38.6894 17.5455 38.3636 16.9091C38.0417 16.2727 37.8807 15.5 37.8807 14.5909C37.8807 13.697 38.0379 12.9186 38.3523 12.2557C38.6667 11.589 39.1042 11.0739 39.6648 10.7102C40.2254 10.3428 40.8731 10.1591 41.608 10.1591C42.1761 10.1591 42.6269 10.2538 42.9602 10.4432C43.2973 10.6288 43.5549 10.8409 43.733 11.0795C43.9148 11.3144 44.0549 11.5076 44.1534 11.6591H44.2898V10.2727H45.5852V19.25C45.5852 20 45.4148 20.6098 45.0739 21.0795C44.7367 21.553 44.2822 21.8996 43.7102 22.1193C43.142 22.3428 42.5095 22.4545 41.8125 22.4545ZM41.767 17.6591C42.3049 17.6591 42.7595 17.536 43.1307 17.2898C43.5019 17.0436 43.7841 16.6894 43.9773 16.2273C44.1705 15.7652 44.267 15.2121 44.267 14.5682C44.267 13.9394 44.1723 13.3845 43.983 12.9034C43.7936 12.4223 43.5133 12.0455 43.142 11.7727C42.7708 11.5 42.3125 11.3636 41.767 11.3636C41.1989 11.3636 40.7254 11.5076 40.3466 11.7955C39.9716 12.0833 39.6894 12.4697 39.5 12.9545C39.3144 13.4394 39.2216 13.9773 39.2216 14.5682C39.2216 15.1742 39.3163 15.7102 39.5057 16.1761C39.6989 16.6383 39.983 17.0019 40.358 17.267C40.7367 17.5284 41.2064 17.6591 41.767 17.6591ZM48.0398 19V10.2727H49.3352V11.5909H49.4261C49.5852 11.1591 49.8731 10.8087 50.2898 10.5398C50.7064 10.2708 51.1761 10.1364 51.6989 10.1364C51.7973 10.1364 51.9205 10.1383 52.0682 10.142C52.2159 10.1458 52.3277 10.1515 52.4034 10.1591V11.5227C52.358 11.5114 52.2538 11.4943 52.0909 11.4716C51.9318 11.4451 51.7633 11.4318 51.5852 11.4318C51.161 11.4318 50.7822 11.5208 50.4489 11.6989C50.1193 11.8731 49.858 12.1155 49.6648 12.4261C49.4754 12.733 49.3807 13.0833 49.3807 13.4773V19H48.0398ZM57.2727 19.1818C56.4848 19.1818 55.7936 18.9943 55.1989 18.6193C54.608 18.2443 54.1458 17.7197 53.8125 17.0455C53.483 16.3712 53.3182 15.5833 53.3182 14.6818C53.3182 13.7727 53.483 12.9792 53.8125 12.3011C54.1458 11.6231 54.608 11.0966 55.1989 10.7216C55.7936 10.3466 56.4848 10.1591 57.2727 10.1591C58.0606 10.1591 58.75 10.3466 59.3409 10.7216C59.9356 11.0966 60.3977 11.6231 60.7273 12.3011C61.0606 12.9792 61.2273 13.7727 61.2273 14.6818C61.2273 15.5833 61.0606 16.3712 60.7273 17.0455C60.3977 17.7197 59.9356 18.2443 59.3409 18.6193C58.75 18.9943 58.0606 19.1818 57.2727 19.1818ZM57.2727 17.9773C57.8712 17.9773 58.3636 17.8239 58.75 17.517C59.1364 17.2102 59.4223 16.8068 59.608 16.3068C59.7936 15.8068 59.8864 15.2652 59.8864 14.6818C59.8864 14.0985 59.7936 13.5549 59.608 13.0511C59.4223 12.5473 59.1364 12.1402 58.75 11.8295C58.3636 11.5189 57.8712 11.3636 57.2727 11.3636C56.6742 11.3636 56.1818 11.5189 55.7955 11.8295C55.4091 12.1402 55.1231 12.5473 54.9375 13.0511C54.7519 13.5549 54.6591 14.0985 54.6591 14.6818C54.6591 15.2652 54.7519 15.8068 54.9375 16.3068C55.1231 16.8068 55.4091 17.2102 55.7955 17.517C56.1818 17.8239 56.6742 17.9773 57.2727 17.9773ZM68.7741 15.4318V10.2727H70.1151V19H68.7741V17.5227H68.6832C68.4787 17.9659 68.1605 18.3428 67.7287 18.6534C67.2969 18.9602 66.7514 19.1136 66.0923 19.1136C65.5469 19.1136 65.062 18.9943 64.6378 18.7557C64.2135 18.5133 63.8802 18.1496 63.6378 17.6648C63.3954 17.1761 63.2741 16.5606 63.2741 15.8182V10.2727H64.6151V15.7273C64.6151 16.3636 64.7931 16.8712 65.1491 17.25C65.509 17.6288 65.9673 17.8182 66.5241 17.8182C66.8575 17.8182 67.1965 17.733 67.5412 17.5625C67.8897 17.392 68.1813 17.1307 68.4162 16.7784C68.6548 16.4261 68.7741 15.9773 68.7741 15.4318ZM73.9119 13.75V19H72.571V10.2727H73.8665V11.6364H73.9801C74.1847 11.1932 74.4953 10.8371 74.9119 10.5682C75.3286 10.2955 75.8665 10.1591 76.5256 10.1591C77.1165 10.1591 77.6335 10.2803 78.0767 10.5227C78.5199 10.7614 78.8646 11.125 79.1108 11.6136C79.357 12.0985 79.4801 12.7121 79.4801 13.4545V19H78.1392V13.5455C78.1392 12.8598 77.9612 12.3258 77.6051 11.9432C77.2491 11.5568 76.7604 11.3636 76.1392 11.3636C75.7112 11.3636 75.3286 11.4564 74.9915 11.642C74.6581 11.8277 74.3949 12.0985 74.2017 12.4545C74.0085 12.8106 73.9119 13.2424 73.9119 13.75ZM85.2259 19.1818C84.4986 19.1818 83.8565 18.9981 83.2997 18.6307C82.7429 18.2595 82.3073 17.7367 81.9929 17.0625C81.6785 16.3845 81.5213 15.5833 81.5213 14.6591C81.5213 13.7424 81.6785 12.947 81.9929 12.2727C82.3073 11.5985 82.7448 11.0777 83.3054 10.7102C83.866 10.3428 84.5137 10.1591 85.2486 10.1591C85.8168 10.1591 86.2656 10.2538 86.5952 10.4432C86.9285 10.6288 87.1823 10.8409 87.3565 11.0795C87.5346 11.3144 87.6728 11.5076 87.7713 11.6591H87.8849V7.36364H89.2259V19H87.9304V17.6591H87.7713C87.6728 17.8182 87.5327 18.0189 87.3509 18.2614C87.169 18.5 86.9096 18.714 86.5724 18.9034C86.2353 19.089 85.7865 19.1818 85.2259 19.1818ZM85.4077 17.9773C85.9455 17.9773 86.4001 17.8371 86.7713 17.5568C87.1425 17.2727 87.4247 16.8807 87.6179 16.3807C87.8111 15.8769 87.9077 15.2955 87.9077 14.6364C87.9077 13.9848 87.813 13.4148 87.6236 12.9261C87.4342 12.4337 87.1539 12.0511 86.7827 11.7784C86.4115 11.5019 85.9531 11.3636 85.4077 11.3636C84.8395 11.3636 84.366 11.5095 83.9872 11.8011C83.6122 12.089 83.33 12.4811 83.1406 12.9773C82.955 13.4697 82.8622 14.0227 82.8622 14.6364C82.8622 15.2576 82.9569 15.822 83.1463 16.3295C83.3395 16.8333 83.6236 17.2348 83.9986 17.5341C84.3774 17.8295 84.8471 17.9773 85.4077 17.9773Z"
        className={"undoIconFill"}
        fill={props.active ? "#01AFFD" : "#585858"}
      />
      <path
        d="M96.5 11.25L100 14.75L103.5 11.25"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FillColor = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="40"
      height="24"
      viewBox="0 0 40 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3432 4.82598C10.6501 4.2584 9.71959 4.2271 9.2648 4.75608L2.26529 12.8974C1.8105 13.4264 2.00366 14.3153 2.69673 14.8829L10.8536 21.5629C11.5467 22.1305 12.4772 22.1618 12.932 21.6328L19.9315 13.4915C20.3863 12.9626 20.1932 12.0736 19.5001 11.506L11.3432 4.82598ZM11.3432 4.82598L7.9814 1.98794"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5001 16C21.5001 16 24.9335 19.1631 23.7531 20.861C22.6973 22.3797 20.303 22.3797 19.2472 20.861C18.0667 19.1631 21.5001 16 21.5001 16Z"
        className={"undoIconFill"}
        fill={props.active ? "#01AFFD" : props.activeColor}
      />
      <path
        d="M4.39967 14.9999C3.79995 14.4999 3.01977 13.9999 3.01977 13.5599C3.01067 13.5259 3.26612 13.2336 3.49984 12.9999L19.1 12.5C19.2 12.7 19.2992 12.7683 19 13.1001L12.1475 21.2087C12.0758 21.2882 11.9542 21.2972 11.8717 21.2291L4.39967 14.9999Z"
        className={"undoIconFill"}
        fill={props.active ? "#01AFFD" : props.activeColor}
      />
      <path
        d="M29.5 10.25L33 13.75L36.5 10.25"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BorderColor = ({ ...props }) => {
  return (
    <svg width="40" height="24" viewBox="0 0 40 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.8187 6.55019L4.36168 16.0072L3 21L7.99283 19.6383L17.4498 10.1813M13.8187 6.55019L16.6168 3.75204C16.8552 3.51361 17.1383 3.32448 17.4498 3.19545C17.7613 3.06641 18.0952 3 18.4324 3C18.7696 3 19.1035 3.06641 19.415 3.19545C19.7265 3.32448 20.0095 3.51361 20.248 3.75204C20.4864 3.99046 20.6755 4.27351 20.8046 4.58503C20.9336 4.89655 21 5.23043 21 5.56761C21 5.90479 20.9336 6.23868 20.8046 6.55019C20.6755 6.86171 20.4864 7.14476 20.248 7.38319L17.4498 10.1813M13.8187 6.55019L17.4498 10.1813"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 16.6462C18 16.6462 20.7467 19.2821 19.8024 20.6971C18.9577 21.9626 17.0423 21.9626 16.1976 20.6971C15.2533 19.2821 18 16.6462 18 16.6462Z"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : props.activeColor}
        strokeWidth="2"
      />
      <path
        d="M29.5 10.25L33 13.75L36.5 10.25"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const BorderWeight = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="40"
      height="24"
      viewBox="0 0 40 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 6.5C1 5.39543 1.89543 4.5 3 4.5H21C22.1046 4.5 23 5.39543 23 6.5C23 7.60457 22.1046 8.5 21 8.5H3C1.89543 8.5 1 7.60457 1 6.5ZM1 14.5C1 13.9477 1.44772 13.5 2 13.5H22C22.5523 13.5 23 13.9477 23 14.5C23 15.0523 22.5523 15.5 22 15.5H2C1.44772 15.5 1 15.0523 1 14.5ZM1.5 22C1.22386 22 1 22.2239 1 22.5C1 22.7761 1.22386 23 1.5 23H22.5C22.7761 23 23 22.7761 23 22.5C23 22.2239 22.7761 22 22.5 22H1.5Z"
        className={"undoIconFill"}
        fill={props.active ? "#01AFFD" : "#585858"}
      />
      <path
        d="M29.5 10.25L33 13.75L36.5 10.25"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Icons = ({ ...props }) => {
  return (
    <svg width="40" height="25" viewBox="0 0 40 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.68475 4.18182C2.80118 4.0639 2.95638 4 3.11549 4H17.6549C18.2072 4 18.6549 3.55228 18.6549 3C18.6549 2.44772 18.2072 2 17.6549 2H3.11549C2.41769 2 1.75108 2.28086 1.26158 2.77661C0.772515 3.27193 0.5 3.94106 0.5 4.63614V16.9072C0.5 17.4595 0.947715 17.9072 1.5 17.9072C2.05228 17.9072 2.5 17.4595 2.5 16.9072V4.63614C2.5 4.46336 2.56789 4.30017 2.68475 4.18182ZM13.0196 21.9977C13.5719 21.9977 14.0196 21.55 14.0196 20.9977C14.0196 20.4454 13.5719 19.9977 13.0196 19.9977H7.15376C6.82577 19.9977 6.53827 19.7249 6.53827 19.3615V8.72661C6.53827 8.36326 6.82577 8.09047 7.15376 8.09047H18.8854C19.2134 8.09047 19.5009 8.36326 19.5009 8.72661V14.0441C19.5009 14.5964 19.9487 15.0441 20.5009 15.0441C21.0532 15.0441 21.5009 14.5964 21.5009 14.0441V8.72661C21.5009 7.28272 20.3419 6.09047 18.8854 6.09047H7.15376C5.69732 6.09047 4.53827 7.28272 4.53827 8.72661V19.3615C4.53827 20.8054 5.69732 21.9977 7.15376 21.9977H13.0196ZM21.5 18C21.5 17.4477 21.0523 17 20.5 17C19.9477 17 19.5 17.4477 19.5 18V20H17.5C16.9477 20 16.5 20.4477 16.5 21C16.5 21.5523 16.9477 22 17.5 22H19.5V24C19.5 24.5523 19.9477 25 20.5 25C21.0523 25 21.5 24.5523 21.5 24V22H23.5C24.0523 22 24.5 21.5523 24.5 21C24.5 20.4477 24.0523 20 23.5 20H21.5V18Z"
        fill={props.active ? "#01AFFD" : "#585858"}
      />
      {/*<path className={'undoIcon'} d="M29.5 10.25L33 13.75L36.5 10.25"stroke={props.active ? '#01AFFD' : "#585858"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>*/}
    </svg>
  );
};
export const BorderDash = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="40"
      height="24"
      viewBox="0 0 40 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 6C1 5.44772 1.44772 5 2 5H22C22.5523 5 23 5.44772 23 6C23 6.55228 22.5523 7 22 7L2 7C1.44772 7 1 6.55229 1 6ZM1 14C1 13.4477 1.44772 13 2 13H9C9.55228 13 10 13.4477 10 14C10 14.5523 9.55228 15 9 15H2C1.44772 15 1 14.5523 1 14ZM14 14C14 13.4477 14.4477 13 15 13H22C22.5523 13 23 13.4477 23 14C23 14.5523 22.5523 15 22 15H15C14.4477 15 14 14.5523 14 14ZM2 21C1.44772 21 1 21.4477 1 22C1 22.5523 1.44772 23 2 23H2.55556C3.10784 23 3.55556 22.5523 3.55556 22C3.55556 21.4477 3.10784 21 2.55556 21H2ZM8.11111 21C7.55883 21 7.11111 21.4477 7.11111 22C7.11111 22.5523 7.55883 23 8.11111 23H9.22222C9.77451 23 10.2222 22.5523 10.2222 22C10.2222 21.4477 9.77451 21 9.22222 21H8.11111ZM14.7778 21C14.2255 21 13.7778 21.4477 13.7778 22C13.7778 22.5523 14.2255 23 14.7778 23H15.8889C16.4412 23 16.8889 22.5523 16.8889 22C16.8889 21.4477 16.4412 21 15.8889 21H14.7778ZM21.4444 21C20.8922 21 20.4444 21.4477 20.4444 22C20.4444 22.5523 20.8922 23 21.4444 23H22C22.5523 23 23 22.5523 23 22C23 21.4477 22.5523 21 22 21H21.4444Z"
        className={"undoIconFill"}
        fill={props.active ? "#01AFFD" : "#585858"}
      />
      <path
        d="M29.5 10.25L33 13.75L36.5 10.25"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Bold = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 12H14C15.0609 12 16.0783 11.5786 16.8284 10.8284C17.5786 10.0783 18 9.06087 18 8C18 6.93913 17.5786 5.92172 16.8284 5.17157C16.0783 4.42143 15.0609 4 14 4H6V12ZM6 12H15C16.0609 12 17.0783 12.4214 17.8284 13.1716C18.5786 13.9217 19 14.9391 19 16C19 17.0609 18.5786 18.0783 17.8284 18.8284C17.0783 19.5786 16.0609 20 15 20H6V12Z"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Italic = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 4H10M14 20H5M15 4L9 20"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Underline = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 3V10C6 11.5913 6.63214 13.1174 7.75736 14.2426C8.88258 15.3679 10.4087 16 12 16C13.5913 16 15.1174 15.3679 16.2426 14.2426C17.3679 13.1174 18 11.5913 18 10V3M4 21H20"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TextColor = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="40"
      height="24"
      viewBox="0 0 40 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 21L19 21"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : props.activeColor}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 16L8 10.5M19 16L16 10.5M8 10.5L12 3L16 10.5M8 10.5H16"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.5 10.25L33 13.75L36.5 10.25"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HighlightColor = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="40"
      height="24"
      viewBox="0 0 40 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 18.0024L6.4624 15.54"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.18135 16.5122C9.06693 16.6276 8.93081 16.7192 8.78083 16.7816C8.63085 16.8441 8.46998 16.8763 8.30751 16.8763C8.14503 16.8763 7.98417 16.8441 7.83419 16.7816C7.68421 16.7192 7.54808 16.6276 7.43367 16.5122L5.48906 14.5676C5.3737 14.4532 5.28214 14.3171 5.21965 14.1671C5.15717 14.0171 5.125 13.8563 5.125 13.6938C5.125 13.5313 5.15717 13.3705 5.21965 13.2205C5.28214 13.0705 5.3737 12.9344 5.48906 12.82L15.5444 2.76469C16.034 2.27507 16.6981 2 17.3905 2C18.083 2 18.7471 2.27507 19.2367 2.76469C19.7263 3.25432 20.0014 3.91839 20.0014 4.61083C20.0014 5.30326 19.7263 5.96734 19.2367 6.45696L9.18135 16.5122Z"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5386 8.15574L14 4.61719"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 22L22 22"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : props.activeColor ? props.activeColor : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.5 10.25L33 13.75L36.5 10.25"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AlignLeft = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 3.5H20.5007"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 7.75024H16.5775"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 12.0002H12.6542"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 20.5005H20.5007"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 16.2505H16.5775"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Align = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="40"
      height="24"
      viewBox="0 0 40 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 3.5H20.5007"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 7.75024H16.5775"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 12.0002H12.6542"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 20.5005H20.5007"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 16.2505H16.5775"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.5 10.25L33 13.75L36.5 10.25"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AlignCenter = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 3.5H20.5007"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.46191 7.75024H18.5394"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.42285 12.0002H16.5771"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 20.5005H20.5007"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.46191 16.2505H18.5394"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AlignRight = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.4955 3.5H3.5"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4963 7.75024H7.42285"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4962 12.0002H11.3447"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4955 20.5005H3.5"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4963 16.2505H7.42285"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const AlignJustify = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5007 3.5H3.5"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5007 7.75024H3.5"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5007 12.0002H3.5"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5007 20.5005H3.5"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5007 16.2505H3.5"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const AlignTop = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5007 3.5H3.5"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3536 6.14571C12.1583 5.95045 11.8417 5.95045 11.6464 6.14571L8.46447 9.32769C8.2692 9.52296 8.2692 9.83954 8.46447 10.0348C8.65973 10.2301 8.97631 10.2301 9.17157 10.0348L12 7.20637L14.8284 10.0348C15.0237 10.2301 15.3403 10.2301 15.5355 10.0348C15.7308 9.83954 15.7308 9.52296 15.5355 9.32769L12.3536 6.14571ZM11.5 20.5C11.5 20.7761 11.7239 21 12 21C12.2761 21 12.5 20.7761 12.5 20.5H11.5ZM11.5 6.49927V20.5H12.5V6.49927H11.5Z"
        className={"undoIconFill"}
        fill={props.active ? "#01AFFD" : "#585858"}
      />
    </svg>
  );
};
export const AlignVerticalCenter = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5007 12H3.5"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3536 14.6464C12.1583 14.4512 11.8417 14.4512 11.6464 14.6464L8.46447 17.8284C8.2692 18.0237 8.2692 18.3403 8.46447 18.5355C8.65973 18.7308 8.97631 18.7308 9.17157 18.5355L12 15.7071L14.8284 18.5355C15.0237 18.7308 15.3403 18.7308 15.5355 18.5355C15.7308 18.3403 15.7308 18.0237 15.5355 17.8284L12.3536 14.6464ZM11.5 22.5C11.5 22.7761 11.7239 23 12 23C12.2761 23 12.5 22.7761 12.5 22.5H11.5ZM11.5 15V22.5H12.5V15H11.5Z"
        className={"undoIconFill"}
        fill={props.active ? "#01AFFD" : "#585858"}
      />
      <path
        d="M12.3536 9.35355C12.1583 9.54882 11.8417 9.54882 11.6464 9.35355L8.46447 6.17157C8.2692 5.97631 8.2692 5.65973 8.46447 5.46447C8.65973 5.2692 8.97631 5.2692 9.17157 5.46447L12 8.29289L14.8284 5.46447C15.0237 5.2692 15.3403 5.2692 15.5355 5.46447C15.7308 5.65973 15.7308 5.97631 15.5355 6.17157L12.3536 9.35355ZM11.5 1.5C11.5 1.22386 11.7239 1 12 1C12.2761 1 12.5 1.22386 12.5 1.5H11.5ZM11.5 9V1.5H12.5V9H11.5Z"
        className={"undoIconFill"}
        fill={props.active ? "#01AFFD" : "#585858"}
      />
    </svg>
  );
};
export const AlignBottom = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.49966 19.9999C3.22352 19.9999 2.99966 20.2237 2.99966 20.4999C2.99966 20.776 3.22352 20.9999 3.49966 20.9999V19.9999ZM20.5004 20.9999C20.7765 20.9999 21.0004 20.776 21.0004 20.4999C21.0004 20.2237 20.7765 19.9999 20.5004 19.9999V20.9999ZM11.6468 17.8541C11.8421 18.0494 12.1586 18.0494 12.3539 17.8541L15.5359 14.6721C15.7312 14.4769 15.7312 14.1603 15.5359 13.965C15.3406 13.7698 15.024 13.7698 14.8288 13.965L12.0004 16.7935L9.17193 13.965C8.97667 13.7698 8.66008 13.7698 8.46482 13.965C8.26956 14.1603 8.26956 14.4769 8.46482 14.6721L11.6468 17.8541ZM12.5004 3.49988C12.5004 3.22374 12.2765 2.99988 12.0004 2.99988C11.7242 2.99988 11.5004 3.22374 11.5004 3.49988H12.5004ZM3.49966 20.9999H20.5004V19.9999H3.49966V20.9999ZM12.5004 17.5006V3.49988H11.5004V17.5006H12.5004Z"
        className={"undoIconFill"}
        fill={props.active ? "#01AFFD" : "#585858"}
      />
    </svg>
  );
};

export const BorderSolid = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="39"
      height="20"
      viewBox="0 0 39 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 10H33"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeLinecap="round"
      />
    </svg>
  );
};
export const BorderDotted = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="39"
      className={"undoIcon"}
      height="20"
      viewBox="0 0 39 20"
      fill={props.active ? "#01AFFD" : "#585858"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 10H33"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="1 4"
      />
    </svg>
  );
};
export const BorderDashed = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="39"
      height="20"
      viewBox="0 0 39 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 10H33"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="4 8"
      />
    </svg>
  );
};
export const BorderDottedDashed = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="39"
      height="20"
      viewBox="0 0 39 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 9.51115C0.723858 9.51115 0.5 9.73501 0.5 10.0112C0.5 10.2873 0.723858 10.5112 1 10.5112V9.51115ZM12 10.5112C12.2761 10.5112 12.5 10.2873 12.5 10.0112C12.5 9.73501 12.2761 9.51115 12 9.51115V10.5112ZM15.5 10.0111C15.5 9.73492 15.2761 9.51106 15 9.51106C14.7239 9.51106 14.5 9.73492 14.5 10.0111H15.5ZM14.5 10.014C14.5 10.2901 14.7239 10.514 15 10.514C15.2761 10.514 15.5 10.2901 15.5 10.014H14.5ZM17.9994 9.5C17.7232 9.50035 17.4996 9.72449 17.5 10.0006C17.5004 10.2768 17.7245 10.5004 18.0006 10.5L17.9994 9.5ZM29.0006 10.486C29.2768 10.4857 29.5004 10.2615 29.5 9.98539C29.4996 9.70925 29.2755 9.48567 28.9994 9.48602L29.0006 10.486ZM33 9.98602C33 9.70988 32.7761 9.48602 32.5 9.48602C32.2239 9.48602 32 9.70988 32 9.98602H33ZM32 9.98895C32 10.2651 32.2239 10.489 32.5 10.489C32.7761 10.489 33 10.2651 33 9.98895H32ZM1 10.5112H12V9.51115H1V10.5112ZM14.5 10.0111V10.014H15.5V10.0111H14.5ZM18.0006 10.5L29.0006 10.486L28.9994 9.48602L17.9994 9.5L18.0006 10.5ZM32 9.98602V9.98895H33V9.98602H32Z"
        className={"undoIcoFill"}
        fill={props.active ? "#01AFFD" : "#585858"}
      />
    </svg>
  );
};
export const BulletedList1 = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="50"
      height="58"
      viewBox="0 0 50 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="49" height="57" rx="3.5" fill="white" />
      <circle cx="9" cy="9" r="3" fill={props.active ? "#01AFFD" : "#000000"} />
      <circle cx="9" cy="49" r="3" fill={props.active ? "#01AFFD" : "#000000"} />
      <circle cx="18" cy="19" r="2" stroke={props.active ? "#01AFFD" : "#000000"} strokeWidth="2" />
      <circle cx="18" cy="29" r="2" stroke={props.active ? "#01AFFD" : "#000000"} strokeWidth="2" />
      <path
        d="M15 9H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M15 49H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24 19H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24 29H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M33 39L43 39"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <mask id="path-11-inside-1_442_9044" fill="white">
        <rect x="24" y="36" width="6" height="6" rx="0.5" />
      </mask>
      <rect
        x="24"
        y="36"
        width="6"
        height="6"
        rx="0.5"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="4"
        strokeLinejoin="round"
        mask="url(#path-11-inside-1_442_9044)"
      />
      <rect
        x="0.5"
        y="0.5"
        width="49"
        height="57"
        rx="3.5"
        stroke={props.active ? "#01AFFD" : "#000000"}
      />
    </svg>
  );
};
export const BulletedList2 = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="50"
      height="58"
      viewBox="0 0 50 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="49" height="57" rx="3.5" fill="white" />
      <path
        d="M15 9H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M15 49H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24 19H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24 29H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M33 39L43 39"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <rect
        x="24"
        y="36"
        width="6"
        height="6"
        rx="0.5"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <rect
        x="9.50012"
        y="5.5"
        width="2.402"
        height="2.402"
        rx="0.5"
        transform="rotate(45 9.50012 5.5)"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <rect
        x="9.50012"
        y="9.10303"
        width="2.402"
        height="2.402"
        rx="0.5"
        transform="rotate(45 9.50012 9.10303)"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <rect
        x="7.5"
        y="7.30164"
        width="2.402"
        height="2.402"
        rx="0.5"
        transform="rotate(45 7.5 7.30164)"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <rect
        x="11.5"
        y="7.30164"
        width="2.402"
        height="2.402"
        rx="0.5"
        transform="rotate(45 11.5 7.30164)"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <rect
        x="9.50012"
        y="45.5"
        width="2.402"
        height="2.402"
        rx="0.5"
        transform="rotate(45 9.50012 45.5)"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <rect
        x="9.50012"
        y="49.103"
        width="2.402"
        height="2.402"
        rx="0.5"
        transform="rotate(45 9.50012 49.103)"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <rect
        x="7.5"
        y="47.3016"
        width="2.402"
        height="2.402"
        rx="0.5"
        transform="rotate(45 7.5 47.3016)"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <rect
        x="11.5"
        y="47.3016"
        width="2.402"
        height="2.402"
        rx="0.5"
        transform="rotate(45 11.5 47.3016)"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M20.2239 18.806C20.4259 18.8565 20.4259 19.1435 20.2239 19.194L11.8482 21.2879C11.642 21.3395 11.5084 21.0763 11.6717 20.9403L13.8156 19.1536C13.9116 19.0737 13.9116 18.9263 13.8156 18.8464L11.6717 17.0597C11.5084 16.9237 11.642 16.6605 11.8482 16.7121L20.2239 18.806Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8876 19C13.8876 19.0568 13.8636 19.1137 13.8157 19.1536L11.6717 20.9403C11.5084 21.0763 11.642 21.3395 11.8482 21.2879L20.2239 19.194C20.3249 19.1688 20.3754 19.0844 20.3754 19H13.8876Z"
        className={"undoIcoFill"}
        fill="#979797"
      />
      <path
        d="M20.2239 28.806C20.4259 28.8565 20.4259 29.1435 20.2239 29.194L11.8482 31.2879C11.642 31.3395 11.5084 31.0763 11.6717 30.9403L13.8156 29.1536C13.9116 29.0737 13.9116 28.9263 13.8156 28.8464L11.6717 27.0597C11.5084 26.9237 11.642 26.6605 11.8482 26.7121L20.2239 28.806Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8876 29C13.8876 29.0568 13.8636 29.1137 13.8157 29.1536L11.6717 30.9403C11.5084 31.0763 11.642 31.3395 11.8482 31.2879L20.2239 29.194C20.3249 29.1688 20.3754 29.0844 20.3754 29H13.8876Z"
        className={"undoIcoFill"}
        fill="#979797"
      />
      <rect
        x="0.5"
        y="0.5"
        width="49"
        height="57"
        rx="3.5"
        stroke={props.active ? "#01AFFD" : "#000000"}
      />
    </svg>
  );
};
export const BulletedList3 = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="50"
      height="58"
      viewBox="0 0 50 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="49" height="57" rx="3.5" fill="white" />
      <path
        d="M15 9H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M15 49H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24 19H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24 29H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M33 39L43 39"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <rect
        x="6.59998"
        y="6.59998"
        width="5.4"
        height="5.4"
        rx="0.5"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <rect
        x="6"
        y="6"
        width="4.8"
        height="4.8"
        rx="0.5"
        fill="white"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeLinejoin="round"
      />
      <rect
        x="15.6"
        y="16.6"
        width="5.4"
        height="5.4"
        rx="0.5"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <rect
        x="15"
        y="16"
        width="4.8"
        height="4.8"
        rx="0.5"
        fill="white"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeLinejoin="round"
      />
      <rect
        x="15.6"
        y="26.6"
        width="5.4"
        height="5.4"
        rx="0.5"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <rect
        x="15"
        y="26"
        width="4.8"
        height="4.8"
        rx="0.5"
        fill="white"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeLinejoin="round"
      />
      <rect
        x="24.6"
        y="36.6"
        width="5.4"
        height="5.4"
        rx="0.5"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <rect
        x="24"
        y="36"
        width="4.8"
        height="4.8"
        rx="0.5"
        fill="white"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeLinejoin="round"
      />
      <rect
        x="6.59998"
        y="46.6"
        width="5.4"
        height="5.4"
        rx="0.5"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <rect
        x="6"
        y="46"
        width="4.8"
        height="4.8"
        rx="0.5"
        fill="white"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeLinejoin="round"
      />
      <rect
        x="0.5"
        y="0.5"
        width="49"
        height="57"
        rx="3.5"
        stroke={props.active ? "#01AFFD" : "#000000"}
      />
    </svg>
  );
};
export const BulletedList4 = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="50"
      height="58"
      viewBox="0 0 50 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="49" height="57" rx="3.5" fill="white" />
      <circle cx="27" cy="39" r="3" fill={props.active ? "#01AFFD" : "#000000"} />
      <path
        d="M15 9H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M15 49H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24 19H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24 29H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M33 39L43 39"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M5 9H11M11 9L9 7M11 9L9 11"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 49H11M11 49L9 47M11 49L9 51"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.1934 15.627C17.3627 15.4577 17.6373 15.4577 17.8066 15.627L20.873 18.6934C21.0423 18.8627 21.0423 19.1373 20.873 19.3066L17.8066 22.373C17.6373 22.5423 17.3627 22.5423 17.1934 22.373L14.127 19.3066C13.9577 19.1373 13.9577 18.8627 14.127 18.6934L17.1934 15.627Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M17.1934 25.627C17.3627 25.4577 17.6373 25.4577 17.8066 25.627L20.873 28.6934C21.0423 28.8627 21.0423 29.1373 20.873 29.3066L17.8066 32.373C17.6373 32.5423 17.3627 32.5423 17.1934 32.373L14.127 29.3066C13.9577 29.1373 13.9577 28.8627 14.127 28.6934L17.1934 25.627Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <rect
        x="0.5"
        y="0.5"
        width="49"
        height="57"
        rx="3.5"
        stroke={props.active ? "#01AFFD" : "#000000"}
      />
    </svg>
  );
};
export const BulletedList5 = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="50"
      height="58"
      viewBox="0 0 50 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="49" height="57" rx="3.5" fill="white" />
      <circle cx="18" cy="19" r="2" stroke={props.active ? "#01AFFD" : "#000000"} strokeWidth="2" />
      <circle cx="18" cy="29" r="2" stroke={props.active ? "#01AFFD" : "#000000"} strokeWidth="2" />
      <path
        d="M15 9H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M15 49H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24 19H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24 29H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M33 39L43 39"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <rect
        x="24"
        y="36"
        width="6"
        height="6"
        rx="0.5"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M7.90489 5.2927C7.93483 5.20057 8.06517 5.20057 8.09511 5.29271L8.8756 7.69483C8.88899 7.73604 8.92739 7.76393 8.97071 7.76393H11.4965C11.5933 7.76393 11.6336 7.88789 11.5552 7.94483L9.51186 9.42943C9.47681 9.4549 9.46215 9.50003 9.47554 9.54123L10.256 11.9434C10.286 12.0355 10.1805 12.1121 10.1022 12.0552L8.05878 10.5706C8.02373 10.5451 7.97627 10.5451 7.94122 10.5706L5.89785 12.0552C5.81948 12.1121 5.71403 12.0355 5.74396 11.9434L6.52446 9.54123C6.53785 9.50003 6.52319 9.4549 6.48814 9.42943L4.44476 7.94483C4.36639 7.88789 4.40667 7.76393 4.50354 7.76393H7.02929C7.07261 7.76393 7.11101 7.73604 7.1244 7.69483L7.90489 5.2927Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M7.90489 45.2927C7.93483 45.2006 8.06517 45.2006 8.09511 45.2927L8.8756 47.6948C8.88899 47.736 8.92739 47.7639 8.97071 47.7639H11.4965C11.5933 47.7639 11.6336 47.8879 11.5552 47.9448L9.51186 49.4294C9.47681 49.4549 9.46215 49.5 9.47554 49.5412L10.256 51.9434C10.286 52.0355 10.1805 52.1121 10.1022 52.0552L8.05878 50.5706C8.02373 50.5451 7.97627 50.5451 7.94122 50.5706L5.89785 52.0552C5.81948 52.1121 5.71403 52.0355 5.74396 51.9434L6.52446 49.5412C6.53785 49.5 6.52319 49.4549 6.48814 49.4294L4.44476 47.9448C4.36639 47.8879 4.40667 47.7639 4.50354 47.7639H7.02929C7.07261 47.7639 7.11101 47.736 7.1244 47.6948L7.90489 45.2927Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <rect
        x="0.5"
        y="0.5"
        width="49"
        height="57"
        rx="3.5"
        stroke={props.active ? "#01AFFD" : "#000000"}
      />
    </svg>
  );
};
export const BulletedList6 = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="50"
      height="58"
      viewBox="0 0 50 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="49" height="57" rx="3.5" fill="white" />
      <circle cx="18" cy="19" r="2" stroke={props.active ? "#01AFFD" : "#000000"} strokeWidth="2" />
      <circle cx="18" cy="29" r="2" stroke={props.active ? "#01AFFD" : "#000000"} strokeWidth="2" />
      <path
        d="M18 9H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M18 49H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24 19H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24 29H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M33 39L43 39"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <rect
        x="24"
        y="36"
        width="6"
        height="6"
        rx="0.5"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M14.2239 8.80597C14.4259 8.85647 14.4259 9.14353 14.2239 9.19403L5.84822 11.2879C5.64201 11.3395 5.50838 11.0763 5.67167 10.9403L7.81563 9.15364C7.91158 9.07369 7.91158 8.92631 7.81563 8.84636L5.67167 7.05973C5.50838 6.92365 5.64201 6.6605 5.84822 6.71205L14.2239 8.80597Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.88762 9C7.88762 9.05683 7.86363 9.11366 7.81565 9.15364L5.6717 10.9403C5.50841 11.0763 5.64203 11.3395 5.84824 11.2879L14.2239 9.19403C14.3249 9.16878 14.3754 9.08439 14.3754 9H7.88762Z"
        className={"undoIcoFill"}
        fill="#979797"
      />
      <path
        d="M14.2239 48.806C14.4259 48.8565 14.4259 49.1435 14.2239 49.194L5.84822 51.2879C5.64201 51.3395 5.50838 51.0763 5.67167 50.9403L7.81563 49.1536C7.91158 49.0737 7.91158 48.9263 7.81563 48.8464L5.67167 47.0597C5.50838 46.9237 5.64201 46.6605 5.84822 46.7121L14.2239 48.806Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.88762 49C7.88762 49.0568 7.86363 49.1137 7.81565 49.1536L5.6717 50.9403C5.50841 51.0763 5.64203 51.3395 5.84824 51.2879L14.2239 49.194C14.3249 49.1688 14.3754 49.0844 14.3754 49H7.88762Z"
        className={"undoIcoFill"}
        fill="#979797"
      />
      <rect
        x="0.5"
        y="0.5"
        width="49"
        height="57"
        rx="3.5"
        stroke={props.active ? "#01AFFD" : "#000000"}
      />
    </svg>
  );
};
export const NumberedList1 = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="50"
      height="58"
      viewBox="0 0 50 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="49" height="57" rx="3.5" fill="white" />
      <path
        d="M15 9H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M15 49H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24 19H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24 29H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M33 39L43 39"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M8.06072 6.18182V12H6.65732V7.49432H6.62322L5.32209 8.28977V7.07386L6.75675 6.18182H8.06072ZM9.84268 12.0824C9.63814 12.0824 9.46295 12.0104 9.31712 11.8665C9.17318 11.7225 9.10215 11.5483 9.10405 11.3438C9.10215 11.143 9.17318 10.9716 9.31712 10.8295C9.46295 10.6856 9.63814 10.6136 9.84268 10.6136C10.0359 10.6136 10.2063 10.6856 10.354 10.8295C10.5037 10.9716 10.5794 11.143 10.5813 11.3438C10.5794 11.4801 10.5434 11.6042 10.4734 11.7159C10.4052 11.8277 10.3152 11.9167 10.2035 11.983C10.0936 12.0492 9.97337 12.0824 9.84268 12.0824Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M5.65945 52V50.9886L7.78161 49.1307C7.9407 48.9867 8.07611 48.8551 8.18786 48.7358C8.2996 48.6146 8.38482 48.4934 8.44354 48.3722C8.50225 48.2491 8.53161 48.1155 8.53161 47.9716C8.53161 47.8106 8.49657 47.6733 8.42649 47.5597C8.35642 47.4441 8.25982 47.3551 8.13672 47.2926C8.01361 47.2301 7.87251 47.1989 7.71342 47.1989C7.55244 47.1989 7.41134 47.232 7.29013 47.2983C7.16892 47.3627 7.07422 47.4564 7.00604 47.5795C6.93975 47.7027 6.90661 47.8523 6.90661 48.0284H5.57422C5.57422 47.6326 5.66323 47.2907 5.84126 47.0028C6.01929 46.715 6.26929 46.4934 6.59126 46.3381C6.91513 46.1809 7.29107 46.1023 7.71911 46.1023C8.16039 46.1023 8.54392 46.1761 8.86967 46.3239C9.19543 46.4716 9.44732 46.678 9.62536 46.9432C9.80528 47.2064 9.89524 47.5123 9.89524 47.8608C9.89524 48.0824 9.85073 48.3021 9.76172 48.5199C9.6727 48.7377 9.51267 48.9782 9.28161 49.2415C9.05244 49.5047 8.72668 49.8201 8.30433 50.1875L7.60831 50.8295V50.8665H9.96626V52H5.65945ZM11.5536 52.0824C11.3491 52.0824 11.1739 52.0104 11.0281 51.8665C10.8841 51.7225 10.8131 51.5483 10.815 51.3438C10.8131 51.143 10.8841 50.9716 11.0281 50.8295C11.1739 50.6856 11.3491 50.6136 11.5536 50.6136C11.7468 50.6136 11.9173 50.6856 12.065 50.8295C12.2146 50.9716 12.2904 51.143 12.2923 51.3438C12.2904 51.4801 12.2544 51.6042 12.1843 51.7159C12.1161 51.8277 12.0262 51.9167 11.9144 51.983C11.8046 52.0492 11.6843 52.0824 11.5536 52.0824Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M15.108 21.0739C14.8295 21.0739 14.5824 21.0275 14.3665 20.9347C14.1525 20.84 13.983 20.6979 13.858 20.5085C13.7348 20.3172 13.6733 20.0777 13.6733 19.7898C13.6733 19.5473 13.7159 19.3428 13.8011 19.1761C13.8864 19.0095 14.0038 18.8741 14.1534 18.7699C14.303 18.6657 14.4754 18.5871 14.6705 18.5341C14.8655 18.4792 15.0739 18.4422 15.2955 18.4233C15.5436 18.4006 15.7434 18.3769 15.8949 18.3523C16.0464 18.3258 16.1563 18.2888 16.2244 18.2415C16.2945 18.1922 16.3295 18.1231 16.3295 18.0341V18.0199C16.3295 17.8741 16.2794 17.7614 16.179 17.6818C16.0786 17.6023 15.9432 17.5625 15.7727 17.5625C15.589 17.5625 15.4413 17.6023 15.3295 17.6818C15.2178 17.7614 15.1468 17.8712 15.1165 18.0114L13.8352 17.9659C13.8731 17.7008 13.9706 17.464 14.1278 17.2557C14.2869 17.0455 14.5047 16.8807 14.7812 16.7614C15.0597 16.6402 15.3939 16.5795 15.7841 16.5795C16.0625 16.5795 16.3191 16.6127 16.554 16.679C16.7888 16.7434 16.9934 16.8381 17.1676 16.9631C17.3419 17.0862 17.4763 17.2377 17.571 17.4176C17.6676 17.5975 17.7159 17.803 17.7159 18.0341V21H16.4091V20.392H16.375C16.2973 20.5398 16.1979 20.6648 16.0767 20.767C15.9574 20.8693 15.8163 20.946 15.6534 20.9972C15.4924 21.0483 15.3106 21.0739 15.108 21.0739ZM15.5369 20.1648C15.6866 20.1648 15.821 20.1345 15.9403 20.0739C16.0616 20.0133 16.1581 19.9299 16.2301 19.8239C16.3021 19.7159 16.3381 19.5909 16.3381 19.4489V19.0341C16.2983 19.0549 16.25 19.0739 16.1932 19.0909C16.1383 19.108 16.0777 19.1241 16.0114 19.1392C15.9451 19.1544 15.8769 19.1676 15.8068 19.179C15.7367 19.1903 15.6695 19.2008 15.6051 19.2102C15.4744 19.2311 15.3627 19.2633 15.2699 19.3068C15.179 19.3504 15.1089 19.4072 15.0597 19.4773C15.0123 19.5455 14.9886 19.6269 14.9886 19.7216C14.9886 19.8655 15.0398 19.9754 15.142 20.0511C15.2462 20.1269 15.3778 20.1648 15.5369 20.1648ZM19.3466 21.0824C19.142 21.0824 18.9669 21.0104 18.821 20.8665C18.6771 20.7225 18.6061 20.5483 18.608 20.3438C18.6061 20.143 18.6771 19.9716 18.821 19.8295C18.9669 19.6856 19.142 19.6136 19.3466 19.6136C19.5398 19.6136 19.7102 19.6856 19.858 19.8295C20.0076 19.9716 20.0833 20.143 20.0852 20.3438C20.0833 20.4801 20.0473 20.6042 19.9773 20.7159C19.9091 20.8277 19.8191 20.9167 19.7074 20.983C19.5975 21.0492 19.4773 21.0824 19.3466 21.0824Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M13.663 32V26.1818H15.0522V28.3835H15.0806C15.1374 28.2509 15.2179 28.1231 15.3221 28C15.4281 27.8769 15.5626 27.7765 15.7255 27.6989C15.8903 27.6193 16.0872 27.5795 16.3164 27.5795C16.6194 27.5795 16.9026 27.6591 17.1658 27.8182C17.431 27.9773 17.645 28.2225 17.8079 28.554C17.9708 28.8854 18.0522 29.3078 18.0522 29.821C18.0522 30.3153 17.9736 30.7292 17.8164 31.0625C17.6611 31.3958 17.4509 31.6458 17.1857 31.8125C16.9225 31.9792 16.6299 32.0625 16.3079 32.0625C16.0882 32.0625 15.8978 32.0265 15.7369 31.9545C15.5759 31.8826 15.4405 31.7879 15.3306 31.6705C15.2227 31.553 15.1393 31.4271 15.0806 31.2926H15.038V32H13.663ZM15.0238 29.8182C15.0238 30.053 15.055 30.2576 15.1175 30.4318C15.1819 30.6061 15.2738 30.7415 15.3931 30.8381C15.5143 30.9328 15.6592 30.9801 15.8278 30.9801C15.9982 30.9801 16.1431 30.9328 16.2624 30.8381C16.3817 30.7415 16.4717 30.6061 16.5323 30.4318C16.5948 30.2576 16.6261 30.053 16.6261 29.8182C16.6261 29.5833 16.5948 29.3797 16.5323 29.2074C16.4717 29.035 16.3817 28.9015 16.2624 28.8068C16.145 28.7121 16.0001 28.6648 15.8278 28.6648C15.6573 28.6648 15.5124 28.7112 15.3931 28.804C15.2738 28.8968 15.1819 29.0294 15.1175 29.2017C15.055 29.3741 15.0238 29.5795 15.0238 29.8182ZM19.5614 32.0824C19.3569 32.0824 19.1817 32.0104 19.0359 31.8665C18.8919 31.7225 18.8209 31.5483 18.8228 31.3438C18.8209 31.143 18.8919 30.9716 19.0359 30.8295C19.1817 30.6856 19.3569 30.6136 19.5614 30.6136C19.7546 30.6136 19.9251 30.6856 20.0728 30.8295C20.2224 30.9716 20.2982 31.143 20.3001 31.3438C20.2982 31.4801 20.2622 31.6042 20.1921 31.7159C20.1239 31.8277 20.034 31.9167 19.9222 31.983C19.8124 32.0492 19.6921 32.0824 19.5614 32.0824Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M24.0849 42V37.6364H25.4741V42H24.0849ZM24.7809 37.1278C24.5858 37.1278 24.4182 37.0634 24.2781 36.9347C24.1379 36.804 24.0678 36.6468 24.0678 36.4631C24.0678 36.2812 24.1379 36.1259 24.2781 35.9972C24.4182 35.8665 24.5858 35.8011 24.7809 35.8011C24.9779 35.8011 25.1455 35.8665 25.2837 35.9972C25.4239 36.1259 25.494 36.2812 25.494 36.4631C25.494 36.6468 25.4239 36.804 25.2837 36.9347C25.1455 37.0634 24.9779 37.1278 24.7809 37.1278ZM27.1396 42.0824C26.935 42.0824 26.7598 42.0104 26.614 41.8665C26.4701 41.7225 26.399 41.5483 26.4009 41.3438C26.399 41.143 26.4701 40.9716 26.614 40.8295C26.7598 40.6856 26.935 40.6136 27.1396 40.6136C27.3327 40.6136 27.5032 40.6856 27.6509 40.8295C27.8005 40.9716 27.8763 41.143 27.8782 41.3438C27.8763 41.4801 27.8403 41.6042 27.7702 41.7159C27.7021 41.8277 27.6121 41.9167 27.5004 41.983C27.3905 42.0492 27.2702 42.0824 27.1396 42.0824Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <rect
        x="0.5"
        y="0.5"
        width="49"
        height="57"
        rx="3.5"
        stroke={props.active ? "#01AFFD" : "#000000"}
      />
    </svg>
  );
};
export const NumberedList2 = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="50"
      height="58"
      viewBox="0 0 50 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="49" height="57" rx="3.5" fill="white" />
      <path
        d="M15 9H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M15 49H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24 19H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24 29H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M33 39L43 39"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M7.43182 6.18182V12H6.02841V7.49432H5.99432L4.69318 8.28977V7.07386L6.12784 6.18182H7.43182ZM10.9709 9.09091C10.9709 9.79167 10.8762 10.4375 10.6868 11.0284C10.4974 11.6174 10.2019 12.1648 9.80043 12.6705H8.45384C8.60724 12.483 8.74834 12.2547 8.87713 11.9858C9.00781 11.7169 9.1205 11.4223 9.2152 11.1023C9.31179 10.7822 9.3866 10.4508 9.43963 10.108C9.49455 9.76515 9.52202 9.42614 9.52202 9.09091C9.52202 8.64205 9.47562 8.19034 9.38281 7.7358C9.29001 7.27936 9.16312 6.85701 9.00213 6.46875C8.84115 6.0786 8.65838 5.75852 8.45384 5.50852H9.80043C10.2019 6.0142 10.4974 6.5625 10.6868 7.15341C10.8762 7.74242 10.9709 8.38826 10.9709 9.09091Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M4.67898 52V50.9886L6.80114 49.1307C6.96023 48.9867 7.09564 48.8551 7.20739 48.7358C7.31913 48.6146 7.40436 48.4934 7.46307 48.3722C7.52178 48.2491 7.55114 48.1155 7.55114 47.9716C7.55114 47.8106 7.5161 47.6733 7.44602 47.5597C7.37595 47.4441 7.27936 47.3551 7.15625 47.2926C7.03314 47.2301 6.89205 47.1989 6.73295 47.1989C6.57197 47.1989 6.43087 47.232 6.30966 47.2983C6.18845 47.3627 6.09375 47.4564 6.02557 47.5795C5.95928 47.7027 5.92614 47.8523 5.92614 48.0284H4.59375C4.59375 47.6326 4.68277 47.2907 4.8608 47.0028C5.03883 46.715 5.28883 46.4934 5.6108 46.3381C5.93466 46.1809 6.31061 46.1023 6.73864 46.1023C7.17992 46.1023 7.56345 46.1761 7.8892 46.3239C8.21496 46.4716 8.46686 46.678 8.64489 46.9432C8.82481 47.2064 8.91477 47.5123 8.91477 47.8608C8.91477 48.0824 8.87027 48.3021 8.78125 48.5199C8.69223 48.7377 8.5322 48.9782 8.30114 49.2415C8.07197 49.5047 7.74621 49.8201 7.32386 50.1875L6.62784 50.8295V50.8665H8.9858V52H4.67898ZM12.0334 49.0909C12.0334 49.7917 11.9387 50.4375 11.7493 51.0284C11.5599 51.6174 11.2644 52.1648 10.8629 52.6705H9.51634C9.66974 52.483 9.81084 52.2547 9.93963 51.9858C10.0703 51.7169 10.183 51.4223 10.2777 51.1023C10.3743 50.7822 10.4491 50.4508 10.5021 50.108C10.5571 49.7652 10.5845 49.4261 10.5845 49.0909C10.5845 48.642 10.5381 48.1903 10.4453 47.7358C10.3525 47.2794 10.2256 46.857 10.0646 46.4688C9.90365 46.0786 9.72088 45.7585 9.51634 45.5085H10.8629C11.2644 46.0142 11.5599 46.5625 11.7493 47.1534C11.9387 47.7424 12.0334 48.3883 12.0334 49.0909Z"
        className={"undoIcoFill"}
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M15.1275 21.0739C14.8491 21.0739 14.6019 21.0275 14.386 20.9347C14.172 20.84 14.0025 20.6979 13.8775 20.5085C13.7544 20.3172 13.6928 20.0777 13.6928 19.7898C13.6928 19.5473 13.7354 19.3428 13.8207 19.1761C13.9059 19.0095 14.0233 18.8741 14.1729 18.7699C14.3226 18.6657 14.4949 18.5871 14.69 18.5341C14.8851 18.4792 15.0934 18.4422 15.315 18.4233C15.5631 18.4006 15.7629 18.3769 15.9144 18.3523C16.0659 18.3258 16.1758 18.2888 16.244 18.2415C16.314 18.1922 16.3491 18.1231 16.3491 18.0341V18.0199C16.3491 17.8741 16.2989 17.7614 16.1985 17.6818C16.0981 17.6023 15.9627 17.5625 15.7923 17.5625C15.6085 17.5625 15.4608 17.6023 15.3491 17.6818C15.2373 17.7614 15.1663 17.8712 15.136 18.0114L13.8548 17.9659C13.8926 17.7008 13.9902 17.464 14.1474 17.2557C14.3065 17.0455 14.5243 16.8807 14.8008 16.7614C15.0792 16.6402 15.4135 16.5795 15.8036 16.5795C16.082 16.5795 16.3387 16.6127 16.5735 16.679C16.8084 16.7434 17.0129 16.8381 17.1871 16.9631C17.3614 17.0862 17.4959 17.2377 17.5906 17.4176C17.6871 17.5975 17.7354 17.803 17.7354 18.0341V21H16.4286V20.392H16.3945C16.3169 20.5398 16.2174 20.6648 16.0962 20.767C15.9769 20.8693 15.8358 20.946 15.6729 20.9972C15.512 21.0483 15.3301 21.0739 15.1275 21.0739ZM15.5565 20.1648C15.7061 20.1648 15.8406 20.1345 15.9599 20.0739C16.0811 20.0133 16.1777 19.9299 16.2496 19.8239C16.3216 19.7159 16.3576 19.5909 16.3576 19.4489V19.0341C16.3178 19.0549 16.2695 19.0739 16.2127 19.0909C16.1578 19.108 16.0972 19.1241 16.0309 19.1392C15.9646 19.1544 15.8964 19.1676 15.8263 19.179C15.7563 19.1903 15.689 19.2008 15.6246 19.2102C15.494 19.2311 15.3822 19.2633 15.2894 19.3068C15.1985 19.3504 15.1284 19.4072 15.0792 19.4773C15.0318 19.5455 15.0082 19.6269 15.0082 19.7216C15.0082 19.8655 15.0593 19.9754 15.1616 20.0511C15.2657 20.1269 15.3974 20.1648 15.5565 20.1648ZM20.8263 18.7102C20.8263 19.411 20.7317 20.0568 20.5423 20.6477C20.3529 21.2367 20.0574 21.7841 19.6559 22.2898H18.3093C18.4627 22.1023 18.6038 21.8741 18.7326 21.6051C18.8633 21.3362 18.976 21.0417 19.0707 20.7216C19.1673 20.4015 19.2421 20.0701 19.2951 19.7273C19.35 19.3845 19.3775 19.0455 19.3775 18.7102C19.3775 18.2614 19.3311 17.8097 19.2383 17.3551C19.1455 16.8987 19.0186 16.4763 18.8576 16.0881C18.6966 15.6979 18.5138 15.3778 18.3093 15.1278H19.6559C20.0574 15.6335 20.3529 16.1818 20.5423 16.7727C20.7317 17.3617 20.8263 18.0076 20.8263 18.7102Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M13.7372 32V26.1818H15.1264V28.3835H15.1548C15.2116 28.2509 15.2921 28.1231 15.3963 28C15.5024 27.8769 15.6368 27.7765 15.7997 27.6989C15.9645 27.6193 16.1615 27.5795 16.3906 27.5795C16.6937 27.5795 16.9768 27.6591 17.2401 27.8182C17.5052 27.9773 17.7192 28.2225 17.8821 28.554C18.045 28.8854 18.1264 29.3078 18.1264 29.821C18.1264 30.3153 18.0478 30.7292 17.8906 31.0625C17.7353 31.3958 17.5251 31.6458 17.2599 31.8125C16.9967 31.9792 16.7041 32.0625 16.3821 32.0625C16.1624 32.0625 15.9721 32.0265 15.8111 31.9545C15.6501 31.8826 15.5147 31.7879 15.4048 31.6705C15.2969 31.553 15.2135 31.4271 15.1548 31.2926H15.1122V32H13.7372ZM15.098 29.8182C15.098 30.053 15.1293 30.2576 15.1918 30.4318C15.2562 30.6061 15.348 30.7415 15.4673 30.8381C15.5885 30.9328 15.7334 30.9801 15.902 30.9801C16.0724 30.9801 16.2173 30.9328 16.3366 30.8381C16.456 30.7415 16.5459 30.6061 16.6065 30.4318C16.669 30.2576 16.7003 30.053 16.7003 29.8182C16.7003 29.5833 16.669 29.3797 16.6065 29.2074C16.5459 29.035 16.456 28.9015 16.3366 28.8068C16.2192 28.7121 16.0743 28.6648 15.902 28.6648C15.7315 28.6648 15.5866 28.7112 15.4673 28.804C15.348 28.8968 15.2562 29.0294 15.1918 29.2017C15.1293 29.3741 15.098 29.5795 15.098 29.8182ZM20.9865 29.7102C20.9865 30.411 20.8918 31.0568 20.7024 31.6477C20.513 32.2367 20.2176 32.7841 19.8161 33.2898H18.4695C18.6229 33.1023 18.764 32.8741 18.8928 32.6051C19.0234 32.3362 19.1361 32.0417 19.2308 31.7216C19.3274 31.4015 19.4022 31.0701 19.4553 30.7273C19.5102 30.3845 19.5376 30.0455 19.5376 29.7102C19.5376 29.2614 19.4912 28.8097 19.3984 28.3551C19.3056 27.8987 19.1787 27.4763 19.0178 27.0881C18.8568 26.6979 18.674 26.3778 18.4695 26.1278H19.8161C20.2176 26.6335 20.513 27.1818 20.7024 27.7727C20.8918 28.3617 20.9865 29.0076 20.9865 29.7102Z"
        className={"undoIcoFill"}
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M23.4677 42V37.6364H24.8569V42H23.4677ZM24.1637 37.1278C23.9686 37.1278 23.801 37.0634 23.6609 36.9347C23.5207 36.804 23.4506 36.6468 23.4506 36.4631C23.4506 36.2812 23.5207 36.1259 23.6609 35.9972C23.801 35.8665 23.9686 35.8011 24.1637 35.8011C24.3607 35.8011 24.5283 35.8665 24.6665 35.9972C24.8067 36.1259 24.8768 36.2812 24.8768 36.4631C24.8768 36.6468 24.8067 36.804 24.6665 36.9347C24.5283 37.0634 24.3607 37.1278 24.1637 37.1278ZM28.256 39.7102C28.256 40.411 28.1613 41.0568 27.9719 41.6477C27.7826 42.2367 27.4871 42.7841 27.0856 43.2898H25.739C25.8924 43.1023 26.0335 42.8741 26.1623 42.6051C26.293 42.3362 26.4057 42.0417 26.5004 41.7216C26.5969 41.4015 26.6718 41.0701 26.7248 40.7273C26.7797 40.3845 26.8072 40.0455 26.8072 39.7102C26.8072 39.2614 26.7608 38.8097 26.668 38.3551C26.5752 37.8987 26.4483 37.4763 26.2873 37.0881C26.1263 36.6979 25.9435 36.3778 25.739 36.1278H27.0856C27.4871 36.6335 27.7826 37.1818 27.9719 37.7727C28.1613 38.3617 28.256 39.0076 28.256 39.7102Z"
        className={"undoIcoFill"}
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <rect
        x="0.5"
        y="0.5"
        width="49"
        height="57"
        rx="3.5"
        stroke={props.active ? "#01AFFD" : "#000000"}
      />
    </svg>
  );
};
export const NumberedList3 = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="50"
      height="58"
      viewBox="0 0 50 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="49" height="57" rx="3.5" fill="white" />
      <path
        d="M15 9H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M15 49H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24 19H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24 29H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M37 39L43 39"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M8.06072 6.18182V12H6.65732V7.49432H6.62322L5.32209 8.28977V7.07386L6.75675 6.18182H8.06072ZM9.84268 12.0824C9.63814 12.0824 9.46295 12.0104 9.31712 11.8665C9.17318 11.7225 9.10215 11.5483 9.10405 11.3438C9.10215 11.143 9.17318 10.9716 9.31712 10.8295C9.46295 10.6856 9.63814 10.6136 9.84268 10.6136C10.0359 10.6136 10.2063 10.6856 10.354 10.8295C10.5037 10.9716 10.5794 11.143 10.5813 11.3438C10.5794 11.4801 10.5434 11.6042 10.4734 11.7159C10.4052 11.8277 10.3152 11.9167 10.2035 11.983C10.0936 12.0492 9.97337 12.0824 9.84268 12.0824Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M5.65945 52V50.9886L7.78161 49.1307C7.9407 48.9867 8.07611 48.8551 8.18786 48.7358C8.2996 48.6146 8.38482 48.4934 8.44354 48.3722C8.50225 48.2491 8.53161 48.1155 8.53161 47.9716C8.53161 47.8106 8.49657 47.6733 8.42649 47.5597C8.35642 47.4441 8.25982 47.3551 8.13672 47.2926C8.01361 47.2301 7.87251 47.1989 7.71342 47.1989C7.55244 47.1989 7.41134 47.232 7.29013 47.2983C7.16892 47.3627 7.07422 47.4564 7.00604 47.5795C6.93975 47.7027 6.90661 47.8523 6.90661 48.0284H5.57422C5.57422 47.6326 5.66323 47.2907 5.84126 47.0028C6.01929 46.715 6.26929 46.4934 6.59126 46.3381C6.91513 46.1809 7.29107 46.1023 7.71911 46.1023C8.16039 46.1023 8.54392 46.1761 8.86967 46.3239C9.19543 46.4716 9.44732 46.678 9.62536 46.9432C9.80528 47.2064 9.89524 47.5123 9.89524 47.8608C9.89524 48.0824 9.85073 48.3021 9.76172 48.5199C9.6727 48.7377 9.51267 48.9782 9.28161 49.2415C9.05244 49.5047 8.72668 49.8201 8.30433 50.1875L7.60831 50.8295V50.8665H9.96626V52H5.65945ZM11.5536 52.0824C11.3491 52.0824 11.1739 52.0104 11.0281 51.8665C10.8841 51.7225 10.8131 51.5483 10.815 51.3438C10.8131 51.143 10.8841 50.9716 11.0281 50.8295C11.1739 50.6856 11.3491 50.6136 11.5536 50.6136C11.7468 50.6136 11.9173 50.6856 12.065 50.8295C12.2146 50.9716 12.2904 51.143 12.2923 51.3438C12.2904 51.4801 12.2544 51.6042 12.1843 51.7159C12.1161 51.8277 12.0262 51.9167 11.9144 51.983C11.8046 52.0492 11.6843 52.0824 11.5536 52.0824Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M12.3732 15.1818V21H10.9698V16.4943H10.9357L9.63459 17.2898V16.0739L11.0692 15.1818H12.3732ZM14.1552 21.0824C13.9506 21.0824 13.7754 21.0104 13.6296 20.8665C13.4857 20.7225 13.4147 20.5483 13.4165 20.3438C13.4147 20.143 13.4857 19.9716 13.6296 19.8295C13.7754 19.6856 13.9506 19.6136 14.1552 19.6136C14.3484 19.6136 14.5188 19.6856 14.6665 19.8295C14.8162 19.9716 14.8919 20.143 14.8938 20.3438C14.8919 20.4801 14.8559 20.6042 14.7859 20.7159C14.7177 20.8277 14.6277 20.9167 14.516 20.983C14.4061 21.0492 14.2859 21.0824 14.1552 21.0824ZM17.7482 15.1818V21H16.3448V16.4943H16.3107L15.0096 17.2898V16.0739L16.4442 15.1818H17.7482ZM19.5302 21.0824C19.3256 21.0824 19.1504 21.0104 19.0046 20.8665C18.8607 20.7225 18.7897 20.5483 18.7915 20.3438C18.7897 20.143 18.8607 19.9716 19.0046 19.8295C19.1504 19.6856 19.3256 19.6136 19.5302 19.6136C19.7234 19.6136 19.8938 19.6856 20.0415 19.8295C20.1912 19.9716 20.2669 20.143 20.2688 20.3438C20.2669 20.4801 20.2309 20.6042 20.1609 20.7159C20.0927 20.8277 20.0027 20.9167 19.891 20.983C19.7811 21.0492 19.6609 21.0824 19.5302 21.0824Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M11.2912 26.1818V32H9.88778V27.4943H9.85369L8.55256 28.2898V27.0739L9.98722 26.1818H11.2912ZM13.0732 32.0824C12.8686 32.0824 12.6934 32.0104 12.5476 31.8665C12.4036 31.7225 12.3326 31.5483 12.3345 31.3438C12.3326 31.143 12.4036 30.9716 12.5476 30.8295C12.6934 30.6856 12.8686 30.6136 13.0732 30.6136C13.2663 30.6136 13.4368 30.6856 13.5845 30.8295C13.7341 30.9716 13.8099 31.143 13.8118 31.3438C13.8099 31.4801 13.7739 31.6042 13.7038 31.7159C13.6357 31.8277 13.5457 31.9167 13.4339 31.983C13.3241 32.0492 13.2038 32.0824 13.0732 32.0824ZM14.718 32V30.9886L16.8402 29.1307C16.9993 28.9867 17.1347 28.8551 17.2464 28.7358C17.3582 28.6146 17.4434 28.4934 17.5021 28.3722C17.5608 28.2491 17.5902 28.1155 17.5902 27.9716C17.5902 27.8106 17.5552 27.6733 17.4851 27.5597C17.415 27.4441 17.3184 27.3551 17.1953 27.2926C17.0722 27.2301 16.9311 27.1989 16.772 27.1989C16.611 27.1989 16.4699 27.232 16.3487 27.2983C16.2275 27.3627 16.1328 27.4564 16.0646 27.5795C15.9983 27.7027 15.9652 27.8523 15.9652 28.0284H14.6328C14.6328 27.6326 14.7218 27.2907 14.8999 27.0028C15.0779 26.715 15.3279 26.4934 15.6499 26.3381C15.9737 26.1809 16.3497 26.1023 16.7777 26.1023C17.219 26.1023 17.6025 26.1761 17.9283 26.3239C18.254 26.4716 18.5059 26.678 18.6839 26.9432C18.8639 27.2064 18.9538 27.5123 18.9538 27.8608C18.9538 28.0824 18.9093 28.3021 18.8203 28.5199C18.7313 28.7377 18.5713 28.9782 18.3402 29.2415C18.111 29.5047 17.7853 29.8201 17.3629 30.1875L16.6669 30.8295V30.8665H19.0249V32H14.718ZM20.6122 32.0824C20.4077 32.0824 20.2325 32.0104 20.0866 31.8665C19.9427 31.7225 19.8717 31.5483 19.8736 31.3438C19.8717 31.143 19.9427 30.9716 20.0866 30.8295C20.2325 30.6856 20.4077 30.6136 20.6122 30.6136C20.8054 30.6136 20.9759 30.6856 21.1236 30.8295C21.2732 30.9716 21.349 31.143 21.3509 31.3438C21.349 31.4801 21.313 31.6042 21.2429 31.7159C21.1747 31.8277 21.0848 31.9167 20.973 31.983C20.8632 32.0492 20.7429 32.0824 20.6122 32.0824Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M20.174 36.1818V42H18.7706V37.4943H18.7365L17.4354 38.2898V37.0739L18.87 36.1818H20.174ZM21.956 42.0824C21.7514 42.0824 21.5762 42.0104 21.4304 41.8665C21.2865 41.7225 21.2154 41.5483 21.2173 41.3438C21.2154 41.143 21.2865 40.9716 21.4304 40.8295C21.5762 40.6856 21.7514 40.6136 21.956 40.6136C22.1491 40.6136 22.3196 40.6856 22.4673 40.8295C22.617 40.9716 22.6927 41.143 22.6946 41.3438C22.6927 41.4801 22.6567 41.6042 22.5866 41.7159C22.5185 41.8277 22.4285 41.9167 22.3168 41.983C22.2069 42.0492 22.0866 42.0824 21.956 42.0824ZM23.6009 42V40.9886L25.723 39.1307C25.8821 38.9867 26.0175 38.8551 26.1293 38.7358C26.241 38.6146 26.3262 38.4934 26.3849 38.3722C26.4437 38.2491 26.473 38.1155 26.473 37.9716C26.473 37.8106 26.438 37.6733 26.3679 37.5597C26.2978 37.4441 26.2012 37.3551 26.0781 37.2926C25.955 37.2301 25.8139 37.1989 25.6548 37.1989C25.4938 37.1989 25.3527 37.232 25.2315 37.2983C25.1103 37.3627 25.0156 37.4564 24.9474 37.5795C24.8812 37.7027 24.848 37.8523 24.848 38.0284H23.5156C23.5156 37.6326 23.6046 37.2907 23.7827 37.0028C23.9607 36.715 24.2107 36.4934 24.5327 36.3381C24.8565 36.1809 25.2325 36.1023 25.6605 36.1023C26.1018 36.1023 26.4853 36.1761 26.8111 36.3239C27.1368 36.4716 27.3887 36.678 27.5668 36.9432C27.7467 37.2064 27.8366 37.5123 27.8366 37.8608C27.8366 38.0824 27.7921 38.3021 27.7031 38.5199C27.6141 38.7377 27.4541 38.9782 27.223 39.2415C26.9938 39.5047 26.6681 39.8201 26.2457 40.1875L25.5497 40.8295V40.8665H27.9077V42H23.6009ZM29.495 42.0824C29.2905 42.0824 29.1153 42.0104 28.9695 41.8665C28.8255 41.7225 28.7545 41.5483 28.7564 41.3438C28.7545 41.143 28.8255 40.9716 28.9695 40.8295C29.1153 40.6856 29.2905 40.6136 29.495 40.6136C29.6882 40.6136 29.8587 40.6856 30.0064 40.8295C30.156 40.9716 30.2318 41.143 30.2337 41.3438C30.2318 41.4801 30.1958 41.6042 30.1257 41.7159C30.0575 41.8277 29.9676 41.9167 29.8558 41.983C29.746 42.0492 29.6257 42.0824 29.495 42.0824ZM33.0881 36.1818V42H31.6847V37.4943H31.6506L30.3494 38.2898V37.0739L31.7841 36.1818H33.0881Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <rect
        x="0.5"
        y="0.5"
        width="49"
        height="57"
        rx="3.5"
        stroke={props.active ? "#01AFFD" : "#000000"}
      />
    </svg>
  );
};
export const NumberedList4 = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="50"
      height="58"
      viewBox="0 0 50 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="49" height="57" rx="3.5" fill="white" />
      <path
        d="M15 9H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M15 49H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24 19H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24 29H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M33 39L43 39"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M5.89418 12H4.38281L6.34588 6.18182H8.21804L10.1811 12H8.66974L7.30327 7.64773H7.25781L5.89418 12ZM5.69247 9.71023H8.85156V10.7784H5.69247V9.71023ZM11.5888 12.0824C11.3842 12.0824 11.209 12.0104 11.0632 11.8665C10.9193 11.7225 10.8482 11.5483 10.8501 11.3438C10.8482 11.143 10.9193 10.9716 11.0632 10.8295C11.209 10.6856 11.3842 10.6136 11.5888 10.6136C11.782 10.6136 11.9524 10.6856 12.1001 10.8295C12.2498 10.9716 12.3255 11.143 12.3274 11.3438C12.3255 11.4801 12.2895 11.6042 12.2195 11.7159C12.1513 11.8277 12.0613 11.9167 11.9496 11.983C11.8397 12.0492 11.7195 12.0824 11.5888 12.0824Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M5.56534 52V46.1818H7.99148C8.42708 46.1818 8.79167 46.2434 9.08523 46.3665C9.38068 46.4896 9.60227 46.6619 9.75 46.8835C9.89962 47.1051 9.97443 47.3617 9.97443 47.6534C9.97443 47.875 9.92803 48.0729 9.83523 48.2472C9.74242 48.4195 9.61458 48.5625 9.4517 48.6761C9.28883 48.7898 9.10038 48.8693 8.88636 48.9148V48.9716C9.12121 48.983 9.33807 49.0464 9.53693 49.1619C9.73769 49.2775 9.89867 49.4384 10.0199 49.6449C10.1411 49.8494 10.2017 50.0919 10.2017 50.3722C10.2017 50.6847 10.1222 50.964 9.96307 51.2102C9.80398 51.4545 9.57386 51.6477 9.27273 51.7898C8.97159 51.9299 8.60606 52 8.17614 52H5.56534ZM6.97159 50.8665H7.84091C8.14583 50.8665 8.37027 50.8087 8.5142 50.6932C8.66004 50.5777 8.73295 50.4167 8.73295 50.2102C8.73295 50.0606 8.69792 49.9318 8.62784 49.8239C8.55777 49.714 8.45833 49.6297 8.32955 49.571C8.20076 49.5104 8.0464 49.4801 7.86648 49.4801H6.97159V50.8665ZM6.97159 48.5739H7.75C7.90341 48.5739 8.03977 48.5483 8.15909 48.4972C8.27841 48.446 8.37121 48.3722 8.4375 48.2756C8.50568 48.179 8.53977 48.0625 8.53977 47.9261C8.53977 47.7311 8.47064 47.5777 8.33239 47.4659C8.19413 47.3542 8.00758 47.2983 7.77273 47.2983H6.97159V48.5739ZM11.6591 52.0824C11.4545 52.0824 11.2794 52.0104 11.1335 51.8665C10.9896 51.7225 10.9186 51.5483 10.9205 51.3438C10.9186 51.143 10.9896 50.9716 11.1335 50.8295C11.2794 50.6856 11.4545 50.6136 11.6591 50.6136C11.8523 50.6136 12.0227 50.6856 12.1705 50.8295C12.3201 50.9716 12.3958 51.143 12.3977 51.3438C12.3958 51.4801 12.3598 51.6042 12.2898 51.7159C12.2216 51.8277 12.1316 51.9167 12.0199 51.983C11.91 52.0492 11.7898 52.0824 11.6591 52.0824Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M15.108 21.0739C14.8295 21.0739 14.5824 21.0275 14.3665 20.9347C14.1525 20.84 13.983 20.6979 13.858 20.5085C13.7348 20.3172 13.6733 20.0777 13.6733 19.7898C13.6733 19.5473 13.7159 19.3428 13.8011 19.1761C13.8864 19.0095 14.0038 18.8741 14.1534 18.7699C14.303 18.6657 14.4754 18.5871 14.6705 18.5341C14.8655 18.4792 15.0739 18.4422 15.2955 18.4233C15.5436 18.4006 15.7434 18.3769 15.8949 18.3523C16.0464 18.3258 16.1563 18.2888 16.2244 18.2415C16.2945 18.1922 16.3295 18.1231 16.3295 18.0341V18.0199C16.3295 17.8741 16.2794 17.7614 16.179 17.6818C16.0786 17.6023 15.9432 17.5625 15.7727 17.5625C15.589 17.5625 15.4413 17.6023 15.3295 17.6818C15.2178 17.7614 15.1468 17.8712 15.1165 18.0114L13.8352 17.9659C13.8731 17.7008 13.9706 17.464 14.1278 17.2557C14.2869 17.0455 14.5047 16.8807 14.7812 16.7614C15.0597 16.6402 15.3939 16.5795 15.7841 16.5795C16.0625 16.5795 16.3191 16.6127 16.554 16.679C16.7888 16.7434 16.9934 16.8381 17.1676 16.9631C17.3419 17.0862 17.4763 17.2377 17.571 17.4176C17.6676 17.5975 17.7159 17.803 17.7159 18.0341V21H16.4091V20.392H16.375C16.2973 20.5398 16.1979 20.6648 16.0767 20.767C15.9574 20.8693 15.8163 20.946 15.6534 20.9972C15.4924 21.0483 15.3106 21.0739 15.108 21.0739ZM15.5369 20.1648C15.6866 20.1648 15.821 20.1345 15.9403 20.0739C16.0616 20.0133 16.1581 19.9299 16.2301 19.8239C16.3021 19.7159 16.3381 19.5909 16.3381 19.4489V19.0341C16.2983 19.0549 16.25 19.0739 16.1932 19.0909C16.1383 19.108 16.0777 19.1241 16.0114 19.1392C15.9451 19.1544 15.8769 19.1676 15.8068 19.179C15.7367 19.1903 15.6695 19.2008 15.6051 19.2102C15.4744 19.2311 15.3627 19.2633 15.2699 19.3068C15.179 19.3504 15.1089 19.4072 15.0597 19.4773C15.0123 19.5455 14.9886 19.6269 14.9886 19.7216C14.9886 19.8655 15.0398 19.9754 15.142 20.0511C15.2462 20.1269 15.3778 20.1648 15.5369 20.1648ZM19.3466 21.0824C19.142 21.0824 18.9669 21.0104 18.821 20.8665C18.6771 20.7225 18.6061 20.5483 18.608 20.3438C18.6061 20.143 18.6771 19.9716 18.821 19.8295C18.9669 19.6856 19.142 19.6136 19.3466 19.6136C19.5398 19.6136 19.7102 19.6856 19.858 19.8295C20.0076 19.9716 20.0833 20.143 20.0852 20.3438C20.0833 20.4801 20.0473 20.6042 19.9773 20.7159C19.9091 20.8277 19.8191 20.9167 19.7074 20.983C19.5975 21.0492 19.4773 21.0824 19.3466 21.0824Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M13.663 32V26.1818H15.0522V28.3835H15.0806C15.1374 28.2509 15.2179 28.1231 15.3221 28C15.4281 27.8769 15.5626 27.7765 15.7255 27.6989C15.8903 27.6193 16.0872 27.5795 16.3164 27.5795C16.6194 27.5795 16.9026 27.6591 17.1658 27.8182C17.431 27.9773 17.645 28.2225 17.8079 28.554C17.9708 28.8854 18.0522 29.3078 18.0522 29.821C18.0522 30.3153 17.9736 30.7292 17.8164 31.0625C17.6611 31.3958 17.4509 31.6458 17.1857 31.8125C16.9225 31.9792 16.6299 32.0625 16.3079 32.0625C16.0882 32.0625 15.8978 32.0265 15.7369 31.9545C15.5759 31.8826 15.4405 31.7879 15.3306 31.6705C15.2227 31.553 15.1393 31.4271 15.0806 31.2926H15.038V32H13.663ZM15.0238 29.8182C15.0238 30.053 15.055 30.2576 15.1175 30.4318C15.1819 30.6061 15.2738 30.7415 15.3931 30.8381C15.5143 30.9328 15.6592 30.9801 15.8278 30.9801C15.9982 30.9801 16.1431 30.9328 16.2624 30.8381C16.3817 30.7415 16.4717 30.6061 16.5323 30.4318C16.5948 30.2576 16.6261 30.053 16.6261 29.8182C16.6261 29.5833 16.5948 29.3797 16.5323 29.2074C16.4717 29.035 16.3817 28.9015 16.2624 28.8068C16.145 28.7121 16.0001 28.6648 15.8278 28.6648C15.6573 28.6648 15.5124 28.7112 15.3931 28.804C15.2738 28.8968 15.1819 29.0294 15.1175 29.2017C15.055 29.3741 15.0238 29.5795 15.0238 29.8182ZM19.5614 32.0824C19.3569 32.0824 19.1817 32.0104 19.0359 31.8665C18.8919 31.7225 18.8209 31.5483 18.8228 31.3438C18.8209 31.143 18.8919 30.9716 19.0359 30.8295C19.1817 30.6856 19.3569 30.6136 19.5614 30.6136C19.7546 30.6136 19.9251 30.6856 20.0728 30.8295C20.2224 30.9716 20.2982 31.143 20.3001 31.3438C20.2982 31.4801 20.2622 31.6042 20.1921 31.7159C20.1239 31.8277 20.034 31.9167 19.9222 31.983C19.8124 32.0492 19.6921 32.0824 19.5614 32.0824Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M24.0849 42V37.6364H25.4741V42H24.0849ZM24.7809 37.1278C24.5858 37.1278 24.4182 37.0634 24.2781 36.9347C24.1379 36.804 24.0678 36.6468 24.0678 36.4631C24.0678 36.2812 24.1379 36.1259 24.2781 35.9972C24.4182 35.8665 24.5858 35.8011 24.7809 35.8011C24.9779 35.8011 25.1455 35.8665 25.2837 35.9972C25.4239 36.1259 25.494 36.2812 25.494 36.4631C25.494 36.6468 25.4239 36.804 25.2837 36.9347C25.1455 37.0634 24.9779 37.1278 24.7809 37.1278ZM27.1396 42.0824C26.935 42.0824 26.7598 42.0104 26.614 41.8665C26.4701 41.7225 26.399 41.5483 26.4009 41.3438C26.399 41.143 26.4701 40.9716 26.614 40.8295C26.7598 40.6856 26.935 40.6136 27.1396 40.6136C27.3327 40.6136 27.5032 40.6856 27.6509 40.8295C27.8005 40.9716 27.8763 41.143 27.8782 41.3438C27.8763 41.4801 27.8403 41.6042 27.7702 41.7159C27.7021 41.8277 27.6121 41.9167 27.5004 41.983C27.3905 42.0492 27.2702 42.0824 27.1396 42.0824Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <rect
        x="0.5"
        y="0.5"
        width="49"
        height="57"
        rx="3.5"
        stroke={props.active ? "#01AFFD" : "#000000"}
      />
    </svg>
  );
};
export const NumberedList5 = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="50"
      height="58"
      viewBox="0 0 50 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="49" height="57" rx="3.5" fill="white" />
      <path
        d="M15 9H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M15 49H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24 19H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24 29H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M33 39L43 39"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M7.48331 6.18182V12H6.07706V6.18182H7.48331ZM9.14737 12.0824C8.94283 12.0824 8.76764 12.0104 8.6218 11.8665C8.47786 11.7225 8.40684 11.5483 8.40874 11.3438C8.40684 11.143 8.47786 10.9716 8.6218 10.8295C8.76764 10.6856 8.94283 10.6136 9.14737 10.6136C9.34055 10.6136 9.51101 10.6856 9.65874 10.8295C9.80836 10.9716 9.88411 11.143 9.88601 11.3438C9.88411 11.4801 9.84813 11.6042 9.77805 11.7159C9.70987 11.8277 9.61991 11.9167 9.50817 11.983C9.39832 12.0492 9.27805 12.0824 9.14737 12.0824Z"
        className={"undoIcoFill"}
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M7.33878 46.1818V52H5.93253V46.1818H7.33878ZM9.62784 46.1818V52H8.22159V46.1818H9.62784ZM11.2919 52.0824C11.0874 52.0824 10.9122 52.0104 10.7663 51.8665C10.6224 51.7225 10.5514 51.5483 10.5533 51.3438C10.5514 51.143 10.6224 50.9716 10.7663 50.8295C10.9122 50.6856 11.0874 50.6136 11.2919 50.6136C11.4851 50.6136 11.6555 50.6856 11.8033 50.8295C11.9529 50.9716 12.0286 51.143 12.0305 51.3438C12.0286 51.4801 11.9927 51.6042 11.9226 51.7159C11.8544 51.8277 11.7644 51.9167 11.6527 51.983C11.5429 52.0492 11.4226 52.0824 11.2919 52.0824Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M14.8942 21H13.3828L15.3459 15.1818H17.218L19.1811 21H17.6697L16.3033 16.6477H16.2578L14.8942 21ZM14.6925 18.7102H17.8516V19.7784H14.6925V18.7102ZM20.5888 21.0824C20.3842 21.0824 20.209 21.0104 20.0632 20.8665C19.9193 20.7225 19.8482 20.5483 19.8501 20.3438C19.8482 20.143 19.9193 19.9716 20.0632 19.8295C20.209 19.6856 20.3842 19.6136 20.5888 19.6136C20.782 19.6136 20.9524 19.6856 21.1001 19.8295C21.2498 19.9716 21.3255 20.143 21.3274 20.3438C21.3255 20.4801 21.2895 20.6042 21.2195 20.7159C21.1513 20.8277 21.0613 20.9167 20.9496 20.983C20.8397 21.0492 20.7195 21.0824 20.5888 21.0824Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M13.5653 32V26.1818H15.9915C16.4271 26.1818 16.7917 26.2434 17.0852 26.3665C17.3807 26.4896 17.6023 26.6619 17.75 26.8835C17.8996 27.1051 17.9744 27.3617 17.9744 27.6534C17.9744 27.875 17.928 28.0729 17.8352 28.2472C17.7424 28.4195 17.6146 28.5625 17.4517 28.6761C17.2888 28.7898 17.1004 28.8693 16.8864 28.9148V28.9716C17.1212 28.983 17.3381 29.0464 17.5369 29.1619C17.7377 29.2775 17.8987 29.4384 18.0199 29.6449C18.1411 29.8494 18.2017 30.0919 18.2017 30.3722C18.2017 30.6847 18.1222 30.964 17.9631 31.2102C17.804 31.4545 17.5739 31.6477 17.2727 31.7898C16.9716 31.9299 16.6061 32 16.1761 32H13.5653ZM14.9716 30.8665H15.8409C16.1458 30.8665 16.3703 30.8087 16.5142 30.6932C16.66 30.5777 16.733 30.4167 16.733 30.2102C16.733 30.0606 16.6979 29.9318 16.6278 29.8239C16.5578 29.714 16.4583 29.6297 16.3295 29.571C16.2008 29.5104 16.0464 29.4801 15.8665 29.4801H14.9716V30.8665ZM14.9716 28.5739H15.75C15.9034 28.5739 16.0398 28.5483 16.1591 28.4972C16.2784 28.446 16.3712 28.3722 16.4375 28.2756C16.5057 28.179 16.5398 28.0625 16.5398 27.9261C16.5398 27.7311 16.4706 27.5777 16.3324 27.4659C16.1941 27.3542 16.0076 27.2983 15.7727 27.2983H14.9716V28.5739ZM19.6591 32.0824C19.4545 32.0824 19.2794 32.0104 19.1335 31.8665C18.9896 31.7225 18.9186 31.5483 18.9205 31.3438C18.9186 31.143 18.9896 30.9716 19.1335 30.8295C19.2794 30.6856 19.4545 30.6136 19.6591 30.6136C19.8523 30.6136 20.0227 30.6856 20.1705 30.8295C20.3201 30.9716 20.3958 31.143 20.3977 31.3438C20.3958 31.4801 20.3598 31.6042 20.2898 31.7159C20.2216 31.8277 20.1316 31.9167 20.0199 31.983C19.91 32.0492 19.7898 32.0824 19.6591 32.0824Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M26.0607 36.1818V42H24.6573V37.4943H24.6232L23.3221 38.2898V37.0739L24.7567 36.1818H26.0607ZM27.8427 42.0824C27.6381 42.0824 27.4629 42.0104 27.3171 41.8665C27.1732 41.7225 27.1022 41.5483 27.104 41.3438C27.1022 41.143 27.1732 40.9716 27.3171 40.8295C27.4629 40.6856 27.6381 40.6136 27.8427 40.6136C28.0359 40.6136 28.2063 40.6856 28.354 40.8295C28.5037 40.9716 28.5794 41.143 28.5813 41.3438C28.5794 41.4801 28.5434 41.6042 28.4734 41.7159C28.4052 41.8277 28.3152 41.9167 28.2035 41.983C28.0936 42.0492 27.9734 42.0824 27.8427 42.0824Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <rect
        x="0.5"
        y="0.5"
        width="49"
        height="57"
        rx="3.5"
        stroke={props.active ? "#01AFFD" : "#000000"}
      />
    </svg>
  );
};
export const NumberedList6 = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="50"
      height="58"
      viewBox="0 0 50 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="49" height="57" rx="3.5" fill="white" />
      <path
        d="M21 9H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M21 49H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24 19H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24 29H43"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M33 39L43 39"
        stroke={props.active ? "#01AFFD" : "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M8.9407 12.142C8.43312 12.142 7.99562 12.0218 7.6282 11.7812C7.26077 11.5388 6.97763 11.1913 6.77876 10.7386C6.5799 10.2841 6.48142 9.73769 6.48331 9.09943C6.4852 8.46117 6.58464 7.91951 6.78161 7.47443C6.98047 7.02746 7.26267 6.6875 7.6282 6.45455C7.99562 6.2197 8.43312 6.10227 8.9407 6.10227C9.44827 6.10227 9.88577 6.2197 10.2532 6.45455C10.6225 6.6875 10.9066 7.02746 11.1055 7.47443C11.3043 7.9214 11.4028 8.46307 11.4009 9.09943C11.4009 9.73958 11.3015 10.2869 11.1026 10.7415C10.9038 11.196 10.6206 11.5436 10.2532 11.7841C9.88767 12.0227 9.45017 12.142 8.9407 12.142ZM8.9407 10.9915C9.24373 10.9915 9.48899 10.8371 9.67649 10.5284C9.86399 10.2178 9.95679 9.74148 9.9549 9.09943C9.9549 8.67898 9.91229 8.33239 9.82706 8.05966C9.74183 7.78504 9.62346 7.58049 9.47195 7.44602C9.32043 7.31155 9.14335 7.24432 8.9407 7.24432C8.63956 7.24432 8.39619 7.39678 8.21058 7.7017C8.02498 8.00473 7.93123 8.47064 7.92933 9.09943C7.92744 9.52557 7.96816 9.87879 8.05149 10.1591C8.13672 10.4394 8.25604 10.6487 8.40945 10.7869C8.56286 10.9233 8.73994 10.9915 8.9407 10.9915ZM14.8967 6.18182V12H13.4933V7.49432H13.4592L12.158 8.28977V7.07386L13.5927 6.18182H14.8967ZM16.6786 12.0824C16.4741 12.0824 16.2989 12.0104 16.1531 11.8665C16.0091 11.7225 15.9381 11.5483 15.94 11.3438C15.9381 11.143 16.0091 10.9716 16.1531 10.8295C16.2989 10.6856 16.4741 10.6136 16.6786 10.6136C16.8718 10.6136 17.0423 10.6856 17.19 10.8295C17.3396 10.9716 17.4154 11.143 17.4173 11.3438C17.4154 11.4801 17.3794 11.6042 17.3093 11.7159C17.2411 11.8277 17.1512 11.9167 17.0394 11.983C16.9296 12.0492 16.8093 12.0824 16.6786 12.0824Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M8.22976 52.142C7.72218 52.142 7.28468 52.0218 6.91726 51.7812C6.54983 51.5388 6.26669 51.1913 6.06783 50.7386C5.86896 50.2841 5.77048 49.7377 5.77237 49.0994C5.77427 48.4612 5.8737 47.9195 6.07067 47.4744C6.26953 47.0275 6.55173 46.6875 6.91726 46.4545C7.28468 46.2197 7.72218 46.1023 8.22976 46.1023C8.73733 46.1023 9.17483 46.2197 9.54226 46.4545C9.91158 46.6875 10.1957 47.0275 10.3945 47.4744C10.5934 47.9214 10.6919 48.4631 10.69 49.0994C10.69 49.7396 10.5906 50.2869 10.3917 50.7415C10.1928 51.196 9.90968 51.5436 9.54226 51.7841C9.17673 52.0227 8.73923 52.142 8.22976 52.142ZM8.22976 50.9915C8.53279 50.9915 8.77805 50.8371 8.96555 50.5284C9.15305 50.2178 9.24586 49.7415 9.24396 49.0994C9.24396 48.679 9.20135 48.3324 9.11612 48.0597C9.03089 47.785 8.91252 47.5805 8.76101 47.446C8.60949 47.3116 8.43241 47.2443 8.22976 47.2443C7.92862 47.2443 7.68525 47.3968 7.49964 47.7017C7.31404 48.0047 7.22029 48.4706 7.21839 49.0994C7.2165 49.5256 7.25722 49.8788 7.34055 50.1591C7.42578 50.4394 7.5451 50.6487 7.69851 50.7869C7.85192 50.9233 8.029 50.9915 8.22976 50.9915ZM11.4954 52V50.9886L13.6175 49.1307C13.7766 48.9867 13.9121 48.8551 14.0238 48.7358C14.1355 48.6146 14.2208 48.4934 14.2795 48.3722C14.3382 48.2491 14.3675 48.1155 14.3675 47.9716C14.3675 47.8106 14.3325 47.6733 14.2624 47.5597C14.1924 47.4441 14.0958 47.3551 13.9727 47.2926C13.8496 47.2301 13.7085 47.1989 13.5494 47.1989C13.3884 47.1989 13.2473 47.232 13.1261 47.2983C13.0049 47.3627 12.9102 47.4564 12.842 47.5795C12.7757 47.7027 12.7425 47.8523 12.7425 48.0284H11.4102C11.4102 47.6326 11.4992 47.2907 11.6772 47.0028C11.8552 46.715 12.1052 46.4934 12.4272 46.3381C12.7511 46.1809 13.127 46.1023 13.555 46.1023C13.9963 46.1023 14.3799 46.1761 14.7056 46.3239C15.0314 46.4716 15.2833 46.678 15.4613 46.9432C15.6412 47.2064 15.7312 47.5123 15.7312 47.8608C15.7312 48.0824 15.6867 48.3021 15.5977 48.5199C15.5086 48.7377 15.3486 48.9782 15.1175 49.2415C14.8884 49.5047 14.5626 49.8201 14.1403 50.1875L13.4442 50.8295V50.8665H15.8022V52H11.4954ZM17.3896 52.0824C17.185 52.0824 17.0098 52.0104 16.864 51.8665C16.7201 51.7225 16.649 51.5483 16.6509 51.3438C16.649 51.143 16.7201 50.9716 16.864 50.8295C17.0098 50.6856 17.185 50.6136 17.3896 50.6136C17.5827 50.6136 17.7532 50.6856 17.9009 50.8295C18.0505 50.9716 18.1263 51.143 18.1282 51.3438C18.1263 51.4801 18.0903 51.6042 18.0202 51.7159C17.9521 51.8277 17.8621 51.9167 17.7504 51.983C17.6405 52.0492 17.5202 52.0824 17.3896 52.0824Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M15.108 21.0739C14.8295 21.0739 14.5824 21.0275 14.3665 20.9347C14.1525 20.84 13.983 20.6979 13.858 20.5085C13.7348 20.3172 13.6733 20.0777 13.6733 19.7898C13.6733 19.5473 13.7159 19.3428 13.8011 19.1761C13.8864 19.0095 14.0038 18.8741 14.1534 18.7699C14.303 18.6657 14.4754 18.5871 14.6705 18.5341C14.8655 18.4792 15.0739 18.4422 15.2955 18.4233C15.5436 18.4006 15.7434 18.3769 15.8949 18.3523C16.0464 18.3258 16.1563 18.2888 16.2244 18.2415C16.2945 18.1922 16.3295 18.1231 16.3295 18.0341V18.0199C16.3295 17.8741 16.2794 17.7614 16.179 17.6818C16.0786 17.6023 15.9432 17.5625 15.7727 17.5625C15.589 17.5625 15.4413 17.6023 15.3295 17.6818C15.2178 17.7614 15.1468 17.8712 15.1165 18.0114L13.8352 17.9659C13.8731 17.7008 13.9706 17.464 14.1278 17.2557C14.2869 17.0455 14.5047 16.8807 14.7812 16.7614C15.0597 16.6402 15.3939 16.5795 15.7841 16.5795C16.0625 16.5795 16.3191 16.6127 16.554 16.679C16.7888 16.7434 16.9934 16.8381 17.1676 16.9631C17.3419 17.0862 17.4763 17.2377 17.571 17.4176C17.6676 17.5975 17.7159 17.803 17.7159 18.0341V21H16.4091V20.392H16.375C16.2973 20.5398 16.1979 20.6648 16.0767 20.767C15.9574 20.8693 15.8163 20.946 15.6534 20.9972C15.4924 21.0483 15.3106 21.0739 15.108 21.0739ZM15.5369 20.1648C15.6866 20.1648 15.821 20.1345 15.9403 20.0739C16.0616 20.0133 16.1581 19.9299 16.2301 19.8239C16.3021 19.7159 16.3381 19.5909 16.3381 19.4489V19.0341C16.2983 19.0549 16.25 19.0739 16.1932 19.0909C16.1383 19.108 16.0777 19.1241 16.0114 19.1392C15.9451 19.1544 15.8769 19.1676 15.8068 19.179C15.7367 19.1903 15.6695 19.2008 15.6051 19.2102C15.4744 19.2311 15.3627 19.2633 15.2699 19.3068C15.179 19.3504 15.1089 19.4072 15.0597 19.4773C15.0123 19.5455 14.9886 19.6269 14.9886 19.7216C14.9886 19.8655 15.0398 19.9754 15.142 20.0511C15.2462 20.1269 15.3778 20.1648 15.5369 20.1648ZM19.3466 21.0824C19.142 21.0824 18.9669 21.0104 18.821 20.8665C18.6771 20.7225 18.6061 20.5483 18.608 20.3438C18.6061 20.143 18.6771 19.9716 18.821 19.8295C18.9669 19.6856 19.142 19.6136 19.3466 19.6136C19.5398 19.6136 19.7102 19.6856 19.858 19.8295C20.0076 19.9716 20.0833 20.143 20.0852 20.3438C20.0833 20.4801 20.0473 20.6042 19.9773 20.7159C19.9091 20.8277 19.8191 20.9167 19.7074 20.983C19.5975 21.0492 19.4773 21.0824 19.3466 21.0824Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M13.663 32V26.1818H15.0522V28.3835H15.0806C15.1374 28.2509 15.2179 28.1231 15.3221 28C15.4281 27.8769 15.5626 27.7765 15.7255 27.6989C15.8903 27.6193 16.0872 27.5795 16.3164 27.5795C16.6194 27.5795 16.9026 27.6591 17.1658 27.8182C17.431 27.9773 17.645 28.2225 17.8079 28.554C17.9708 28.8854 18.0522 29.3078 18.0522 29.821C18.0522 30.3153 17.9736 30.7292 17.8164 31.0625C17.6611 31.3958 17.4509 31.6458 17.1857 31.8125C16.9225 31.9792 16.6299 32.0625 16.3079 32.0625C16.0882 32.0625 15.8978 32.0265 15.7369 31.9545C15.5759 31.8826 15.4405 31.7879 15.3306 31.6705C15.2227 31.553 15.1393 31.4271 15.0806 31.2926H15.038V32H13.663ZM15.0238 29.8182C15.0238 30.053 15.055 30.2576 15.1175 30.4318C15.1819 30.6061 15.2738 30.7415 15.3931 30.8381C15.5143 30.9328 15.6592 30.9801 15.8278 30.9801C15.9982 30.9801 16.1431 30.9328 16.2624 30.8381C16.3817 30.7415 16.4717 30.6061 16.5323 30.4318C16.5948 30.2576 16.6261 30.053 16.6261 29.8182C16.6261 29.5833 16.5948 29.3797 16.5323 29.2074C16.4717 29.035 16.3817 28.9015 16.2624 28.8068C16.145 28.7121 16.0001 28.6648 15.8278 28.6648C15.6573 28.6648 15.5124 28.7112 15.3931 28.804C15.2738 28.8968 15.1819 29.0294 15.1175 29.2017C15.055 29.3741 15.0238 29.5795 15.0238 29.8182ZM19.5614 32.0824C19.3569 32.0824 19.1817 32.0104 19.0359 31.8665C18.8919 31.7225 18.8209 31.5483 18.8228 31.3438C18.8209 31.143 18.8919 30.9716 19.0359 30.8295C19.1817 30.6856 19.3569 30.6136 19.5614 30.6136C19.7546 30.6136 19.9251 30.6856 20.0728 30.8295C20.2224 30.9716 20.2982 31.143 20.3001 31.3438C20.2982 31.4801 20.2622 31.6042 20.1921 31.7159C20.1239 31.8277 20.034 31.9167 19.9222 31.983C19.8124 32.0492 19.6921 32.0824 19.5614 32.0824Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <path
        d="M24.0849 42V37.6364H25.4741V42H24.0849ZM24.7809 37.1278C24.5858 37.1278 24.4182 37.0634 24.2781 36.9347C24.1379 36.804 24.0678 36.6468 24.0678 36.4631C24.0678 36.2812 24.1379 36.1259 24.2781 35.9972C24.4182 35.8665 24.5858 35.8011 24.7809 35.8011C24.9779 35.8011 25.1455 35.8665 25.2837 35.9972C25.4239 36.1259 25.494 36.2812 25.494 36.4631C25.494 36.6468 25.4239 36.804 25.2837 36.9347C25.1455 37.0634 24.9779 37.1278 24.7809 37.1278ZM27.1396 42.0824C26.935 42.0824 26.7598 42.0104 26.614 41.8665C26.4701 41.7225 26.399 41.5483 26.4009 41.3438C26.399 41.143 26.4701 40.9716 26.614 40.8295C26.7598 40.6856 26.935 40.6136 27.1396 40.6136C27.3327 40.6136 27.5032 40.6856 27.6509 40.8295C27.8005 40.9716 27.8763 41.143 27.8782 41.3438C27.8763 41.4801 27.8403 41.6042 27.7702 41.7159C27.7021 41.8277 27.6121 41.9167 27.5004 41.983C27.3905 42.0492 27.2702 42.0824 27.1396 42.0824Z"
        fill={props.active ? "#01AFFD" : "#000000"}
      />
      <rect
        x="0.5"
        y="0.5"
        width="49"
        height="57"
        rx="3.5"
        stroke={props.active ? "#01AFFD" : "#000000"}
      />
    </svg>
  );
};

export const Spacing = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="40"
      height="24"
      viewBox="0 0 40 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 3H3"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 21V10M18 21L15 18M18 21L21 18M18 3V14M18 3L15 6M18 3L21 6"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 9H3"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 15H3"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 21H3"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.5 10.25L33 13.75L36.5 10.25"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Bulleted = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="40"
      height="24"
      viewBox="0 0 40 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.9998 5.00293C21.5521 5.00304 21.9999 4.55542 22 4.00313C22.0001 3.45085 21.5525 3.00304 21.0002 3.00293L20.9998 5.00293ZM6.5002 3C5.94792 2.99989 5.50011 3.44751 5.5 3.9998C5.49989 4.55208 5.94751 4.99989 6.4998 5L6.5002 3ZM4 4C4 3.44772 3.55228 3 3 3C2.44772 3 2 3.44772 2 4H4ZM2 4.00293C2 4.55521 2.44772 5.00293 3 5.00293C3.55228 5.00293 4 4.55521 4 4.00293H2ZM21.0002 3.00293L6.5002 3L6.4998 5L20.9998 5.00293L21.0002 3.00293ZM2 4V4.00293H4V4H2Z"
        className={"undoIconFill"}
        fill={props.active ? "#01AFFD" : "#585858"}
      />
      <path
        d="M21 13.0015C21.5523 13.0015 22 12.5537 22 12.0015C22 11.4492 21.5523 11.0015 21 11.0015V13.0015ZM6.5 11.0015C5.94772 11.0015 5.5 11.4492 5.5 12.0015C5.5 12.5537 5.94772 13.0015 6.5 13.0015V11.0015ZM4 11.9985C4 11.4463 3.55228 10.9985 3 10.9985C2.44772 10.9985 2 11.4463 2 11.9985H4ZM2 12.0015C2 12.5537 2.44772 13.0015 3 13.0015C3.55228 13.0015 4 12.5537 4 12.0015H2ZM21 11.0015H6.5V13.0015H21V11.0015ZM2 11.9985V12.0015H4V11.9985H2Z"
        className={"undoIconFill"}
        fill={props.active ? "#01AFFD" : "#585858"}
      />
      <path
        d="M20.9998 21C21.5521 21.0001 21.9999 20.5525 22 20.0002C22.0001 19.4479 21.5525 19.0001 21.0002 19L20.9998 21ZM6.5002 18.9971C5.94792 18.997 5.50011 19.4446 5.5 19.9969C5.49989 20.5492 5.94751 20.997 6.4998 20.9971L6.5002 18.9971ZM4 19.9971C4 19.4448 3.55228 18.9971 3 18.9971C2.44772 18.9971 2 19.4448 2 19.9971H4ZM2 20C2 20.5523 2.44772 21 3 21C3.55228 21 4 20.5523 4 20H2ZM21.0002 19L6.5002 18.9971L6.4998 20.9971L20.9998 21L21.0002 19ZM2 19.9971V20H4V19.9971H2Z"
        className={"undoIconFill"}
        fill={props.active ? "#01AFFD" : "#585858"}
      />
      <path
        d="M29.5 10.25L33 13.75L36.5 10.25"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Numbered = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="40"
      height="24"
      viewBox="0 0 40 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 4H9"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M21 12H9"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M21 20H9"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M4.42942 1.63647V6.00011H3.24476V2.72738H3.21919L2.26465 3.29841V2.29272L3.33851 1.63647H4.42942Z"
        className={"undoIconFill"}
        fill={props.active ? "#01AFFD" : "#585858"}
      />
      <path
        d="M2.08523 14.0632V13.2109L3.71307 11.8643C3.82102 11.7748 3.91335 11.691 3.99006 11.6129C4.06818 11.5334 4.12784 11.4517 4.16903 11.3679C4.21165 11.2841 4.23295 11.191 4.23295 11.0888C4.23295 10.9765 4.20881 10.8807 4.16051 10.8011C4.11364 10.7216 4.0483 10.6605 3.96449 10.6179C3.88068 10.5738 3.78409 10.5518 3.67472 10.5518C3.56534 10.5518 3.46875 10.5738 3.38494 10.6179C3.30256 10.6619 3.23864 10.7265 3.19318 10.8118C3.14773 10.897 3.125 11.0007 3.125 11.1228H2C2 10.816 2.06889 10.5518 2.20668 10.3302C2.34446 10.1086 2.53906 9.93819 2.79048 9.81887C3.0419 9.69955 3.33665 9.63989 3.67472 9.63989C4.02415 9.63989 4.3267 9.696 4.58239 9.80822C4.83949 9.91901 5.03764 10.0753 5.17685 10.277C5.31747 10.4787 5.38778 10.7152 5.38778 10.9865C5.38778 11.1541 5.35298 11.321 5.28338 11.4872C5.21378 11.652 5.08878 11.8345 4.90838 12.0348C4.72798 12.2351 4.47159 12.4737 4.1392 12.7507L3.73011 13.0916V13.1172H5.43466V14.0632H2.08523Z"
        className={"undoIconFill"}
        fill={props.active ? "#01AFFD" : "#585858"}
      />
      <path
        d="M3.77273 21.9967C3.42898 21.9967 3.12358 21.9385 2.85653 21.8223C2.59091 21.7047 2.3821 21.5429 2.23011 21.337C2.07812 21.1311 2.00142 20.8945 2 20.627H3.19318C3.1946 20.7096 3.22017 20.7838 3.26989 20.8496C3.32102 20.9141 3.39063 20.9645 3.47869 21.0009C3.56676 21.0373 3.66761 21.0555 3.78125 21.0555C3.89063 21.0555 3.98722 21.0366 4.07102 20.9988C4.15483 20.9596 4.22017 20.9057 4.26705 20.837C4.31392 20.7684 4.33665 20.69 4.33523 20.6018C4.33665 20.5149 4.30966 20.4379 4.25426 20.3707C4.20028 20.3034 4.12429 20.2509 4.02628 20.2131C3.92827 20.1753 3.81534 20.1564 3.6875 20.1564H3.24432V19.3497H3.6875C3.8054 19.3497 3.90909 19.3308 3.99858 19.293C4.08949 19.2552 4.1598 19.2026 4.20952 19.1354C4.26065 19.0682 4.28551 18.9912 4.28409 18.9043C4.28551 18.8203 4.26491 18.7461 4.2223 18.6817C4.17969 18.6172 4.12003 18.5668 4.04332 18.5304C3.96804 18.494 3.88068 18.4758 3.78125 18.4758C3.6733 18.4758 3.5767 18.4947 3.49148 18.5325C3.40767 18.5703 3.34162 18.6228 3.29332 18.6901C3.24503 18.7573 3.22017 18.8343 3.21875 18.9211H2.08523C2.08665 18.6579 2.1598 18.4254 2.30469 18.2237C2.45099 18.022 2.65128 17.8638 2.90554 17.7489C3.1598 17.6341 3.4517 17.5767 3.78125 17.5767C4.10369 17.5767 4.38849 17.6306 4.63565 17.7384C4.88423 17.8463 5.07813 17.9947 5.21733 18.1838C5.35795 18.3714 5.42756 18.5864 5.42614 18.8287C5.42898 19.0696 5.34517 19.2671 5.17472 19.4211C5.00568 19.5752 4.79119 19.6662 4.53125 19.6942V19.7278C4.88352 19.7657 5.14844 19.8721 5.32599 20.0472C5.50355 20.2208 5.59091 20.4393 5.58807 20.7026C5.58949 20.9547 5.51278 21.1781 5.35795 21.3727C5.20455 21.5674 4.99077 21.7201 4.71662 21.8307C4.44389 21.9413 4.12926 21.9967 3.77273 21.9967Z"
        className={"undoIconFill"}
        fill={props.active ? "#01AFFD" : "#585858"}
      />
      <path
        d="M29.5 10.25L33 13.75L36.5 10.25"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DecreaseIndent = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.5007 3.5H3.5"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5005 9.16699H10.6924"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5005 14.8337H10.6924"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5007 20.5005H3.5"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.11689 9.16699L4.15527 12.0004L6.11689 14.8338"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IncreaseIndent = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.5007 3.5H3.5"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5005 9.16699H10.6924"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5005 14.8337H10.6924"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5007 20.5005H3.5"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.46191 9.16699L8.0774 12.0004L5.46191 14.8338"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MoreOptions = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CropImage = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.13 1L6 16C6 16.5304 6.21071 17.0391 6.58579 17.4142C6.96086 17.7893 7.46957 18 8 18H23M1 6.13L16 6C16.5304 6 17.0391 6.21071 17.4142 6.58579C17.7893 6.96086 18 7.46957 18 8V23"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ResetImage = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.02983 20.0576L8 14.1895L12 16.1895L16 11.1895L20.0584 20.0246M3 13.1895V18.5425C3 19.4521 3.76751 20.1895 4.71429 20.1895H19.2857C20.2325 20.1895 21 19.4521 21 18.5425V13.1895"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 8.18939C16 2.68941 8 2.18945 4 9.18941M4 9.18941V5.18943M4 9.18941L8 9.18938"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Plus = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 4.25V14.75M3.75 9.5H14.25"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FontSize = ({ ...props }) => {
  return (
    <>
      <div onClick={props.onClick}></div>
    </>
  );
};

export const Minus = ({ ...props }) => {
  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.75 9.5H14.25"
        className={"undoIcon"}
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const InsertTable = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="40"
        height="24"
        viewBox="0 0 40 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 3V21M9 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V12M9 3H15M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V12M9 21H15M15 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V12M15 3V21M15 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V12M3 12H21"
          className={"undoIcon"}
          stroke={props.active ? "#01AFFD" : "#585858"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M29.5 10.25L33 13.75L36.5 10.25"
          className={"undoIcon"}
          stroke={props.active ? "#01AFFD" : "#585858"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const Columns = ({ ...props }) => {
  return (
    <>
      <svg
        width="21"
        height="21"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 1V19M7 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V17C1 17.5304 1.21071 18.0391 1.58579 18.4142C1.96086 18.7893 2.46957 19 3 19H7M7 1H13M7 19H13M13 1H17C17.5304 1 18.0391 1.21071 18.4142 1.58579C18.7893 1.96086 19 2.46957 19 3V17C19 17.5304 18.7893 18.0391 18.4142 18.4142C18.0391 18.7893 17.5304 19 17 19H13M13 1V19"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const AddColumns = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.4141 20.4142C20.039 20.7893 19.5303 21 18.9998 21L11.9998 21L4.99985 21C4.46942 21 3.96071 20.7893 3.58564 20.4142C3.21056 20.0391 2.99985 19.5304 2.99985 19L2.99985 12L2.99985 9L2.99985 5C2.99985 4.46957 3.21056 3.96086 3.58564 3.58579C3.96071 3.21071 4.46942 3 4.99985 3L11.9998 3L18.9998 3C19.5303 3 20.039 3.21071 20.4141 3.58579"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 18L21 12L21 9.42857L21 6"
          stroke="#01AFFD"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M9 20L8.99999 3" stroke="#585858" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15 20L15 3" stroke="#585858" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </>
  );
};

export const Rows = ({ ...props }) => {
  return (
    <>
      <svg
        width="21"
        height="21"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 13H19M1 13V17C1 17.5304 1.21071 18.0391 1.58579 18.4142C1.96086 18.7893 2.46957 19 3 19H17C17.5304 19 18.0391 18.7893 18.4142 18.4142C18.7893 18.0391 19 17.5304 19 17V13M1 13V7M19 13V7M1 7V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H17C17.5304 1 18.0391 1.21071 18.4142 1.58579C18.7893 1.96086 19 2.46957 19 3V7M1 7H19"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const AddRows = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.58579 20.4141C3.21071 20.039 3 19.5303 3 18.9998V11.9998L3 4.99985C3 4.46942 3.21071 3.96071 3.58579 3.58564C3.96086 3.21056 4.46957 2.99985 5 2.99985L12 2.99985H15H19C19.5304 2.99985 20.0391 3.21056 20.4142 3.58564C20.7893 3.96071 21 4.46942 21 4.99985L21 11.9998V18.9998C21 19.5303 20.7893 20.039 20.4142 20.4141"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 21H12H14.5714H18"
          stroke="#01AFFD"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M3 9L21 9" stroke="#585858" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3 15L21 15" stroke="#585858" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </>
  );
};

export const DeleteRow = ({ ...props }) => {
  return (
    <>
      <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.5 0.5L0.5 7.5M0.5 0.5L7.5 7.5"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const DeleteCol = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="8"
        height="8"
        viewBox="0 0 8 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.5 0.5L0.5 7.5M0.5 0.5L7.5 7.5"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const HorizontalBar = ({ ...props }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 18H14M4 12L20 12M4 6L10 6"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const ClusteredHorizontalBar = ({ ...props }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 11H20M5 18H18M5 4H16M5 7H7M5 14H12M5 21H11.5"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const VerticalBar = ({ ...props }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 20V10M12 20V4M6 20V14"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const ClusteredVerticalBar = ({ ...props }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 20V10M18 20V7M4 20V16M7 20V18M14 20V13M21 20V4"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const StackedBarChart = ({ ...props }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 20V18M18 20V17M6 20V19M6 16V15M6 12V11M12 15V13M12 10V8M18 14V11M18 8V5"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const FloatingBarChart = ({ ...props }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 10V4M17 19V18M5 20V16M8 14V12M14 16V12M20 16V14"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const LineChart = ({ ...props }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M23 6L13.5 15.5L8.5 10.5L1 18M23 6H17M23 6V12"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const BubbleChart = ({ ...props }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="7.5" cy="5.5" r="1.5" stroke="#585858" />
        <circle cx="4.5" cy="16.5" r="1.5" stroke="#585858" />
        <circle cx="19" cy="18" r="2" stroke="#585858" />
        <circle cx="15.5" cy="9.5" r="3.5" stroke="#585858" />
      </svg>
    </>
  );
};
export const Combo = ({ ...props }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 20V10M18 20V4M6 20V16"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23 5L13.5 14.5L8.5 9.5L1 17"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const DoughnutChart = ({ ...props }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.21 15.89C20.5739 17.3945 19.5788 18.7202 18.3119 19.7513C17.045 20.7824 15.5448 21.4874 13.9425 21.8048C12.3401 22.1221 10.6845 22.0421 9.12018 21.5718C7.55591 21.1014 6.13066 20.2551 4.96906 19.1067C3.80745 17.9582 2.94485 16.5428 2.45667 14.9839C1.96849 13.4251 1.8696 11.7705 2.16863 10.1646C2.46767 8.55878 3.15553 7.05063 4.17208 5.77203C5.18863 4.49343 6.50292 3.48332 8.00004 2.83M22 12C22 10.6868 21.7414 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8269 2.7612C14.6136 2.25866 13.3133 2 12 2"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.526 14.3359C17.1443 15.2388 16.5473 16.0345 15.7872 16.6533C15.027 17.2721 14.1269 17.6952 13.1656 17.8856C12.2042 18.0761 11.2108 18.0281 10.2722 17.7458C9.3337 17.4635 8.47857 16.9556 7.78162 16.2664C7.08467 15.5772 6.56712 14.7277 6.27422 13.7922C5.98132 12.8567 5.92198 11.8637 6.1014 10.8999C6.28082 9.93619 6.69353 9.03108 7.30344 8.26375C7.91336 7.49641 8.70192 6.8902 9.60017 6.49812M18 12.0014C18 11.2133 17.8448 10.4329 17.5433 9.70476C17.2418 8.97664 16.7998 8.31505 16.2427 7.75777C15.6855 7.20049 15.0241 6.75843 14.2962 6.45683C13.5682 6.15523 12.788 6 12.0001 6"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const PieChart = ({ ...props }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.21 15.89C20.5739 17.3945 19.5788 18.7202 18.3119 19.7513C17.045 20.7824 15.5448 21.4874 13.9425 21.8048C12.3401 22.1221 10.6845 22.0421 9.12018 21.5718C7.55591 21.1014 6.13066 20.2551 4.96906 19.1067C3.80745 17.9582 2.94485 16.5428 2.45667 14.9839C1.96849 13.4251 1.8696 11.7705 2.16863 10.1646C2.46767 8.55878 3.15553 7.05063 4.17208 5.77203C5.18863 4.49343 6.50292 3.48332 8.00004 2.83M22 12C22 10.6868 21.7414 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8269 2.7612C14.6136 2.25866 13.3133 2 12 2V12H22Z"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const ScatterChart = ({ ...props }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="4.5" cy="8.5" r="1.5" stroke="#585858" />
        <circle cx="6.5" cy="20.5" r="1.5" stroke="#585858" />
        <circle cx="19.5" cy="19.5" r="1.5" stroke="#585858" />
        <circle cx="18.5" cy="3.5" r="1.5" stroke="#585858" />
        <circle cx="13.5" cy="12.5" r="1.5" stroke="#585858" />
      </svg>
    </>
  );
};
export const StackedBarLine = ({ ...props }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 21V17.25M19 21V15M7 21V19.5"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22 8L13.7955 14.3333L9.47727 11L3 16"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22 3L13.7955 9.33333L9.47727 6L3 11"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const Line = ({ ...props }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.5 4C4.5 4.2003 4.46074 4.39144 4.38949 4.56613L20.275 18.6865C20.4899 18.5677 20.737 18.5 21 18.5C21.8284 18.5 22.5 19.1716 22.5 20C22.5 20.8284 21.8284 21.5 21 21.5C20.1716 21.5 19.5 20.8284 19.5 20C19.5 19.7997 19.5393 19.6086 19.6105 19.4339L3.72503 5.31345C3.51014 5.43233 3.26297 5.5 3 5.5C2.17157 5.5 1.5 4.82843 1.5 4C1.5 3.17157 2.17157 2.5 3 2.5C3.82843 2.5 4.5 3.17157 4.5 4Z"
          fill="#585858"
        />
      </svg>
    </>
  );
};
export const Arrow = ({ ...props }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.50086 4.02934C2.48465 3.75368 2.69497 3.51706 2.97064 3.50084L7.46287 3.2366C7.73854 3.22038 7.97516 3.43071 7.99137 3.70637C8.00759 3.98204 7.79726 4.21865 7.5216 4.23487L4.23438 4.42824L21.3322 19.6263C21.5386 19.8097 21.5572 20.1258 21.3737 20.3322C21.1902 20.5386 20.8742 20.5571 20.6678 20.3737L3.57002 5.17564L3.76339 8.46286C3.7796 8.73852 3.56928 8.97514 3.29361 8.99135C3.01794 9.00757 2.78133 8.79724 2.76511 8.52158L2.50086 4.02934Z"
          fill="#585858"
        />
      </svg>
    </>
  );
};
export const Elbow = ({ ...props }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 5.5C3.65311 5.5 4.20873 5.0826 4.41465 4.5H11.5V20C11.5 20.2761 11.7239 20.5 12 20.5H19.5854C19.7913 21.0826 20.3469 21.5 21 21.5C21.8284 21.5 22.5 20.8284 22.5 20C22.5 19.1716 21.8284 18.5 21 18.5C20.3469 18.5 19.7913 18.9174 19.5854 19.5H12.5V4C12.5 3.72386 12.2761 3.5 12 3.5H4.41465C4.20873 2.9174 3.65311 2.5 3 2.5C2.17157 2.5 1.5 3.17157 1.5 4C1.5 4.82843 2.17157 5.5 3 5.5Z"
          fill="#585858"
        />
      </svg>
    </>
  );
};
export const Curved = ({ ...props }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 5.5C3.65311 5.5 4.20873 5.0826 4.41465 4.5H8C9.933 4.5 11.5 6.067 11.5 8V16C11.5 18.4853 13.5147 20.5 16 20.5H19.5854C19.7913 21.0826 20.3469 21.5 21 21.5C21.8284 21.5 22.5 20.8284 22.5 20C22.5 19.1716 21.8284 18.5 21 18.5C20.3469 18.5 19.7913 18.9174 19.5854 19.5H16C14.067 19.5 12.5 17.933 12.5 16V8C12.5 5.51472 10.4853 3.5 8 3.5H4.41465C4.20873 2.9174 3.65311 2.5 3 2.5C2.17157 2.5 1.5 3.17157 1.5 4C1.5 4.82843 2.17157 5.5 3 5.5Z"
          fill="#585858"
        />
      </svg>
    </>
  );
};
export const Curve = ({ ...props }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 5.5C3.82843 5.5 4.5 4.82843 4.5 4C4.5 3.17157 3.82843 2.5 3 2.5C2.17157 2.5 1.5 3.17157 1.5 4C1.5 4.82843 2.17157 5.5 3 5.5ZM21 21.5C21.8284 21.5 22.5 20.8284 22.5 20C22.5 19.1716 21.8284 18.5 21 18.5C20.1716 18.5 19.5 19.1716 19.5 20C19.5 20.8284 20.1716 21.5 21 21.5Z"
          fill="#585858"
        />
        <path
          d="M3 3.5C2.72386 3.5 2.5 3.72386 2.5 4C2.5 4.27614 2.72386 4.5 3 4.5V3.5ZM21 20.5C21.2761 20.5 21.5 20.2761 21.5 20C21.5 19.7239 21.2761 19.5 21 19.5V20.5ZM3 4.5H17V3.5H3V4.5ZM17 11.5H7V12.5H17V11.5ZM7 20.5H21V19.5H7V20.5ZM2.5 16C2.5 18.4853 4.51472 20.5 7 20.5V19.5C5.067 19.5 3.5 17.933 3.5 16H2.5ZM7 11.5C4.51472 11.5 2.5 13.5147 2.5 16H3.5C3.5 14.067 5.067 12.5 7 12.5V11.5ZM20.5 8C20.5 9.933 18.933 11.5 17 11.5V12.5C19.4853 12.5 21.5 10.4853 21.5 8H20.5ZM17 4.5C18.933 4.5 20.5 6.067 20.5 8H21.5C21.5 5.51472 19.4853 3.5 17 3.5V4.5Z"
          fill="#585858"
        />
      </svg>
    </>
  );
};
export const PolyLine = ({ ...props }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 20V20.5C22.1894 20.5 22.3625 20.393 22.4472 20.2236C22.5319 20.0542 22.5136 19.8515 22.4 19.7L22 20ZM22 4L22.4 4.3C22.5136 4.14849 22.5319 3.94579 22.4472 3.77639C22.3625 3.607 22.1894 3.5 22 3.5V4ZM9.5 4V3.5C9.3618 3.5 9.22975 3.5572 9.13523 3.65803L9.5 4ZM2 12L1.63523 11.658C1.45492 11.8504 1.45492 12.1496 1.63523 12.342L2 12ZM9.5 20L9.13523 20.342C9.22975 20.4428 9.3618 20.5 9.5 20.5V20ZM16 12L15.6 11.7C15.4667 11.8778 15.4667 12.1222 15.6 12.3L16 12ZM22 3.5H9.5V4.5H22V3.5ZM9.5 20.5H22V19.5H9.5V20.5ZM22.4 19.7L16.4 11.7L15.6 12.3L21.6 20.3L22.4 19.7ZM16.4 12.3L22.4 4.3L21.6 3.7L15.6 11.7L16.4 12.3ZM1.63523 12.342L9.13523 20.342L9.86477 19.658L2.36477 11.658L1.63523 12.342ZM9.13523 3.65803L1.63523 11.658L2.36477 12.342L9.86477 4.34197L9.13523 3.65803Z"
          fill="#585858"
        />
      </svg>
    </>
  );
};
export const Scribble = ({ ...props }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.626295 5.07069C0.442836 5.27708 0.461427 5.59312 0.667818 5.77658C0.874209 5.96004 1.19025 5.94144 1.3737 5.73505L0.626295 5.07069ZM6.5 9.90287L6.96817 10.0784L6.5 9.90287ZM16.5 9.90287L16.6857 9.43864L16.5 9.90287ZM22.924 14.3972C23.1969 14.4392 23.4522 14.252 23.4942 13.979C23.5362 13.7061 23.349 13.4508 23.076 13.4088L22.924 14.3972ZM19.1203 18.3163L18.6268 18.2356L19.1203 18.3163ZM15.2662 19.5635L14.9143 19.9187L15.2662 19.5635ZM6.73958 18.2893L6.68623 18.7864L6.73958 18.2893ZM1.3737 5.73505C2.00183 5.02842 2.87521 4.32704 3.76914 3.83143C4.68118 3.32578 5.52793 3.08212 6.12652 3.16637C6.40812 3.20601 6.62188 3.31557 6.7814 3.49785C6.94598 3.6859 7.09009 3.99436 7.14566 4.49441C7.25877 5.51209 6.98888 7.17513 6.03183 9.72731L6.96817 10.0784C7.93939 7.48846 8.27947 5.64292 8.13954 4.38395C8.0686 3.74567 7.87044 3.22378 7.53391 2.83926C7.19234 2.44897 6.74615 2.24373 6.26589 2.17613C5.34074 2.04592 4.25606 2.41807 3.28426 2.95685C2.29436 3.50567 1.33151 4.27732 0.626295 5.07069L1.3737 5.73505ZM6.03183 9.72731C5.39285 11.4313 4.83283 13.5174 4.74576 15.2335C4.7025 16.0862 4.77258 16.9023 5.05157 17.5422C5.34452 18.2141 5.87701 18.6996 6.68623 18.7864L6.79293 17.7922C6.39905 17.7499 6.14261 17.5424 5.96823 17.1425C5.77992 16.7106 5.70431 16.076 5.74448 15.2842C5.82427 13.7114 6.34755 11.7334 6.96817 10.0784L6.03183 9.72731ZM9.55847 16.3609C10.545 13.7883 11.7266 12.0559 12.9194 11.0906C14.0963 10.1382 15.2582 9.94466 16.3143 10.3671L16.6857 9.43864C15.2253 8.85447 13.6867 9.18319 12.2903 10.3133C10.9098 11.4305 9.64552 13.341 8.62477 16.0029L9.55847 16.3609ZM16.3143 10.3671C17.2921 10.7582 18.0184 11.8484 18.4266 13.3661C18.8291 14.8628 18.8854 16.6543 18.6268 18.2356L19.6137 18.397C19.8926 16.6918 19.8358 14.7555 19.3923 13.1064C18.9545 11.4784 18.102 10.0052 16.6857 9.43864L16.3143 10.3671ZM15.618 19.2082C15.1311 18.7259 14.7816 18.2176 14.6409 17.7139C14.5067 17.2333 14.5522 16.7261 14.916 16.1803L14.084 15.6256C13.5569 16.4162 13.466 17.2246 13.6778 17.9829C13.8831 18.718 14.3621 19.3718 14.9143 19.9187L15.618 19.2082ZM14.916 16.1803C15.5928 15.1652 16.989 14.6095 18.6098 14.3727C20.2044 14.1398 21.8782 14.2363 22.924 14.3972L23.076 13.4088C21.9551 13.2364 20.1789 13.1329 18.4652 13.3832C16.7776 13.6298 15.0072 14.2408 14.084 15.6256L14.916 16.1803ZM18.6268 18.2356C18.3827 19.7283 16.6955 20.2754 15.618 19.2082L14.9143 19.9187C16.5662 21.5549 19.2378 20.6956 19.6137 18.397L18.6268 18.2356ZM6.68623 18.7864C7.46217 18.8697 8.08996 18.5127 8.55153 18.0337C9.00735 17.5608 9.33798 16.9359 9.55847 16.3609L8.62477 16.0029C8.43123 16.5076 8.16073 16.9982 7.83149 17.3398C7.508 17.6755 7.16679 17.8323 6.79293 17.7922L6.68623 18.7864Z"
          fill="#585858"
        />
      </svg>
    </>
  );
};
export const UploadFromPC = ({ ...props }) => {
  return (
    <>
      <svg
        className={props.className ? props.className : ""}
        width="25"
        height="25"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M17 8L12 3M12 3L7 8M12 3V15"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const SearchWeb = ({ ...props }) => {
  return (
    <>
      <svg
        className={props.className ? props.className : ""}
        width="25"
        height="25"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const UploadFromDrive = ({ ...props }) => {
  return (
    <>
      <svg
        className={props.className ? props.className : ""}
        width="25"
        height="25"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 3H15L23 16L20.381 22H3.61905L1 16L9 3Z"
          stroke="#585858"
          strokeLinejoin="round"
        />
        <path d="M12 9L17 17H7L12 9Z" stroke="#585858" strokeLinejoin="round" />
      </svg>
    </>
  );
};
export const LinkFromExternalSource = ({ ...props }) => {
  return (
    <>
      <svg
        className={props.className ? props.className : ""}
        width="25"
        height="25"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 7H18C18.6566 7 19.3068 7.12933 19.9134 7.3806C20.52 7.63188 21.0712 8.00017 21.5355 8.46447C21.9998 8.92876 22.3681 9.47996 22.6194 10.0866C22.8707 10.6932 23 11.3434 23 12C23 12.6566 22.8707 13.3068 22.6194 13.9134C22.3681 14.52 21.9998 15.0712 21.5355 15.5355C21.0712 15.9998 20.52 16.3681 19.9134 16.6194C19.3068 16.8707 18.6566 17 18 17H15M9 17H6C5.34339 17 4.69321 16.8707 4.08658 16.6194C3.47995 16.3681 2.92876 15.9998 2.46447 15.5355C1.52678 14.5979 1 13.3261 1 12C1 10.6739 1.52678 9.40215 2.46447 8.46447C3.40215 7.52678 4.67392 7 6 7H9M8 12H16"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const DownArrow = ({ ...props }) => {
  return (
    <>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className="undoIcon"
          d="M4.5 6.75L9 11.25L13.5 6.75"
          stroke={props.active ? "#01AFFD" : "#585858"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const Tick = ({ ...props }) => {
  return (
    <svg
      className={props.className ? props.className : ""}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 6L9 17L4 12"
        stroke={props.shouldShow ? "#585858" : "transparent"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ClearFormatting = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.4622 10.8838L8.31536 19.4711C8.18141 20.0069 8.50717 20.5498 9.04297 20.6838C9.57876 20.8177 10.1217 20.492 10.2556 19.9562L12.0536 12.7645L10.4622 10.8838ZM12.8005 9.77693L13.9233 5.28539H19.571C20.1233 5.28539 20.571 4.83768 20.571 4.28539C20.571 3.73311 20.1233 3.28539 19.571 3.28539H13.1635C13.149 3.28508 13.1345 3.28508 13.1201 3.28539H7.30762L8.99992 5.28539H11.8618L11.2091 7.89621L12.8005 9.77693Z"
          fill="#585858"
          className="undoIconFill"
        />
        <path
          d="M4 3L18 20"
          stroke="#585858"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="undoIcon"
        />
      </svg>
    </>
  );
};

export const UpwardArrow = ({ ...props }) => {
  return (
    <>
      <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.24647 4.7461C8.09051 4.90202 7.87901 4.9896 7.65849 4.9896C7.43796 4.9896 7.22646 4.90202 7.0705 4.7461L4.33185 2.00745L1.59319 4.7461C1.51647 4.82554 1.42471 4.88889 1.32324 4.93248C1.22177 4.97607 1.11264 4.99901 1.00222 4.99997C0.891789 5.00093 0.782277 4.97989 0.680069 4.93807C0.577861 4.89625 0.485005 4.8345 0.406918 4.75641C0.328831 4.67833 0.267078 4.58547 0.225261 4.48326C0.183445 4.38105 0.162402 4.27154 0.163361 4.16111C0.164321 4.05069 0.187263 3.94156 0.23085 3.84009C0.274436 3.73862 0.337795 3.64685 0.417227 3.57014L3.74387 0.243499C3.89982 0.0875866 4.11132 -1.9279e-08 4.33185 0C4.55237 1.9279e-08 4.76387 0.0875867 4.91983 0.243499L8.24647 3.57014C8.40238 3.7261 8.48997 3.93759 8.48997 4.15812C8.48997 4.37865 8.40238 4.59015 8.24647 4.7461Z"
          fill="currentColor"
        />
      </svg>
    </>
  );
};
export const UpwardArrowBlue = ({ ...props }) => {
  return (
    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 8.75L7.5 5.25L4 8.75"
        stroke={props.color ? props.color : "#01AFFD"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const DownwardArrow = ({ ...props }) => {
  return (
    <>
      <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.406829 0.253896C0.562788 0.0979839 0.774286 0.0103972 0.994812 0.0103972C1.21534 0.0103972 1.42684 0.0979839 1.5828 0.253896L4.32145 2.99255L7.06011 0.253896C7.13682 0.174464 7.22859 0.111106 7.33006 0.0675198C7.43152 0.0239334 7.54066 0.000990984 7.65108 3.1401e-05C7.76151 -0.000928182 7.87102 0.020114 7.97323 0.0619306C8.07544 0.103747 8.16829 0.165501 8.24638 0.243587C8.32447 0.321674 8.38622 0.414531 8.42804 0.516739C8.46985 0.618946 8.4909 0.728459 8.48994 0.838886C8.48898 0.949314 8.46604 1.05844 8.42245 1.15991C8.37886 1.26138 8.3155 1.35314 8.23607 1.42986L4.90943 4.7565C4.75347 4.91241 4.54198 5 4.32145 5C4.10092 5 3.88943 4.91241 3.73347 4.7565L0.406829 1.42986C0.250917 1.2739 0.16333 1.06241 0.16333 0.841879C0.16333 0.621353 0.250917 0.409855 0.406829 0.253896Z"
          fill="currentColor"
        />
      </svg>
    </>
  );
};
export const DownwardArrowBlue = ({ ...props }) => {
  return (
    <>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.5 5.25L7 8.75L10.5 5.25"
          stroke={props.color ? props.color : "currentColor"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const Exit = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6L6 18M6 6L18 18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Rotate90 = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.03535 1.55254L13.2821 4.76287L9.03535 8.19104"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.0505 23.4997C12.3266 23.4997 12.5505 23.2759 12.5505 22.9997C12.5505 22.7236 12.3266 22.4997 12.0505 22.4997V23.4997ZM12.0505 22.4997C6.73294 22.4997 2.5 18.5672 2.5 13.808H1.5C1.5 19.2017 6.26659 23.4997 12.0505 23.4997V22.4997ZM2.5 13.808C2.5 9.04874 6.73294 5.11621 12.0505 5.11621V4.11621C6.26659 4.11621 1.5 8.41427 1.5 13.808H2.5Z"
          fill="#585858"
        />
        <rect
          width="8"
          height="8"
          rx="1"
          transform="matrix(0.701411 -0.712757 0.701411 0.712757 11.0503 14.8086)"
          stroke="#585858"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const FlipHorizontally = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 1V23" stroke="#585858" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M15 3H21V21H15"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="2 4"
        />
        <path d="M9 3H3V21H9" stroke="#585858" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </>
  );
};
export const FlipVertically = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M23 12L1 12" stroke="#585858" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M21 15L21 21L3 21L3 15"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="2 4"
        />
        <path
          d="M21 9L21 3L3 3L3 9"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const Cut = ({ ...props }) => {
  return (
    <>
      <svg
        className={props.className ? props.className : ""}
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 4L8.12 15.88M14.47 14.48L20 20M8.12 8.12L12 12M9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6ZM9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.3431 4.34315 15 6 15C7.65685 15 9 16.3431 9 18Z"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const Copy = ({ ...props }) => {
  return (
    <>
      <svg
        className={props.className ? props.className : ""}
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 15H4C3.46957 15 2.96086 14.7893 2.58579 14.4142C2.21071 14.0391 2 13.5304 2 13V4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H13C13.5304 2 14.0391 2.21071 14.4142 2.58579C14.7893 2.96086 15 3.46957 15 4V5M11 9H20C21.1046 9 22 9.89543 22 11V20C22 21.1046 21.1046 22 20 22H11C9.89543 22 9 21.1046 9 20V11C9 9.89543 9.89543 9 11 9Z"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const Paste = ({ ...props }) => {
  return (
    <>
      <svg
        className={props.className ? props.className : ""}
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 4H18C18.5304 4 19.0391 4.21071 19.4142 4.58579C19.7893 4.96086 20 5.46957 20 6V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4H8M9 2H15C15.5523 2 16 2.44772 16 3V5C16 5.55228 15.5523 6 15 6H9C8.44772 6 8 5.55228 8 5V3C8 2.44772 8.44772 2 9 2Z"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const AlignItemLeft = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.5 2C2.77614 2 3 2.22386 3 2.5V21.5004C3 21.7765 2.77614 22.0004 2.5 22.0004C2.22386 22.0004 2 21.7765 2 21.5004V2.5C2 2.22386 2.22386 2 2.5 2ZM7.61679 4.46152C7.08577 4.46152 6.65527 4.89201 6.65527 5.42309V8.34622C6.65527 8.8773 7.08577 9.30779 7.61679 9.30779H14.1936C14.7246 9.30779 15.1551 8.8773 15.1551 8.34622V5.42309C15.1551 4.89201 14.7246 4.46152 14.1936 4.46152H7.61679ZM5.65527 5.42309C5.65527 4.33976 6.53345 3.46152 7.61679 3.46152H14.1936C15.2769 3.46152 16.1551 4.33976 16.1551 5.42309V8.34622C16.1551 9.42955 15.2769 10.3078 14.1936 10.3078H7.61679C6.53345 10.3078 5.65527 9.42955 5.65527 8.34622V5.42309ZM6.65527 15.654C6.65527 15.1229 7.08577 14.6924 7.61679 14.6924H20.0396C20.5706 14.6924 21.0011 15.1229 21.0011 15.654V18.5771C21.0011 19.1082 20.5706 19.5387 20.0396 19.5387H7.61679C7.08577 19.5387 6.65527 19.1082 6.65527 18.5771V15.654ZM7.61679 13.6924C6.53345 13.6924 5.65527 14.5707 5.65527 15.654V18.5771C5.65527 19.6605 6.53345 20.5387 7.61679 20.5387H20.0396C21.123 20.5387 22.0011 19.6605 22.0011 18.5771V15.654C22.0011 14.5707 21.123 13.6924 20.0396 13.6924H7.61679Z"
          fill="#585858"
        />
      </svg>
    </>
  );
};
export const AlignItemCenter = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.13737 3C7.53329 3 7.09189 3.45644 7.09189 3.96156V6.88468C7.09189 7.3898 7.53329 7.84624 8.13737 7.84624H15.8648C16.4688 7.84624 16.9102 7.3898 16.9102 6.88468V3.96156C16.9102 3.45644 16.4688 3 15.8648 3H8.13737ZM6.09189 3.96156C6.09189 2.85229 7.03435 2 8.13737 2H15.8648C16.9678 2 17.9102 2.85229 17.9102 3.96156V6.88468C17.9102 7.99396 16.9678 8.84624 15.8648 8.84624H12.5005V15.1541H18.9548C20.0578 15.1541 21.0003 16.0063 21.0003 17.1156V20.0387C21.0003 21.148 20.0578 22.0003 18.9548 22.0003H5.04548C3.94246 22.0003 3 21.148 3 20.0387V17.1156C3 16.0063 3.94246 15.1541 5.04548 15.1541H11.5005V8.84624H8.13737C7.03435 8.84624 6.09189 7.99396 6.09189 6.88468V3.96156ZM11.9924 16.1541H5.04548C4.44141 16.1541 4 16.6105 4 17.1156V20.0387C4 20.5439 4.44141 21.0003 5.04548 21.0003H18.9548C19.5589 21.0003 20.0003 20.5439 20.0003 20.0387V17.1156C20.0003 16.6105 19.5589 16.1541 18.9548 16.1541H12.0086C12.0059 16.1541 12.0032 16.1541 12.0005 16.1541C11.9978 16.1541 11.9951 16.1541 11.9924 16.1541Z"
          fill="#585858"
        />
      </svg>
    </>
  );
};
export const AlignItemRight = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.5011 2C21.7773 2 22.0011 2.22386 22.0011 2.5V21.5004C22.0011 21.7765 21.7773 22.0004 21.5011 22.0004C21.225 22.0004 21.0011 21.7765 21.0011 21.5004V2.5C21.0011 2.22386 21.225 2 21.5011 2ZM16.3844 9.30774C16.9154 9.30774 17.3459 8.87725 17.3459 8.34618V5.42305C17.3459 4.89197 16.9154 4.46148 16.3844 4.46148H9.80756C9.27655 4.46148 8.84605 4.89197 8.84605 5.42305V8.34618C8.84605 8.87725 9.27655 9.30774 9.80756 9.30774H16.3844ZM18.3459 8.34618C18.3459 9.4295 17.4677 10.3077 16.3844 10.3077H9.80756C8.72423 10.3077 7.84605 9.4295 7.84605 8.34618V5.42305C7.84605 4.33972 8.72423 3.46148 9.80756 3.46148H16.3844C17.4677 3.46148 18.3459 4.33972 18.3459 5.42305V8.34618ZM17.3459 18.5772C17.3459 19.1083 16.9154 19.5388 16.3844 19.5388H3.96151C3.4305 19.5388 3 19.1083 3 18.5772V15.6541C3 15.123 3.4305 14.6925 3.96151 14.6925L16.3844 14.6925C16.9154 14.6925 17.3459 15.123 17.3459 15.6541V18.5772ZM16.3844 20.5388C17.4677 20.5388 18.3459 19.6605 18.3459 18.5772V15.6541C18.3459 14.5708 17.4677 13.6925 16.3844 13.6925L3.96151 13.6925C2.87818 13.6925 2 14.5708 2 15.6541V18.5772C2 19.6605 2.87818 20.5388 3.96151 20.5388H16.3844Z"
          fill="#585858"
        />
      </svg>
    </>
  );
};
export const AlignItemTop = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 2.5C2 2.22386 2.22386 2 2.5 2H21.5004C21.7765 2 22.0004 2.22386 22.0004 2.5C22.0004 2.77614 21.7765 3 21.5004 3H2.5C2.22386 3 2 2.77614 2 2.5ZM19.5391 7.61555C19.5391 7.0845 19.1086 6.65399 18.5775 6.65399H15.6544C15.1233 6.65399 14.6928 7.0845 14.6928 7.61555V14.1926C14.6928 14.7236 15.1233 15.1541 15.6544 15.1541H18.5775C19.1086 15.1541 19.5391 14.7236 19.5391 14.1926V7.61555ZM18.5775 5.65399C19.6608 5.65399 20.5391 6.53221 20.5391 7.61555V14.1926C20.5391 15.2759 19.6608 16.1541 18.5775 16.1541H15.6544C14.571 16.1541 13.6928 15.2759 13.6928 14.1926V7.61555C13.6928 6.53221 14.571 5.65399 15.6544 5.65399H18.5775ZM8.34605 6.65399C8.87711 6.65399 9.30762 7.0845 9.30762 7.61555V20.0388C9.30762 20.5699 8.87711 21.0004 8.34605 21.0004H5.42292C4.89186 21.0004 4.46136 20.5699 4.46136 20.0388V7.61555C4.46136 7.0845 4.89186 6.65399 5.42292 6.65399H8.34605ZM10.3076 7.61555C10.3076 6.53221 9.42939 5.65399 8.34605 5.65399H5.42292C4.33958 5.65399 3.46136 6.53221 3.46136 7.61555V20.0388C3.46136 21.1222 4.33958 22.0004 5.42292 22.0004H8.34605C9.42939 22.0004 10.3076 21.1222 10.3076 20.0388V7.61555Z"
          fill="#585858"
        />
      </svg>
    </>
  );
};
export const AlignItemMiddle = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.84641 5.04548C7.84641 4.44142 7.38996 4 6.88481 4H3.9616C3.45645 4 3 4.44142 3 5.04548V18.9548C3 19.5589 3.45645 20.0003 3.9616 20.0003H6.88481C7.38996 20.0003 7.84641 19.5589 7.84641 18.9548V12.0001V5.04548ZM8.84641 11.5001V5.04548C8.84641 3.94245 7.99409 3 6.88481 3H3.9616C2.85232 3 2 3.94245 2 5.04548V18.9548C2 20.0578 2.85232 21.0003 3.9616 21.0003H6.88481C7.99409 21.0003 8.84641 20.0578 8.84641 18.9548V12.5001H15.1533V17.4093C15.1533 18.5123 16.0056 19.4548 17.1149 19.4548H20.0381C21.1474 19.4548 21.9997 18.5123 21.9997 17.4093V8.13639C21.9997 7.03336 21.1474 6.09091 20.0381 6.09091H17.1149C16.0056 6.09091 15.1533 7.03336 15.1533 8.13639V11.5001H8.84641ZM16.1533 12.0335C16.154 12.0225 16.1544 12.0113 16.1544 12.0001C16.1544 11.9889 16.154 11.9778 16.1533 11.9668V8.13639C16.1533 7.53233 16.6098 7.09091 17.1149 7.09091H20.0381C20.5433 7.09091 20.9997 7.53233 20.9997 8.13639V17.4093C20.9997 18.0133 20.5433 18.4548 20.0381 18.4548H17.1149C16.6098 18.4548 16.1533 18.0133 16.1533 17.4093V12.0335Z"
          fill="#585858"
        />
      </svg>
    </>
  );
};
export const AlignItemBottom = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.42153 17.3464C4.89047 17.3464 4.45996 16.9159 4.45996 16.3848V3.96156C4.45996 3.43051 4.89047 3 5.42153 3H8.34466C8.87572 3 9.30622 3.43051 9.30622 3.96156V16.3848C9.30622 16.9159 8.87572 17.3464 8.34466 17.3464H5.42153ZM3.45996 16.3848C3.45996 17.4682 4.33819 18.3464 5.42153 18.3464H8.34466C9.428 18.3464 10.3062 17.4682 10.3062 16.3848V3.96156C10.3062 2.87822 9.428 2 8.34466 2H5.42153C4.33819 2 3.45996 2.87822 3.45996 3.96156V16.3848ZM14.6924 16.3848C14.6924 16.9159 15.1229 17.3464 15.6539 17.3464H18.5771C19.1081 17.3464 19.5386 16.9159 19.5386 16.3848V9.80781C19.5386 9.27675 19.1081 8.84624 18.5771 8.84624H15.6539C15.1229 8.84624 14.6924 9.27675 14.6924 9.80781V16.3848ZM15.6539 18.3464C14.5706 18.3464 13.6924 17.4682 13.6924 16.3848V9.80781C13.6924 8.72446 14.5706 7.84624 15.6539 7.84624H18.5771C19.6604 7.84624 20.5386 8.72446 20.5386 9.80781V16.3848C20.5386 17.4682 19.6604 18.3464 18.5771 18.3464H15.6539ZM2 21.5003C2 21.2241 2.22386 21.0003 2.5 21.0003H21.5004C21.7765 21.0003 22.0004 21.2241 22.0004 21.5003C22.0004 21.7764 21.7765 22.0003 21.5004 22.0003H2.5C2.22386 22.0003 2 21.7764 2 21.5003Z"
          fill="#585858"
        />
      </svg>
    </>
  );
};
export const DistributeHorizontally = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.95 20C10.6484 20 10.2 19.627 10.2 18.881V5.11905C10.2 4.37303 10.6484 4 10.95 4H13.45C13.7516 4 14.2 4.37303 14.2 5.11905V18.881C14.2 19.627 13.7516 20 13.45 20H10.95ZM9.2 18.881C9.2 19.9233 9.87092 21 10.95 21H13.45C14.5291 21 15.2 19.9233 15.2 18.881V12.474L16.1406 12.4739V16.2696C16.1406 17.0342 16.752 17.6692 17.5246 17.6692H19.2926C20.0651 17.6692 20.6765 17.0342 20.6765 16.2696V12.4737H21.5003C21.7764 12.4737 22.0003 12.2499 22.0003 11.9737C22.0003 11.6976 21.7764 11.4737 21.5003 11.4737H20.6765V8.62274C20.6765 7.85805 20.0651 7.22311 19.2926 7.22311H17.5246C16.752 7.22311 16.1406 7.85805 16.1406 8.62274V11.4739L15.2 11.474V5.11905C15.2 4.07672 14.5291 3 13.45 3H10.95C9.87092 3 9.2 4.07672 9.2 5.11905V11.474H8.303V8.62274C8.303 7.85805 7.69161 7.22311 6.91902 7.22311H5.15107C4.37848 7.22311 3.76709 7.85805 3.76709 8.62274V11.474L2.50009 11.4737C2.22395 11.4737 2.00005 11.6975 2 11.9736C1.99995 12.2498 2.22377 12.4737 2.49991 12.4737L3.76709 12.474V16.2696C3.76709 17.0342 4.37848 17.6692 5.15107 17.6692H6.91902C7.69161 17.6692 8.303 17.0342 8.303 16.2696V12.474H9.2V18.881ZM5.15107 16.6692C4.94724 16.6692 4.76709 16.4986 4.76709 16.2696V8.62274C4.76709 8.39372 4.94724 8.22311 5.15107 8.22311H6.91902C7.12285 8.22311 7.303 8.39372 7.303 8.62274V11.9493C7.3026 11.9575 7.3024 11.9657 7.3024 11.974C7.3024 11.9823 7.3026 11.9905 7.303 11.9987V16.2696C7.303 16.4986 7.12285 16.6692 6.91902 16.6692H5.15107ZM19.6747 11.9737C19.6747 11.9591 19.6753 11.9446 19.6765 11.9303V8.62274C19.6765 8.39372 19.4964 8.22311 19.2926 8.22311H17.5246C17.3208 8.22311 17.1406 8.39372 17.1406 8.62274V16.2696C17.1406 16.4986 17.3208 16.6692 17.5246 16.6692H19.2926C19.4964 16.6692 19.6765 16.4986 19.6765 16.2696V12.0172C19.6753 12.0029 19.6747 11.9884 19.6747 11.9737Z"
          fill="#585858"
        />
      </svg>
    </>
  );
};
export const DistributeVertically = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.881 14.8003C19.9233 14.8003 21 14.1294 21 13.0503V10.5503C21 9.4712 19.9233 8.80028 18.881 8.80028H12.474L12.4739 7.85965H16.2696C17.0342 7.85965 17.6692 7.24826 17.6692 6.47567V4.70772C17.6692 3.93513 17.0342 3.32374 16.2696 3.32374H12.4737V2.5C12.4737 2.22386 12.2499 2 11.9737 2C11.6976 2 11.4737 2.22386 11.4737 2.5V3.32374H8.62274C7.85805 3.32374 7.22311 3.93513 7.22311 4.70772V6.47567C7.22311 7.24826 7.85805 7.85965 8.62274 7.85965H11.4739L11.474 8.80028H5.11905C4.07672 8.80028 3 9.4712 3 10.5503V13.0503C3 14.1294 4.07672 14.8003 5.11905 14.8003H11.474V15.6973H8.62274C7.85805 15.6973 7.22311 16.3087 7.22311 17.0813V18.8492C7.22311 19.6218 7.85805 20.2332 8.62274 20.2332H11.474L11.4737 21.5002C11.4737 21.7763 11.6975 22.0002 11.9736 22.0003C12.2498 22.0003 12.4737 21.7765 12.4737 21.5004L12.474 20.2332H16.2696C17.0342 20.2332 17.6692 19.6218 17.6692 18.8492V17.0813C17.6692 16.3087 17.0342 15.6973 16.2696 15.6973H12.474V14.8003H18.881ZM20 13.0503C20 13.3519 19.627 13.8003 18.881 13.8003H5.11905C4.37303 13.8003 4 13.3519 4 13.0503V10.5503C4 10.2486 4.37303 9.80028 5.11905 9.80028H18.881C19.627 9.80028 20 10.2486 20 10.5503V13.0503ZM16.6692 18.8492C16.6692 19.053 16.4986 19.2332 16.2696 19.2332H8.62274C8.39372 19.2332 8.22311 19.053 8.22311 18.8492V17.0813C8.22311 16.8774 8.39372 16.6973 8.62274 16.6973H11.9493C11.9575 16.6977 11.9657 16.6979 11.974 16.6979C11.9823 16.6979 11.9905 16.6977 11.9987 16.6973H16.2696C16.4986 16.6973 16.6692 16.8774 16.6692 17.0813V18.8492ZM11.9737 4.3256C11.9591 4.3256 11.9446 4.32497 11.9303 4.32374H8.62274C8.39372 4.32374 8.22311 4.50389 8.22311 4.70772V6.47567C8.22311 6.6795 8.39372 6.85965 8.62274 6.85965H16.2696C16.4986 6.85965 16.6692 6.6795 16.6692 6.47567V4.70772C16.6692 4.50389 16.4986 4.32374 16.2696 4.32374H12.0172C12.0029 4.32497 11.9884 4.3256 11.9737 4.3256Z"
          fill="#585858"
        />
      </svg>
    </>
  );
};
export const RightArrow = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width={props.width ? props.width : "24"}
        height={props.height ? props.height : "24"}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 18L15 12L9 6"
          stroke={props.color ? props.color : "#585858"}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </svg>
    </>
  );
};
// export const LineStart = ({...props}) => {
//     return <>
//         <svg onClick={props.onClick} width="40" height="24" viewBox="0 0 40 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//             <path d="M4 12H22" stroke="#585858" strokeWidth="2" strokeLinecap="round"/>
//             <circle cx="4" cy="12" r="3" fill="#80D7FE"/>
//             <path d="M29.5 10.25L33 13.75L36.5 10.25" stroke="#585858" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//         </svg>
//     </>
// }

export const InsertTextInShape = ({ ...props }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 8.875V7H17V8.875M10.125 17H13.875M12 7V17"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect x="2" y="2" width="20" height="20" stroke="#585858" strokeLinejoin="round" />
        <circle cx="2" cy="2" r="2" fill="#585858" />
        <circle cx="2" cy="22" r="2" fill="#585858" />
        <circle cx="22" cy="22" r="2" fill="#585858" />
        <circle cx="22" cy="2" r="2" fill="#585858" />
      </svg>
    </>
  );
};

export const LineStart = ({ ...props }) => {
  return (
    <>
      <svg
        width="40"
        height="24"
        viewBox="0 0 40 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M4 12H22" stroke="#585858" strokeWidth="2" strokeLinecap="round" />
        <circle cx="4" cy="12" r="3" fill="#80D7FE" />
        <path
          d="M29.5 10.25L33 13.75L36.5 10.25"
          stroke="#585858"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const LineStart1 = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={() => props.onChange("")}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M4 12H22" stroke="#585858" strokeLinecap="round" />
        <circle cx="4" cy="12" r="3" fill="#80D7FE" />
      </svg>
    </>
  );
};

export const LineStart2 = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={() => props.onChange(`transparentArrowhead`)}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 12L22 12M2 12L7 8M2 12L7 16"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const LineStart3 = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={() => props.onChange(`arrowhead`)}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M7 9L2 12L7 15L7 12L7 9Z" fill="#585858" />
        <path
          d="M22 12L7 12M7 12L7 9L2 12L7 15L7 12Z"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const LineStart4 = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={() => props.onChange(`circle`)}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M4 12H22" stroke="#585858" strokeLinecap="round" />
        <circle cx="4" cy="12" r="2" fill="#585858" />
      </svg>
    </>
  );
};
export const LineStart5 = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={() => props.onChange(`square`)}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M4 12H22" stroke="#585858" strokeLinecap="round" />
        <rect x="2" y="10" width="4" height="4" fill="#585858" />
      </svg>
    </>
  );
};
export const LineStart6 = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={() => props.onChange(`transparentArrowhead`)}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 12L7 12M7 12L7 15L2 12L7 9L7 12Z"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const LineStart7 = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={() => props.onChange("url(#transparentCircle)")}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5.5 12H21" stroke="#585858" strokeLinecap="round" />
        <circle cx="4" cy="12" r="1.5" stroke="#585858" />
      </svg>
    </>
  );
};
export const LineStart8 = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={() => props.onChange("url(#transparentSquare)")}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5.5 12H21" stroke="#585858" strokeLinecap="round" />
        <rect x="2.5" y="10.5" width="3" height="3" stroke="#585858" />
      </svg>
    </>
  );
};

export const LineEnd = ({ ...props }) => {
  return (
    <>
      <svg
        width="40"
        height="24"
        viewBox="0 0 40 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M2 12H20" stroke="#585858" strokeWidth="2" strokeLinecap="round" />
        <circle cx="20" cy="12" r="3" fill="#80D7FE" />
        <path
          d="M29.5 10.25L33 13.75L36.5 10.25"
          stroke="#585858"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const LineEnd1 = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={() => props.onChange("")}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M2 12H20" stroke="#585858" strokeLinecap="round" />
        <circle cx="20" cy="12" r="3" fill="#80D7FE" />
      </svg>
    </>
  );
};

export const LineEnd2 = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={() => props.onChange("transparentArrowhead")}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 12H2M22 12L17 8M22 12L17 16"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const LineEnd3 = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={() => props.onChange("arrowhead")}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M17 9L22 12L17 15V12V9Z" fill="#585858" />
        <path
          d="M17 12H2M17 12V9L22 12L17 15V12Z"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const LineEnd4 = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={() => props.onChange("circle")}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M2 12L20 12" stroke="#585858" strokeLinecap="round" />
        <path
          d="M22 12C22 10.8954 21.1046 10 20 10C18.8954 10 18 10.8954 18 12C18 13.1046 18.8954 14 20 14C21.1046 14 22 13.1046 22 12Z"
          fill="#585858"
        />
      </svg>
    </>
  );
};
export const LineEnd5 = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={() => props.onChange("square")}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M2 12H20" stroke="#585858" strokeLinecap="round" />
        <rect x="18" y="10" width="4" height="4" fill="#585858" />
      </svg>
    </>
  );
};
export const LineEnd6 = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={() => props.onChange("transparentArrowhead")}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17 12H2M17 12V15L22 12L17 9V12Z"
          stroke="#585858"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const LineEnd7 = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={() => props.onChange("transparentCircle")}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M2 12H17.5" stroke="#585858" strokeLinecap="round" />
        <circle cx="19" cy="12" r="1.5" stroke="#585858" />
      </svg>
    </>
  );
};
export const LineEnd8 = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={() => props.onChange("transparentSquare")}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M3 12H18.5" stroke="#585858" strokeLinecap="round" />
        <rect x="18.5" y="10.5" width="3" height="3" stroke="#585858" />
      </svg>
    </>
  );
};

export const Search = ({ ...props }) => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.5 10.5L8.325 8.325M9.5 5.5C9.5 7.70914 7.70914 9.5 5.5 9.5C3.29086 9.5 1.5 7.70914 1.5 5.5C1.5 3.29086 3.29086 1.5 5.5 1.5C7.70914 1.5 9.5 3.29086 9.5 5.5Z"
        stroke="#D4D5DE"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TableBorder1 = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
        stroke="#585858"
        strokeWidth="2"
      />
      <path d="M12 6V18" stroke="#585858" strokeWidth="2" strokeLinecap="square" />
      <path d="M18 12L6 12" stroke="#585858" strokeWidth="2" strokeLinecap="square" />
    </svg>
  );
};
export const TableBorder2 = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 3V21M3 12H21"
        stroke="#585858"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M3 9V5C3 3.89543 3.89543 3 5 3H9"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M15 3L19 3C20.1046 3 21 3.89543 21 5L21 9"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M21 15L21 19C21 20.1046 20.1046 21 19 21L15 21"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M9 21L5 21C3.89543 21 3 20.1046 3 19L3 15"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TableBorder3 = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
        stroke="#585858"
        strokeWidth="2"
      />
      <path d="M12 6V18" stroke="#D4D5DE" strokeWidth="2" strokeLinecap="square" />
      <path d="M18 12L6 12" stroke="#D4D5DE" strokeWidth="2" strokeLinecap="square" />
    </svg>
  );
};
export const TableBorder4 = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 3V3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21V21"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 21V21C20.1046 21 21 20.1046 21 19L21 5C21 3.89543 20.1046 3 19 3V3"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 3L17 3"
        stroke="#585858"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M6 12L18 12"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M12 6L12 18"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M6 21L18 21"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TableBorder5 = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 11V5C3 3.89543 3.89543 3 5 3H15"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M6 12L18 12"
        stroke="#585858"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M12 6L12 9"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M12 15L12 18"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M15 3L19 3C20.1046 3 21 3.89543 21 5L21 11"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M21 12L21 19C21 20.1046 20.1046 21 19 21L15 21"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M13 21L5 21C3.89543 21 3 20.1046 3 19L3 12"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TableBorder6 = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 21V21C20.1046 21 21 20.1046 21 19L21 5C21 3.89543 20.1046 3 19 3V3"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 3V3C3.89543 3 3 3.89543 3 5L3 19C3 20.1046 3.89543 21 5 21V21"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 21L7 21"
        stroke="#585858"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M18 12L6 12"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M12 18L12 6"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M18 3L6 3"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TableBorder7 = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.99976 19V19C2.99976 20.1046 3.89519 21 4.99976 21L18.9998 21C20.1043 21 20.9998 20.1046 20.9998 19V19"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9998 5V5C20.9998 3.89543 20.1043 3 18.9998 3L4.99976 3C3.89519 3 2.99976 3.89543 2.99976 5V5"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.99976 17L2.99976 7"
        stroke="#585858"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M11.9998 18L11.9998 6"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M5.99976 12L17.9998 12"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M20.9998 18L20.9998 6"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TableBorder8 = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 21L5 21C3.89543 21 3 20.1046 3 19L3 9"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M12 18L12 6"
        stroke="#585858"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M6 12H9"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M15 12H18"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M3 9V5C3 3.89543 3.89543 3 5 3H11"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M12 3L19 3C20.1046 3 21 3.89543 21 5L21 9"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M21 11L21 19C21 20.1046 20.1046 21 19 21L12 21"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TableBorder9 = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 5V5C21 3.89543 20.1046 3 19 3L5 3C3.89543 3 3 3.89543 3 5V5"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 19V19C3 20.1046 3.89543 21 5 21L19 21C20.1046 21 21 20.1046 21 19V19"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 7L21 17"
        stroke="#585858"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M12 6L12 18"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M18 12L6 12"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M3 6L3 18"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TableBorder10 = ({ ...props }) => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 3.5H5C3.89543 3.5 3 4.39543 3 5.5V19.5C3 20.6046 3.89543 21.5 5 21.5H19C20.1046 21.5 21 20.6046 21 19.5V5.5C21 4.39543 20.1046 3.5 19 3.5Z"
        stroke="#D4D5DE"
        strokeWidth="2"
      />
      <path d="M12 6.5V18.5" stroke="#D4D5DE" strokeWidth="2" strokeLinecap="square" />
      <path d="M18 12.5L6 12.5" stroke="#D4D5DE" strokeWidth="2" strokeLinecap="square" />
    </svg>
  );
};
export const TableBorder11 = ({ ...props }) => {
  return (
    <svg
      style={{ transform: "rotate(90deg)" }}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 21.5V21.5C20.1046 21.5 21 20.6046 21 19.5L21 5.5C21 4.39543 20.1046 3.5 19 3.5V3.5"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 3.5V3.5C3.89543 3.5 3 4.39543 3 5.5L3 19.5C3 20.6046 3.89543 21.5 5 21.5V21.5"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 21.5L7 21.5"
        stroke="#585858"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M18 12.5L6 12.5"
        stroke="#585858"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M12 9.5L12 6.5"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M12 18.5L12 15.5"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M17 3.5L7 3.5"
        stroke="#585858"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TableBorder12 = ({ ...props }) => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 21.5V21.5C20.1046 21.5 21 20.6046 21 19.5L21 5.5C21 4.39543 20.1046 3.5 19 3.5V3.5"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 3.5V3.5C3.89543 3.5 3 4.39543 3 5.5L3 19.5C3 20.6046 3.89543 21.5 5 21.5V21.5"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 21.5L7 21.5"
        stroke="#585858"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M18 12.5L6 12.5"
        stroke="#585858"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M12 9.5L12 6.5"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M12 18.5L12 15.5"
        stroke="#D4D5DE"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M17 3.5L7 3.5"
        stroke="#585858"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ArrowDownSubMenu = ({ ...props }) => {
  return (
    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.5 1.25L5 4.75L8.5 1.25"
        className="undoIcon"
        stroke={props.active ? "#01AFFD" : "#585858"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TemplateSelectedCheckbox = ({ ...props }) => {
  return (
    <svg
      className={props.className ? props.className : ""}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_280_91972)">
        <circle cx="11" cy="11" r="7" fill="#01AFFD" />
      </g>
      <path d="M8 11L9.97661 13L14 9" stroke="white" strokeWidth="1.77778" strokeLinecap="square" />
      <defs>
        <filter
          id="filter0_d_280_91972"
          x="0"
          y="0"
          width="22"
          height="22"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_280_91972" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_280_91972"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const ResetTemplate = ({ ...props }) => {
  return (
    <svg
      onClick={props.onClick}
      className={props.className ? props.className : ""}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="7" cy="7" r="6.5" fill="#006FC9" stroke="#006FC9" />
      <path
        d="M3.76212 9.34904L3.00007 10.1111V7.88897H5.22218L4.40077 8.71039C4.95717 9.55429 5.91346 10.1112 7.00001 10.1112C8.71813 10.1112 10.1111 8.71826 10.1111 7.00006H11C11 9.20917 9.20917 11 7.00006 11C5.66866 11 4.48924 10.3496 3.7621 9.34902L3.76212 9.34904ZM10.2379 4.65096L10.9999 3.88892V6.11103H8.77782L9.59923 5.28961C9.04283 4.44571 8.08654 3.88884 6.99999 3.88884C5.28187 3.88884 3.88889 5.28174 3.88889 6.99994H3C3 4.79083 4.79083 3 6.99994 3C8.33134 3 9.51076 3.65043 10.2379 4.65098L10.2379 4.65096Z"
        fill="white"
      />
    </svg>
  );
};

export const BluePlus = ({ ...props }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 1V15M1 8H15"
        stroke="#01AFFD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const LeftArrow = ({ ...props }) => {
  return (
    <svg
      width={props.width ? props.width : "18"}
      height={props.height ? props.height : "18"}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.25 4.5L6.75 9L11.25 13.5"
        stroke={props.color ? props.color : "#D4D5DE"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
